var Vn = Object.defineProperty;
var An = (a, o, e) => o in a ? Vn(a, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[o] = e;
var Me = (a, o, e) => (An(a, typeof o != "symbol" ? o + "" : o, e), e);
import { computed as _, toValue as Se, unref as n, ref as z, shallowRef as bt, watch as fe, getCurrentScope as Rl, onScopeDispose as Dl, shallowReadonly as Tt, isRef as On, toRef as k, readonly as Ye, customRef as In, onMounted as Ue, nextTick as Ne, getCurrentInstance as Bt, reactive as cl, defineComponent as L, watchEffect as Pt, mergeModels as ge, useModel as _e, onBeforeUnmount as Ra, openBlock as m, createElementBlock as A, Fragment as ve, createElementVNode as Q, renderSlot as $, createBlock as P, Teleport as _t, mergeProps as K, normalizeClass as R, normalizeStyle as Le, createTextVNode as ue, toDisplayString as J, createCommentVNode as ee, render as jl, h as Ie, inject as Ve, provide as Xe, onActivated as Pn, Transition as Nn, withCtx as I, useAttrs as Dt, resolveDynamicComponent as ce, createVNode as ye, useSlots as He, normalizeProps as Be, guardReactiveProps as Ce, withDirectives as ct, vShow as jt, renderList as ke, TransitionGroup as Gl, withModifiers as vt, vModelCheckbox as En, vModelRadio as Fn, vModelSelect as Ln, createSlots as Da, onUnmounted as zn, withKeys as Ut } from "vue";
const Gt = (a) => _(() => {
  const o = Se(a);
  return o ? `justify-content-${o}` : "";
}), ba = (a, o) => _(() => {
  const e = Se(a), l = Se(o);
  return e === !0 ? "true" : typeof e == "string" ? e : l === !1 ? "true" : e === !1 ? "false" : void 0;
});
class rt {
  constructor(o, e = {}) {
    Me(this, "cancelable", !0);
    Me(this, "componentId", null);
    Me(this, "_defaultPrevented", !1);
    Me(this, "eventType", "");
    Me(this, "nativeEvent", null);
    Me(this, "_preventDefault");
    Me(this, "relatedTarget", null);
    Me(this, "target", null);
    if (!o)
      throw new TypeError(
        `Failed to construct '${this.constructor.name}'. 1 argument required, ${arguments.length} given.`
      );
    Object.assign(this, rt.Defaults, e, { eventType: o }), this._preventDefault = function() {
      this.cancelable && (this.defaultPrevented = !0);
    };
  }
  // Readable by everyone,
  // But only overwritten by inherrited constructors
  get defaultPrevented() {
    return this._defaultPrevented;
  }
  set defaultPrevented(o) {
    this._defaultPrevented = o;
  }
  // I think this is right
  // We want to be able to have it callable to everyone,
  // But only overwritten by inherrited constructors
  get preventDefault() {
    return this._preventDefault;
  }
  // This may not be correct, because it doesn't get correct type inferences in children
  // Ex overwrite this.preventDefault = () => true is valid. Could be a TS issue
  set preventDefault(o) {
    this._preventDefault = o;
  }
  static get Defaults() {
    return {
      cancelable: !0,
      componentId: null,
      eventType: "",
      nativeEvent: null,
      relatedTarget: null,
      target: null
    };
  }
}
class wt extends rt {
  constructor(e, l = {}) {
    super(e, l);
    Me(this, "trigger", null);
    Object.assign(this, rt.Defaults, l, { eventType: e });
  }
  static get Defaults() {
    return {
      ...super.Defaults,
      trigger: null
    };
  }
}
class Wl extends rt {
  constructor(e, l) {
    super(e, l);
    Me(this, "from");
    Me(this, "to");
    Me(this, "direction");
    Object.assign(this, rt.Defaults, l, { eventType: e });
    const { from: t, direction: s, to: r } = l;
    this.from = t, this.to = r, this.direction = s;
  }
  static get Defaults() {
    return {
      ...super.Defaults
    };
  }
}
const Hn = (a, o = {}) => {
  const e = (t = []) => {
    const { activeElement: s } = document;
    return s && !t.some((r) => r === s) ? s : null;
  }, l = (t) => t === e();
  try {
    a.focus(o);
  } catch (t) {
    console.error(t);
  }
  return l(a);
}, Ae = (a) => ((a == null ? void 0 : a()) ?? []).length === 0, Mn = (a) => {
  if (a.getAttribute("display") === "none")
    return !1;
  const o = a.getBoundingClientRect();
  return !!(o && o.height > 0 && o.width > 0);
}, xa = (a) => {
  const o = window.getComputedStyle(a), e = o.transitionDelay.split(",")[0] || "", l = o.transitionDuration.split(",")[0] || "", t = Number(e.slice(0, -1)) * 1e3, s = Number(l.slice(0, -1)) * 1e3;
  return t + s;
}, ja = typeof window < "u" && typeof document < "u" && typeof navigator < "u", Rn = (a) => (() => {
  let e = !1;
  if (ja)
    try {
      const l = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          e = !0;
        }
      };
      WINDOW.addEventListener("test", l, l), WINDOW.removeEventListener("test", l, l);
    } catch {
      e = !1;
    }
  return e;
})() ? typeof a == "object" ? a : { capture: !!a || !1 } : typeof a == "object" ? a.capture : a, Dn = (a, o, e, l) => {
  a && a.addEventListener && a.addEventListener(o, e, Rn(l));
}, jn = (a, o, e, l) => {
  a && a.removeEventListener && a.removeEventListener(o, e, l);
}, fl = (a, o) => {
  (a ? Dn : jn)(...o);
}, Gn = ["TD", "TH", "TR"], Wn = [
  "a",
  "a *",
  // Include content inside links
  "button",
  "button *",
  // Include content inside buttons
  "input:not(.disabled):not([disabled])",
  "select:not(.disabled):not([disabled])",
  "textarea:not(.disabled):not([disabled])",
  '[role="link"]',
  '[role="link"] *',
  '[role="button"]',
  '[role="button"] *',
  "[tabindex]:not(.disabled):not([disabled])"
].join(","), Xt = (a) => {
  if (!a || !a.target)
    return !1;
  const o = a.target;
  if ("disabled" in o && o.disabled || Gn.indexOf(o.tagName) !== -1)
    return !1;
  if (o.closest(".dropdown-menu"))
    return !0;
  const e = o.tagName === "LABEL" ? o : o.closest("label");
  if (e) {
    const l = e.getAttribute("for"), t = l ? document.getElementById(l) : e.querySelector("input, select, textarea");
    if (t && !t.disabled)
      return !0;
  }
  return o.matches(Wn);
}, ql = ["top", "right", "bottom", "left"], pl = ["start", "end"], vl = /* @__PURE__ */ ql.reduce((a, o) => a.concat(o, o + "-" + pl[0], o + "-" + pl[1]), []), je = Math.min, Pe = Math.max, na = Math.round, Kt = Math.floor, yt = (a) => ({
  x: a,
  y: a
}), qn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Un = {
  start: "end",
  end: "start"
};
function Sa(a, o, e) {
  return Pe(a, je(o, e));
}
function ft(a, o) {
  return typeof a == "function" ? a(o) : a;
}
function Je(a) {
  return a.split("-")[0];
}
function lt(a) {
  return a.split("-")[1];
}
function Ul(a) {
  return a === "x" ? "y" : "x";
}
function Ga(a) {
  return a === "y" ? "height" : "width";
}
function Nt(a) {
  return ["top", "bottom"].includes(Je(a)) ? "y" : "x";
}
function Wa(a) {
  return Ul(Nt(a));
}
function Xl(a, o, e) {
  e === void 0 && (e = !1);
  const l = lt(a), t = Wa(a), s = Ga(t);
  let r = t === "x" ? l === (e ? "end" : "start") ? "right" : "left" : l === "start" ? "bottom" : "top";
  return o.reference[s] > o.floating[s] && (r = ra(r)), [r, ra(r)];
}
function Xn(a) {
  const o = ra(a);
  return [sa(a), o, sa(o)];
}
function sa(a) {
  return a.replace(/start|end/g, (o) => Un[o]);
}
function Kn(a, o, e) {
  const l = ["left", "right"], t = ["right", "left"], s = ["top", "bottom"], r = ["bottom", "top"];
  switch (a) {
    case "top":
    case "bottom":
      return e ? o ? t : l : o ? l : t;
    case "left":
    case "right":
      return o ? s : r;
    default:
      return [];
  }
}
function Yn(a, o, e, l) {
  const t = lt(a);
  let s = Kn(Je(a), e === "start", l);
  return t && (s = s.map((r) => r + "-" + t), o && (s = s.concat(s.map(sa)))), s;
}
function ra(a) {
  return a.replace(/left|right|bottom|top/g, (o) => qn[o]);
}
function Zn(a) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...a
  };
}
function qa(a) {
  return typeof a != "number" ? Zn(a) : {
    top: a,
    right: a,
    bottom: a,
    left: a
  };
}
function At(a) {
  return {
    ...a,
    top: a.y,
    left: a.x,
    right: a.x + a.width,
    bottom: a.y + a.height
  };
}
function ml(a, o, e) {
  let {
    reference: l,
    floating: t
  } = a;
  const s = Nt(o), r = Wa(o), u = Ga(r), i = Je(o), d = s === "y", f = l.x + l.width / 2 - t.width / 2, c = l.y + l.height / 2 - t.height / 2, y = l[u] / 2 - t[u] / 2;
  let p;
  switch (i) {
    case "top":
      p = {
        x: f,
        y: l.y - t.height
      };
      break;
    case "bottom":
      p = {
        x: f,
        y: l.y + l.height
      };
      break;
    case "right":
      p = {
        x: l.x + l.width,
        y: c
      };
      break;
    case "left":
      p = {
        x: l.x - t.width,
        y: c
      };
      break;
    default:
      p = {
        x: l.x,
        y: l.y
      };
  }
  switch (lt(o)) {
    case "start":
      p[r] -= y * (e && d ? -1 : 1);
      break;
    case "end":
      p[r] += y * (e && d ? -1 : 1);
      break;
  }
  return p;
}
const Jn = async (a, o, e) => {
  const {
    placement: l = "bottom",
    strategy: t = "absolute",
    middleware: s = [],
    platform: r
  } = e, u = s.filter(Boolean), i = await (r.isRTL == null ? void 0 : r.isRTL(o));
  let d = await r.getElementRects({
    reference: a,
    floating: o,
    strategy: t
  }), {
    x: f,
    y: c
  } = ml(d, l, i), y = l, p = {}, b = 0;
  for (let h = 0; h < u.length; h++) {
    const {
      name: w,
      fn: v
    } = u[h], {
      x: B,
      y: g,
      data: S,
      reset: C
    } = await v({
      x: f,
      y: c,
      initialPlacement: l,
      placement: y,
      strategy: t,
      middlewareData: p,
      rects: d,
      platform: r,
      elements: {
        reference: a,
        floating: o
      }
    });
    f = B ?? f, c = g ?? c, p = {
      ...p,
      [w]: {
        ...p[w],
        ...S
      }
    }, C && b <= 50 && (b++, typeof C == "object" && (C.placement && (y = C.placement), C.rects && (d = C.rects === !0 ? await r.getElementRects({
      reference: a,
      floating: o,
      strategy: t
    }) : C.rects), {
      x: f,
      y: c
    } = ml(d, y, i)), h = -1);
  }
  return {
    x: f,
    y: c,
    placement: y,
    strategy: t,
    middlewareData: p
  };
};
async function Ot(a, o) {
  var e;
  o === void 0 && (o = {});
  const {
    x: l,
    y: t,
    platform: s,
    rects: r,
    elements: u,
    strategy: i
  } = a, {
    boundary: d = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: c = "floating",
    altBoundary: y = !1,
    padding: p = 0
  } = ft(o, a), b = qa(p), w = u[y ? c === "floating" ? "reference" : "floating" : c], v = At(await s.getClippingRect({
    element: (e = await (s.isElement == null ? void 0 : s.isElement(w))) == null || e ? w : w.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(u.floating)),
    boundary: d,
    rootBoundary: f,
    strategy: i
  })), B = c === "floating" ? {
    x: l,
    y: t,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, g = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u.floating)), S = await (s.isElement == null ? void 0 : s.isElement(g)) ? await (s.getScale == null ? void 0 : s.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = At(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: B,
    offsetParent: g,
    strategy: i
  }) : B);
  return {
    top: (v.top - C.top + b.top) / S.y,
    bottom: (C.bottom - v.bottom + b.bottom) / S.y,
    left: (v.left - C.left + b.left) / S.x,
    right: (C.right - v.right + b.right) / S.x
  };
}
const Qn = (a) => ({
  name: "arrow",
  options: a,
  async fn(o) {
    const {
      x: e,
      y: l,
      placement: t,
      rects: s,
      platform: r,
      elements: u,
      middlewareData: i
    } = o, {
      element: d,
      padding: f = 0
    } = ft(a, o) || {};
    if (d == null)
      return {};
    const c = qa(f), y = {
      x: e,
      y: l
    }, p = Wa(t), b = Ga(p), h = await r.getDimensions(d), w = p === "y", v = w ? "top" : "left", B = w ? "bottom" : "right", g = w ? "clientHeight" : "clientWidth", S = s.reference[b] + s.reference[p] - y[p] - s.floating[b], C = y[p] - s.reference[p], x = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(d));
    let V = x ? x[g] : 0;
    (!V || !await (r.isElement == null ? void 0 : r.isElement(x))) && (V = u.floating[g] || s.floating[b]);
    const q = S / 2 - C / 2, G = V / 2 - h[b] / 2 - 1, O = je(c[v], G), Z = je(c[B], G), ae = O, ie = V - h[b] - Z, X = V / 2 - h[b] / 2 + q, j = Sa(ae, X, ie), T = !i.arrow && lt(t) != null && X !== j && s.reference[b] / 2 - (X < ae ? O : Z) - h[b] / 2 < 0, N = T ? X < ae ? X - ae : X - ie : 0;
    return {
      [p]: y[p] + N,
      data: {
        [p]: j,
        centerOffset: X - j - N,
        ...T && {
          alignmentOffset: N
        }
      },
      reset: T
    };
  }
});
function es(a, o, e) {
  return (a ? [...e.filter((t) => lt(t) === a), ...e.filter((t) => lt(t) !== a)] : e.filter((t) => Je(t) === t)).filter((t) => a ? lt(t) === a || (o ? sa(t) !== t : !1) : !0);
}
const ts = function(a) {
  return a === void 0 && (a = {}), {
    name: "autoPlacement",
    options: a,
    async fn(o) {
      var e, l, t;
      const {
        rects: s,
        middlewareData: r,
        placement: u,
        platform: i,
        elements: d
      } = o, {
        crossAxis: f = !1,
        alignment: c,
        allowedPlacements: y = vl,
        autoAlignment: p = !0,
        ...b
      } = ft(a, o), h = c !== void 0 || y === vl ? es(c || null, p, y) : y, w = await Ot(o, b), v = ((e = r.autoPlacement) == null ? void 0 : e.index) || 0, B = h[v];
      if (B == null)
        return {};
      const g = Xl(B, s, await (i.isRTL == null ? void 0 : i.isRTL(d.floating)));
      if (u !== B)
        return {
          reset: {
            placement: h[0]
          }
        };
      const S = [w[Je(B)], w[g[0]], w[g[1]]], C = [...((l = r.autoPlacement) == null ? void 0 : l.overflows) || [], {
        placement: B,
        overflows: S
      }], x = h[v + 1];
      if (x)
        return {
          data: {
            index: v + 1,
            overflows: C
          },
          reset: {
            placement: x
          }
        };
      const V = C.map((O) => {
        const Z = lt(O.placement);
        return [O.placement, Z && f ? (
          // Check along the mainAxis and main crossAxis side.
          O.overflows.slice(0, 2).reduce((ae, ie) => ae + ie, 0)
        ) : (
          // Check only the mainAxis.
          O.overflows[0]
        ), O.overflows];
      }).sort((O, Z) => O[1] - Z[1]), G = ((t = V.filter((O) => O[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        lt(O[0]) ? 2 : 3
      ).every((Z) => Z <= 0))[0]) == null ? void 0 : t[0]) || V[0][0];
      return G !== u ? {
        data: {
          index: v + 1,
          overflows: C
        },
        reset: {
          placement: G
        }
      } : {};
    }
  };
}, as = function(a) {
  return a === void 0 && (a = {}), {
    name: "flip",
    options: a,
    async fn(o) {
      var e, l;
      const {
        placement: t,
        middlewareData: s,
        rects: r,
        initialPlacement: u,
        platform: i,
        elements: d
      } = o, {
        mainAxis: f = !0,
        crossAxis: c = !0,
        fallbackPlacements: y,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: h = !0,
        ...w
      } = ft(a, o);
      if ((e = s.arrow) != null && e.alignmentOffset)
        return {};
      const v = Je(t), B = Je(u) === u, g = await (i.isRTL == null ? void 0 : i.isRTL(d.floating)), S = y || (B || !h ? [ra(u)] : Xn(u));
      !y && b !== "none" && S.push(...Yn(u, h, b, g));
      const C = [u, ...S], x = await Ot(o, w), V = [];
      let q = ((l = s.flip) == null ? void 0 : l.overflows) || [];
      if (f && V.push(x[v]), c) {
        const ae = Xl(t, r, g);
        V.push(x[ae[0]], x[ae[1]]);
      }
      if (q = [...q, {
        placement: t,
        overflows: V
      }], !V.every((ae) => ae <= 0)) {
        var G, O;
        const ae = (((G = s.flip) == null ? void 0 : G.index) || 0) + 1, ie = C[ae];
        if (ie)
          return {
            data: {
              index: ae,
              overflows: q
            },
            reset: {
              placement: ie
            }
          };
        let X = (O = q.filter((j) => j.overflows[0] <= 0).sort((j, T) => j.overflows[1] - T.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!X)
          switch (p) {
            case "bestFit": {
              var Z;
              const j = (Z = q.map((T) => [T.placement, T.overflows.filter((N) => N > 0).reduce((N, F) => N + F, 0)]).sort((T, N) => T[1] - N[1])[0]) == null ? void 0 : Z[0];
              j && (X = j);
              break;
            }
            case "initialPlacement":
              X = u;
              break;
          }
        if (t !== X)
          return {
            reset: {
              placement: X
            }
          };
      }
      return {};
    }
  };
};
function bl(a, o) {
  return {
    top: a.top - o.height,
    right: a.right - o.width,
    bottom: a.bottom - o.height,
    left: a.left - o.width
  };
}
function yl(a) {
  return ql.some((o) => a[o] >= 0);
}
const ls = function(a) {
  return a === void 0 && (a = {}), {
    name: "hide",
    options: a,
    async fn(o) {
      const {
        rects: e
      } = o, {
        strategy: l = "referenceHidden",
        ...t
      } = ft(a, o);
      switch (l) {
        case "referenceHidden": {
          const s = await Ot(o, {
            ...t,
            elementContext: "reference"
          }), r = bl(s, e.reference);
          return {
            data: {
              referenceHiddenOffsets: r,
              referenceHidden: yl(r)
            }
          };
        }
        case "escaped": {
          const s = await Ot(o, {
            ...t,
            altBoundary: !0
          }), r = bl(s, e.floating);
          return {
            data: {
              escapedOffsets: r,
              escaped: yl(r)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function Kl(a) {
  const o = je(...a.map((s) => s.left)), e = je(...a.map((s) => s.top)), l = Pe(...a.map((s) => s.right)), t = Pe(...a.map((s) => s.bottom));
  return {
    x: o,
    y: e,
    width: l - o,
    height: t - e
  };
}
function os(a) {
  const o = a.slice().sort((t, s) => t.y - s.y), e = [];
  let l = null;
  for (let t = 0; t < o.length; t++) {
    const s = o[t];
    !l || s.y - l.y > l.height / 2 ? e.push([s]) : e[e.length - 1].push(s), l = s;
  }
  return e.map((t) => At(Kl(t)));
}
const ns = function(a) {
  return a === void 0 && (a = {}), {
    name: "inline",
    options: a,
    async fn(o) {
      const {
        placement: e,
        elements: l,
        rects: t,
        platform: s,
        strategy: r
      } = o, {
        padding: u = 2,
        x: i,
        y: d
      } = ft(a, o), f = Array.from(await (s.getClientRects == null ? void 0 : s.getClientRects(l.reference)) || []), c = os(f), y = At(Kl(f)), p = qa(u);
      function b() {
        if (c.length === 2 && c[0].left > c[1].right && i != null && d != null)
          return c.find((w) => i > w.left - p.left && i < w.right + p.right && d > w.top - p.top && d < w.bottom + p.bottom) || y;
        if (c.length >= 2) {
          if (Nt(e) === "y") {
            const O = c[0], Z = c[c.length - 1], ae = Je(e) === "top", ie = O.top, X = Z.bottom, j = ae ? O.left : Z.left, T = ae ? O.right : Z.right, N = T - j, F = X - ie;
            return {
              top: ie,
              bottom: X,
              left: j,
              right: T,
              width: N,
              height: F,
              x: j,
              y: ie
            };
          }
          const w = Je(e) === "left", v = Pe(...c.map((O) => O.right)), B = je(...c.map((O) => O.left)), g = c.filter((O) => w ? O.left === B : O.right === v), S = g[0].top, C = g[g.length - 1].bottom, x = B, V = v, q = V - x, G = C - S;
          return {
            top: S,
            bottom: C,
            left: x,
            right: V,
            width: q,
            height: G,
            x,
            y: S
          };
        }
        return y;
      }
      const h = await s.getElementRects({
        reference: {
          getBoundingClientRect: b
        },
        floating: l.floating,
        strategy: r
      });
      return t.reference.x !== h.reference.x || t.reference.y !== h.reference.y || t.reference.width !== h.reference.width || t.reference.height !== h.reference.height ? {
        reset: {
          rects: h
        }
      } : {};
    }
  };
};
async function ss(a, o) {
  const {
    placement: e,
    platform: l,
    elements: t
  } = a, s = await (l.isRTL == null ? void 0 : l.isRTL(t.floating)), r = Je(e), u = lt(e), i = Nt(e) === "y", d = ["left", "top"].includes(r) ? -1 : 1, f = s && i ? -1 : 1, c = ft(o, a);
  let {
    mainAxis: y,
    crossAxis: p,
    alignmentAxis: b
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...c
  };
  return u && typeof b == "number" && (p = u === "end" ? b * -1 : b), i ? {
    x: p * f,
    y: y * d
  } : {
    x: y * d,
    y: p * f
  };
}
const Yl = function(a) {
  return a === void 0 && (a = 0), {
    name: "offset",
    options: a,
    async fn(o) {
      var e, l;
      const {
        x: t,
        y: s,
        placement: r,
        middlewareData: u
      } = o, i = await ss(o, a);
      return r === ((e = u.offset) == null ? void 0 : e.placement) && (l = u.arrow) != null && l.alignmentOffset ? {} : {
        x: t + i.x,
        y: s + i.y,
        data: {
          ...i,
          placement: r
        }
      };
    }
  };
}, rs = function(a) {
  return a === void 0 && (a = {}), {
    name: "shift",
    options: a,
    async fn(o) {
      const {
        x: e,
        y: l,
        placement: t
      } = o, {
        mainAxis: s = !0,
        crossAxis: r = !1,
        limiter: u = {
          fn: (w) => {
            let {
              x: v,
              y: B
            } = w;
            return {
              x: v,
              y: B
            };
          }
        },
        ...i
      } = ft(a, o), d = {
        x: e,
        y: l
      }, f = await Ot(o, i), c = Nt(Je(t)), y = Ul(c);
      let p = d[y], b = d[c];
      if (s) {
        const w = y === "y" ? "top" : "left", v = y === "y" ? "bottom" : "right", B = p + f[w], g = p - f[v];
        p = Sa(B, p, g);
      }
      if (r) {
        const w = c === "y" ? "top" : "left", v = c === "y" ? "bottom" : "right", B = b + f[w], g = b - f[v];
        b = Sa(B, b, g);
      }
      const h = u.fn({
        ...o,
        [y]: p,
        [c]: b
      });
      return {
        ...h,
        data: {
          x: h.x - e,
          y: h.y - l
        }
      };
    }
  };
}, is = function(a) {
  return a === void 0 && (a = {}), {
    name: "size",
    options: a,
    async fn(o) {
      const {
        placement: e,
        rects: l,
        platform: t,
        elements: s
      } = o, {
        apply: r = () => {
        },
        ...u
      } = ft(a, o), i = await Ot(o, u), d = Je(e), f = lt(e), c = Nt(e) === "y", {
        width: y,
        height: p
      } = l.floating;
      let b, h;
      d === "top" || d === "bottom" ? (b = d, h = f === (await (t.isRTL == null ? void 0 : t.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (h = d, b = f === "end" ? "top" : "bottom");
      const w = p - i.top - i.bottom, v = y - i.left - i.right, B = je(p - i[b], w), g = je(y - i[h], v), S = !o.middlewareData.shift;
      let C = B, x = g;
      if (c ? x = f || S ? je(g, v) : v : C = f || S ? je(B, w) : w, S && !f) {
        const q = Pe(i.left, 0), G = Pe(i.right, 0), O = Pe(i.top, 0), Z = Pe(i.bottom, 0);
        c ? x = y - 2 * (q !== 0 || G !== 0 ? q + G : Pe(i.left, i.right)) : C = p - 2 * (O !== 0 || Z !== 0 ? O + Z : Pe(i.top, i.bottom));
      }
      await r({
        ...o,
        availableWidth: x,
        availableHeight: C
      });
      const V = await t.getDimensions(s.floating);
      return y !== V.width || p !== V.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function it(a) {
  return Ua(a) ? (a.nodeName || "").toLowerCase() : "#document";
}
function We(a) {
  var o;
  return (a == null || (o = a.ownerDocument) == null ? void 0 : o.defaultView) || window;
}
function pt(a) {
  var o;
  return (o = (Ua(a) ? a.ownerDocument : a.document) || window.document) == null ? void 0 : o.documentElement;
}
function Ua(a) {
  return a instanceof Node || a instanceof We(a).Node;
}
function ut(a) {
  return a instanceof Element || a instanceof We(a).Element;
}
function nt(a) {
  return a instanceof HTMLElement || a instanceof We(a).HTMLElement;
}
function gl(a) {
  return typeof ShadowRoot > "u" ? !1 : a instanceof ShadowRoot || a instanceof We(a).ShadowRoot;
}
function Wt(a) {
  const {
    overflow: o,
    overflowX: e,
    overflowY: l,
    display: t
  } = Qe(a);
  return /auto|scroll|overlay|hidden|clip/.test(o + l + e) && !["inline", "contents"].includes(t);
}
function us(a) {
  return ["table", "td", "th"].includes(it(a));
}
function Xa(a) {
  const o = Ka(), e = Qe(a);
  return e.transform !== "none" || e.perspective !== "none" || (e.containerType ? e.containerType !== "normal" : !1) || !o && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !o && (e.filter ? e.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((l) => (e.willChange || "").includes(l)) || ["paint", "layout", "strict", "content"].some((l) => (e.contain || "").includes(l));
}
function ds(a) {
  let o = It(a);
  for (; nt(o) && !ya(o); ) {
    if (Xa(o))
      return o;
    o = It(o);
  }
  return null;
}
function Ka() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ya(a) {
  return ["html", "body", "#document"].includes(it(a));
}
function Qe(a) {
  return We(a).getComputedStyle(a);
}
function ga(a) {
  return ut(a) ? {
    scrollLeft: a.scrollLeft,
    scrollTop: a.scrollTop
  } : {
    scrollLeft: a.pageXOffset,
    scrollTop: a.pageYOffset
  };
}
function It(a) {
  if (it(a) === "html")
    return a;
  const o = (
    // Step into the shadow DOM of the parent of a slotted node.
    a.assignedSlot || // DOM Element detected.
    a.parentNode || // ShadowRoot detected.
    gl(a) && a.host || // Fallback.
    pt(a)
  );
  return gl(o) ? o.host : o;
}
function Zl(a) {
  const o = It(a);
  return ya(o) ? a.ownerDocument ? a.ownerDocument.body : a.body : nt(o) && Wt(o) ? o : Zl(o);
}
function Mt(a, o, e) {
  var l;
  o === void 0 && (o = []), e === void 0 && (e = !0);
  const t = Zl(a), s = t === ((l = a.ownerDocument) == null ? void 0 : l.body), r = We(t);
  return s ? o.concat(r, r.visualViewport || [], Wt(t) ? t : [], r.frameElement && e ? Mt(r.frameElement) : []) : o.concat(t, Mt(t, [], e));
}
function Jl(a) {
  const o = Qe(a);
  let e = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0;
  const t = nt(a), s = t ? a.offsetWidth : e, r = t ? a.offsetHeight : l, u = na(e) !== s || na(l) !== r;
  return u && (e = s, l = r), {
    width: e,
    height: l,
    $: u
  };
}
function Ya(a) {
  return ut(a) ? a : a.contextElement;
}
function Vt(a) {
  const o = Ya(a);
  if (!nt(o))
    return yt(1);
  const e = o.getBoundingClientRect(), {
    width: l,
    height: t,
    $: s
  } = Jl(o);
  let r = (s ? na(e.width) : e.width) / l, u = (s ? na(e.height) : e.height) / t;
  return (!r || !Number.isFinite(r)) && (r = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: r,
    y: u
  };
}
const cs = /* @__PURE__ */ yt(0);
function Ql(a) {
  const o = We(a);
  return !Ka() || !o.visualViewport ? cs : {
    x: o.visualViewport.offsetLeft,
    y: o.visualViewport.offsetTop
  };
}
function fs(a, o, e) {
  return o === void 0 && (o = !1), !e || o && e !== We(a) ? !1 : o;
}
function ht(a, o, e, l) {
  o === void 0 && (o = !1), e === void 0 && (e = !1);
  const t = a.getBoundingClientRect(), s = Ya(a);
  let r = yt(1);
  o && (l ? ut(l) && (r = Vt(l)) : r = Vt(a));
  const u = fs(s, e, l) ? Ql(s) : yt(0);
  let i = (t.left + u.x) / r.x, d = (t.top + u.y) / r.y, f = t.width / r.x, c = t.height / r.y;
  if (s) {
    const y = We(s), p = l && ut(l) ? We(l) : l;
    let b = y, h = b.frameElement;
    for (; h && l && p !== b; ) {
      const w = Vt(h), v = h.getBoundingClientRect(), B = Qe(h), g = v.left + (h.clientLeft + parseFloat(B.paddingLeft)) * w.x, S = v.top + (h.clientTop + parseFloat(B.paddingTop)) * w.y;
      i *= w.x, d *= w.y, f *= w.x, c *= w.y, i += g, d += S, b = We(h), h = b.frameElement;
    }
  }
  return At({
    width: f,
    height: c,
    x: i,
    y: d
  });
}
const ps = [":popover-open", ":modal"];
function eo(a) {
  return ps.some((o) => {
    try {
      return a.matches(o);
    } catch {
      return !1;
    }
  });
}
function vs(a) {
  let {
    elements: o,
    rect: e,
    offsetParent: l,
    strategy: t
  } = a;
  const s = t === "fixed", r = pt(l), u = o ? eo(o.floating) : !1;
  if (l === r || u && s)
    return e;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = yt(1);
  const f = yt(0), c = nt(l);
  if ((c || !c && !s) && ((it(l) !== "body" || Wt(r)) && (i = ga(l)), nt(l))) {
    const y = ht(l);
    d = Vt(l), f.x = y.x + l.clientLeft, f.y = y.y + l.clientTop;
  }
  return {
    width: e.width * d.x,
    height: e.height * d.y,
    x: e.x * d.x - i.scrollLeft * d.x + f.x,
    y: e.y * d.y - i.scrollTop * d.y + f.y
  };
}
function ms(a) {
  return Array.from(a.getClientRects());
}
function to(a) {
  return ht(pt(a)).left + ga(a).scrollLeft;
}
function bs(a) {
  const o = pt(a), e = ga(a), l = a.ownerDocument.body, t = Pe(o.scrollWidth, o.clientWidth, l.scrollWidth, l.clientWidth), s = Pe(o.scrollHeight, o.clientHeight, l.scrollHeight, l.clientHeight);
  let r = -e.scrollLeft + to(a);
  const u = -e.scrollTop;
  return Qe(l).direction === "rtl" && (r += Pe(o.clientWidth, l.clientWidth) - t), {
    width: t,
    height: s,
    x: r,
    y: u
  };
}
function ys(a, o) {
  const e = We(a), l = pt(a), t = e.visualViewport;
  let s = l.clientWidth, r = l.clientHeight, u = 0, i = 0;
  if (t) {
    s = t.width, r = t.height;
    const d = Ka();
    (!d || d && o === "fixed") && (u = t.offsetLeft, i = t.offsetTop);
  }
  return {
    width: s,
    height: r,
    x: u,
    y: i
  };
}
function gs(a, o) {
  const e = ht(a, !0, o === "fixed"), l = e.top + a.clientTop, t = e.left + a.clientLeft, s = nt(a) ? Vt(a) : yt(1), r = a.clientWidth * s.x, u = a.clientHeight * s.y, i = t * s.x, d = l * s.y;
  return {
    width: r,
    height: u,
    x: i,
    y: d
  };
}
function hl(a, o, e) {
  let l;
  if (o === "viewport")
    l = ys(a, e);
  else if (o === "document")
    l = bs(pt(a));
  else if (ut(o))
    l = gs(o, e);
  else {
    const t = Ql(a);
    l = {
      ...o,
      x: o.x - t.x,
      y: o.y - t.y
    };
  }
  return At(l);
}
function ao(a, o) {
  const e = It(a);
  return e === o || !ut(e) || ya(e) ? !1 : Qe(e).position === "fixed" || ao(e, o);
}
function hs(a, o) {
  const e = o.get(a);
  if (e)
    return e;
  let l = Mt(a, [], !1).filter((u) => ut(u) && it(u) !== "body"), t = null;
  const s = Qe(a).position === "fixed";
  let r = s ? It(a) : a;
  for (; ut(r) && !ya(r); ) {
    const u = Qe(r), i = Xa(r);
    !i && u.position === "fixed" && (t = null), (s ? !i && !t : !i && u.position === "static" && !!t && ["absolute", "fixed"].includes(t.position) || Wt(r) && !i && ao(a, r)) ? l = l.filter((f) => f !== r) : t = u, r = It(r);
  }
  return o.set(a, l), l;
}
function Bs(a) {
  let {
    element: o,
    boundary: e,
    rootBoundary: l,
    strategy: t
  } = a;
  const r = [...e === "clippingAncestors" ? hs(o, this._c) : [].concat(e), l], u = r[0], i = r.reduce((d, f) => {
    const c = hl(o, f, t);
    return d.top = Pe(c.top, d.top), d.right = je(c.right, d.right), d.bottom = je(c.bottom, d.bottom), d.left = Pe(c.left, d.left), d;
  }, hl(o, u, t));
  return {
    width: i.right - i.left,
    height: i.bottom - i.top,
    x: i.left,
    y: i.top
  };
}
function _s(a) {
  const {
    width: o,
    height: e
  } = Jl(a);
  return {
    width: o,
    height: e
  };
}
function ws(a, o, e) {
  const l = nt(o), t = pt(o), s = e === "fixed", r = ht(a, !0, s, o);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const i = yt(0);
  if (l || !l && !s)
    if ((it(o) !== "body" || Wt(t)) && (u = ga(o)), l) {
      const c = ht(o, !0, s, o);
      i.x = c.x + o.clientLeft, i.y = c.y + o.clientTop;
    } else
      t && (i.x = to(t));
  const d = r.left + u.scrollLeft - i.x, f = r.top + u.scrollTop - i.y;
  return {
    x: d,
    y: f,
    width: r.width,
    height: r.height
  };
}
function Bl(a, o) {
  return !nt(a) || Qe(a).position === "fixed" ? null : o ? o(a) : a.offsetParent;
}
function lo(a, o) {
  const e = We(a);
  if (!nt(a) || eo(a))
    return e;
  let l = Bl(a, o);
  for (; l && us(l) && Qe(l).position === "static"; )
    l = Bl(l, o);
  return l && (it(l) === "html" || it(l) === "body" && Qe(l).position === "static" && !Xa(l)) ? e : l || ds(a) || e;
}
const Cs = async function(a) {
  const o = this.getOffsetParent || lo, e = this.getDimensions;
  return {
    reference: ws(a.reference, await o(a.floating), a.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await e(a.floating)
    }
  };
};
function ks(a) {
  return Qe(a).direction === "rtl";
}
const Ts = {
  convertOffsetParentRelativeRectToViewportRelativeRect: vs,
  getDocumentElement: pt,
  getClippingRect: Bs,
  getOffsetParent: lo,
  getElementRects: Cs,
  getClientRects: ms,
  getDimensions: _s,
  getScale: Vt,
  isElement: ut,
  isRTL: ks
};
function $s(a, o) {
  let e = null, l;
  const t = pt(a);
  function s() {
    var u;
    clearTimeout(l), (u = e) == null || u.disconnect(), e = null;
  }
  function r(u, i) {
    u === void 0 && (u = !1), i === void 0 && (i = 1), s();
    const {
      left: d,
      top: f,
      width: c,
      height: y
    } = a.getBoundingClientRect();
    if (u || o(), !c || !y)
      return;
    const p = Kt(f), b = Kt(t.clientWidth - (d + c)), h = Kt(t.clientHeight - (f + y)), w = Kt(d), B = {
      rootMargin: -p + "px " + -b + "px " + -h + "px " + -w + "px",
      threshold: Pe(0, je(1, i)) || 1
    };
    let g = !0;
    function S(C) {
      const x = C[0].intersectionRatio;
      if (x !== i) {
        if (!g)
          return r();
        x ? r(!1, x) : l = setTimeout(() => {
          r(!1, 1e-7);
        }, 100);
      }
      g = !1;
    }
    try {
      e = new IntersectionObserver(S, {
        ...B,
        // Handle <iframe>s
        root: t.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(S, B);
    }
    e.observe(a);
  }
  return r(!0), s;
}
function oo(a, o, e, l) {
  l === void 0 && (l = {});
  const {
    ancestorScroll: t = !0,
    ancestorResize: s = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: i = !1
  } = l, d = Ya(a), f = t || s ? [...d ? Mt(d) : [], ...Mt(o)] : [];
  f.forEach((v) => {
    t && v.addEventListener("scroll", e, {
      passive: !0
    }), s && v.addEventListener("resize", e);
  });
  const c = d && u ? $s(d, e) : null;
  let y = -1, p = null;
  r && (p = new ResizeObserver((v) => {
    let [B] = v;
    B && B.target === d && p && (p.unobserve(o), cancelAnimationFrame(y), y = requestAnimationFrame(() => {
      var g;
      (g = p) == null || g.observe(o);
    })), e();
  }), d && !i && p.observe(d), p.observe(o));
  let b, h = i ? ht(a) : null;
  i && w();
  function w() {
    const v = ht(a);
    h && (v.x !== h.x || v.y !== h.y || v.width !== h.width || v.height !== h.height) && e(), h = v, b = requestAnimationFrame(w);
  }
  return e(), () => {
    var v;
    f.forEach((B) => {
      t && B.removeEventListener("scroll", e), s && B.removeEventListener("resize", e);
    }), c == null || c(), (v = p) == null || v.disconnect(), p = null, i && cancelAnimationFrame(b);
  };
}
const xs = ts, no = rs, so = as, ro = is, Ss = ls, Vs = Qn, As = ns, Os = (a, o, e) => {
  const l = /* @__PURE__ */ new Map(), t = {
    platform: Ts,
    ...e
  }, s = {
    ...t.platform,
    _c: l
  };
  return Jn(a, o, {
    ...t,
    platform: s
  });
};
function Is(a) {
  return a != null && typeof a == "object" && "$el" in a;
}
function Va(a) {
  if (Is(a)) {
    const o = a.$el;
    return Ua(o) && it(o) === "#comment" ? null : o;
  }
  return a;
}
function Ps(a) {
  return {
    name: "arrow",
    options: a,
    fn(o) {
      const e = Va(n(a.element));
      return e == null ? {} : Vs({
        element: e,
        padding: a.padding
      }).fn(o);
    }
  };
}
function io(a) {
  return typeof window > "u" ? 1 : (a.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _l(a, o) {
  const e = io(a);
  return Math.round(o * e) / e;
}
function uo(a, o, e) {
  e === void 0 && (e = {});
  const l = e.whileElementsMounted, t = _(() => {
    var V;
    return (V = n(e.open)) != null ? V : !0;
  }), s = _(() => n(e.middleware)), r = _(() => {
    var V;
    return (V = n(e.placement)) != null ? V : "bottom";
  }), u = _(() => {
    var V;
    return (V = n(e.strategy)) != null ? V : "absolute";
  }), i = _(() => {
    var V;
    return (V = n(e.transform)) != null ? V : !0;
  }), d = _(() => Va(a.value)), f = _(() => Va(o.value)), c = z(0), y = z(0), p = z(u.value), b = z(r.value), h = bt({}), w = z(!1), v = _(() => {
    const V = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return V;
    const q = _l(f.value, c.value), G = _l(f.value, y.value);
    return i.value ? {
      ...V,
      transform: "translate(" + q + "px, " + G + "px)",
      ...io(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: q + "px",
      top: G + "px"
    };
  });
  let B;
  function g() {
    d.value == null || f.value == null || Os(d.value, f.value, {
      middleware: s.value,
      placement: r.value,
      strategy: u.value
    }).then((V) => {
      c.value = V.x, y.value = V.y, p.value = V.strategy, b.value = V.placement, h.value = V.middlewareData, w.value = !0;
    });
  }
  function S() {
    typeof B == "function" && (B(), B = void 0);
  }
  function C() {
    if (S(), l === void 0) {
      g();
      return;
    }
    if (d.value != null && f.value != null) {
      B = l(d.value, f.value, g);
      return;
    }
  }
  function x() {
    t.value || (w.value = !1);
  }
  return fe([s, r, u], g, {
    flush: "sync"
  }), fe([d, f], C, {
    flush: "sync"
  }), fe(t, x, {
    flush: "sync"
  }), Rl() && Dl(S), {
    x: Tt(c),
    y: Tt(y),
    strategy: Tt(p),
    placement: Tt(b),
    middlewareData: Tt(h),
    isPositioned: Tt(w),
    floatingStyles: v,
    update: g
  };
}
const Ns = /* @__PURE__ */ new Set([
  "background",
  "cite",
  "href",
  "itemtype",
  "longdesc",
  "poster",
  "src",
  "xlink:href"
]), Es = /^aria-[\w-]*$/i, Fs = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i, Ls = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i, zs = (a, o) => {
  const e = a.nodeName.toLowerCase();
  return o.includes(e) ? Ns.has(e) ? !!(Fs.test(a.nodeValue || "") || Ls.test(a.nodeValue || "")) : !0 : o.filter((l) => l instanceof RegExp).some((l) => l.test(e));
}, $t = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", Es],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  div: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, xt = (a, o, e) => {
  if (!a.length)
    return a;
  if (e && typeof e == "function")
    return e(a);
  const t = new window.DOMParser().parseFromString(a, "text/html"), s = t.body.querySelectorAll("*");
  for (const r of s) {
    const u = r.nodeName.toLowerCase();
    if (!Object.keys(o).includes(u)) {
      r.remove();
      continue;
    }
    const i = r.attributes, d = [...o["*"] || [], ...o[u] || []];
    for (const f of i)
      zs(f, d) || r.removeAttribute(f.nodeName);
  }
  return t.body.innerHTML;
};
function dt(a) {
  return Rl() ? (Dl(a), !0) : !1;
}
function Hs(a, o) {
  if (typeof Symbol < "u") {
    const e = { ...a };
    return Object.defineProperty(e, Symbol.iterator, {
      enumerable: !1,
      value() {
        let l = 0;
        return {
          next: () => ({
            value: o[l++],
            done: l > o.length
          })
        };
      }
    }), e;
  } else
    return Object.assign([...o], a);
}
function ze(a) {
  return typeof a == "function" ? a() : n(a);
}
const ia = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const co = (a) => a != null, Ms = Object.prototype.toString, Rs = (a) => Ms.call(a) === "[object Object]", Ze = () => {
}, Aa = /* @__PURE__ */ Ds();
function Ds() {
  var a, o;
  return ia && ((a = window == null ? void 0 : window.navigator) == null ? void 0 : a.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((o = window == null ? void 0 : window.navigator) == null ? void 0 : o.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function fo(a, o) {
  function e(...l) {
    return new Promise((t, s) => {
      Promise.resolve(a(() => o.apply(this, l), { fn: o, thisArg: this, args: l })).then(t).catch(s);
    });
  }
  return e;
}
const po = (a) => a();
function js(a, o = {}) {
  let e, l, t = Ze;
  const s = (u) => {
    clearTimeout(u), t(), t = Ze;
  };
  return (u) => {
    const i = ze(a), d = ze(o.maxWait);
    return e && s(e), i <= 0 || d !== void 0 && d <= 0 ? (l && (s(l), l = null), Promise.resolve(u())) : new Promise((f, c) => {
      t = o.rejectOnCancel ? c : f, d && !l && (l = setTimeout(() => {
        e && s(e), l = null, f(u());
      }, d)), e = setTimeout(() => {
        l && s(l), l = null, f(u());
      }, i);
    });
  };
}
function Gs(a = po) {
  const o = z(!0);
  function e() {
    o.value = !1;
  }
  function l() {
    o.value = !0;
  }
  const t = (...s) => {
    o.value && a(...s);
  };
  return { isActive: Ye(o), pause: e, resume: l, eventFilter: t };
}
function Ws(a) {
  const o = /* @__PURE__ */ Object.create(null);
  return (e) => o[e] || (o[e] = a(e));
}
const qs = /-(\w)/g, Us = Ws((a) => a.replace(qs, (o, e) => e ? e.toUpperCase() : ""));
function Xs(a) {
  return a || Bt();
}
function vo(...a) {
  if (a.length !== 1)
    return k(...a);
  const o = a[0];
  return typeof o == "function" ? Ye(In(() => ({ get: o, set: Ze }))) : z(o);
}
function Ks(a, o = 200, e = {}) {
  return fo(
    js(o, e),
    a
  );
}
function Ys(a, o, e = {}) {
  const {
    eventFilter: l = po,
    ...t
  } = e;
  return fe(
    a,
    fo(
      l,
      o
    ),
    t
  );
}
function Oa(a, o, e = {}) {
  const {
    eventFilter: l,
    ...t
  } = e, { eventFilter: s, pause: r, resume: u, isActive: i } = Gs(l);
  return { stop: Ys(
    a,
    o,
    {
      ...t,
      eventFilter: s
    }
  ), pause: r, resume: u, isActive: i };
}
function Ia(a, o, ...[e]) {
  const {
    flush: l = "sync",
    deep: t = !1,
    immediate: s = !0,
    direction: r = "both",
    transform: u = {}
  } = e || {}, i = [], d = "ltr" in u && u.ltr || ((y) => y), f = "rtl" in u && u.rtl || ((y) => y);
  return (r === "both" || r === "ltr") && i.push(Oa(
    a,
    (y) => {
      i.forEach((p) => p.pause()), o.value = d(y), i.forEach((p) => p.resume());
    },
    { flush: l, deep: t, immediate: s }
  )), (r === "both" || r === "rtl") && i.push(Oa(
    o,
    (y) => {
      i.forEach((p) => p.pause()), a.value = f(y), i.forEach((p) => p.resume());
    },
    { flush: l, deep: t, immediate: s }
  )), () => {
    i.forEach((y) => y.stop());
  };
}
function mo(a, o = !0, e) {
  Xs() ? Ue(a, e) : o ? a() : Ne(a);
}
function bo(a, o = 1e3, e = {}) {
  const {
    immediate: l = !0,
    immediateCallback: t = !1
  } = e;
  let s = null;
  const r = z(!1);
  function u() {
    s && (clearInterval(s), s = null);
  }
  function i() {
    r.value = !1, u();
  }
  function d() {
    const f = ze(o);
    f <= 0 || (r.value = !0, t && a(), u(), s = setInterval(a, f));
  }
  if (l && ia && d(), On(o) || typeof o == "function") {
    const f = fe(o, () => {
      r.value && ia && d();
    });
    dt(f);
  }
  return dt(i), {
    isActive: r,
    pause: i,
    resume: d
  };
}
function he(a, o = {}) {
  const {
    method: e = "parseFloat",
    radix: l,
    nanToZero: t
  } = o;
  return _(() => {
    let s = ze(a);
    return typeof s == "string" && (s = Number[e](s, l)), t && Number.isNaN(s) && (s = 0), s;
  });
}
function ua(a = {}) {
  const {
    inheritAttrs: o = !0
  } = a, e = bt(), l = /* @__PURE__ */ L({
    setup(s, { slots: r }) {
      return () => {
        e.value = r.default;
      };
    }
  }), t = /* @__PURE__ */ L({
    inheritAttrs: o,
    setup(s, { attrs: r, slots: u }) {
      return () => {
        var i;
        if (!e.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const d = (i = e.value) == null ? void 0 : i.call(e, { ...Zs(r), $slots: u });
        return o && (d == null ? void 0 : d.length) === 1 ? d[0] : d;
      };
    }
  });
  return Hs(
    { define: l, reuse: t },
    [l, t]
  );
}
function Zs(a) {
  const o = {};
  for (const e in a)
    o[Us(e)] = a[e];
  return o;
}
function Ge(a) {
  var o;
  const e = ze(a);
  return (o = e == null ? void 0 : e.$el) != null ? o : e;
}
const qe = ia ? window : void 0;
function Te(...a) {
  let o, e, l, t;
  if (typeof a[0] == "string" || Array.isArray(a[0]) ? ([e, l, t] = a, o = qe) : [o, e, l, t] = a, !o)
    return Ze;
  Array.isArray(e) || (e = [e]), Array.isArray(l) || (l = [l]);
  const s = [], r = () => {
    s.forEach((f) => f()), s.length = 0;
  }, u = (f, c, y, p) => (f.addEventListener(c, y, p), () => f.removeEventListener(c, y, p)), i = fe(
    () => [Ge(o), ze(t)],
    ([f, c]) => {
      if (r(), !f)
        return;
      const y = Rs(c) ? { ...c } : c;
      s.push(
        ...e.flatMap((p) => l.map((b) => u(f, p, b, y)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    i(), r();
  };
  return dt(d), d;
}
let wl = !1;
function yo(a, o, e = {}) {
  const { window: l = qe, ignore: t = [], capture: s = !0, detectIframe: r = !1 } = e;
  if (!l)
    return Ze;
  Aa && !wl && (wl = !0, Array.from(l.document.body.children).forEach((y) => y.addEventListener("click", Ze)), l.document.documentElement.addEventListener("click", Ze));
  let u = !0;
  const i = (y) => t.some((p) => {
    if (typeof p == "string")
      return Array.from(l.document.querySelectorAll(p)).some((b) => b === y.target || y.composedPath().includes(b));
    {
      const b = Ge(p);
      return b && (y.target === b || y.composedPath().includes(b));
    }
  }), f = [
    Te(l, "click", (y) => {
      const p = Ge(a);
      if (!(!p || p === y.target || y.composedPath().includes(p))) {
        if (y.detail === 0 && (u = !i(y)), !u) {
          u = !0;
          return;
        }
        o(y);
      }
    }, { passive: !0, capture: s }),
    Te(l, "pointerdown", (y) => {
      const p = Ge(a);
      u = !i(y) && !!(p && !y.composedPath().includes(p));
    }, { passive: !0 }),
    r && Te(l, "blur", (y) => {
      setTimeout(() => {
        var p;
        const b = Ge(a);
        ((p = l.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(b != null && b.contains(l.document.activeElement)) && o(y);
      }, 0);
    })
  ].filter(Boolean);
  return () => f.forEach((y) => y());
}
function Js(a) {
  return typeof a == "function" ? a : typeof a == "string" ? (o) => o.key === a : Array.isArray(a) ? (o) => a.includes(o.key) : () => !0;
}
function De(...a) {
  let o, e, l = {};
  a.length === 3 ? (o = a[0], e = a[1], l = a[2]) : a.length === 2 ? typeof a[1] == "object" ? (o = !0, e = a[0], l = a[1]) : (o = a[0], e = a[1]) : (o = !0, e = a[0]);
  const {
    target: t = qe,
    eventName: s = "keydown",
    passive: r = !1,
    dedupe: u = !1
  } = l, i = Js(o);
  return Te(t, s, (f) => {
    f.repeat && ze(u) || i(f) && e(f);
  }, r);
}
function Qs() {
  const a = z(!1), o = Bt();
  return o && Ue(() => {
    a.value = !0;
  }, o), a;
}
function Za(a) {
  const o = Qs();
  return _(() => (o.value, !!a()));
}
function er(a, o = {}) {
  const { window: e = qe } = o, l = Za(() => e && "matchMedia" in e && typeof e.matchMedia == "function");
  let t;
  const s = z(!1), r = (d) => {
    s.value = d.matches;
  }, u = () => {
    t && ("removeEventListener" in t ? t.removeEventListener("change", r) : t.removeListener(r));
  }, i = Pt(() => {
    l.value && (u(), t = e.matchMedia(ze(a)), "addEventListener" in t ? t.addEventListener("change", r) : t.addListener(r), s.value = t.matches);
  });
  return dt(() => {
    i(), u(), t = void 0;
  }), s;
}
const Yt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Zt = "__vueuse_ssr_handlers__", tr = /* @__PURE__ */ ar();
function ar() {
  return Zt in Yt || (Yt[Zt] = Yt[Zt] || {}), Yt[Zt];
}
function Ja(a, o) {
  return tr[a] || o;
}
function lr(a) {
  return a == null ? "any" : a instanceof Set ? "set" : a instanceof Map ? "map" : a instanceof Date ? "date" : typeof a == "boolean" ? "boolean" : typeof a == "string" ? "string" : typeof a == "object" ? "object" : Number.isNaN(a) ? "any" : "number";
}
const or = {
  boolean: {
    read: (a) => a === "true",
    write: (a) => String(a)
  },
  object: {
    read: (a) => JSON.parse(a),
    write: (a) => JSON.stringify(a)
  },
  number: {
    read: (a) => Number.parseFloat(a),
    write: (a) => String(a)
  },
  any: {
    read: (a) => a,
    write: (a) => String(a)
  },
  string: {
    read: (a) => a,
    write: (a) => String(a)
  },
  map: {
    read: (a) => new Map(JSON.parse(a)),
    write: (a) => JSON.stringify(Array.from(a.entries()))
  },
  set: {
    read: (a) => new Set(JSON.parse(a)),
    write: (a) => JSON.stringify(Array.from(a))
  },
  date: {
    read: (a) => new Date(a),
    write: (a) => a.toISOString()
  }
}, Cl = "vueuse-storage";
function nr(a, o, e, l = {}) {
  var t;
  const {
    flush: s = "pre",
    deep: r = !0,
    listenToStorageChanges: u = !0,
    writeDefaults: i = !0,
    mergeDefaults: d = !1,
    shallow: f,
    window: c = qe,
    eventFilter: y,
    onError: p = (O) => {
      console.error(O);
    },
    initOnMounted: b
  } = l, h = (f ? bt : z)(typeof o == "function" ? o() : o);
  if (!e)
    try {
      e = Ja("getDefaultStorage", () => {
        var O;
        return (O = qe) == null ? void 0 : O.localStorage;
      })();
    } catch (O) {
      p(O);
    }
  if (!e)
    return h;
  const w = ze(o), v = lr(w), B = (t = l.serializer) != null ? t : or[v], { pause: g, resume: S } = Oa(
    h,
    () => x(h.value),
    { flush: s, deep: r, eventFilter: y }
  );
  c && u && mo(() => {
    Te(c, "storage", q), Te(c, Cl, G), b && q();
  }), b || q();
  function C(O, Z) {
    c && c.dispatchEvent(new CustomEvent(Cl, {
      detail: {
        key: a,
        oldValue: O,
        newValue: Z,
        storageArea: e
      }
    }));
  }
  function x(O) {
    try {
      const Z = e.getItem(a);
      if (O == null)
        C(Z, null), e.removeItem(a);
      else {
        const ae = B.write(O);
        Z !== ae && (e.setItem(a, ae), C(Z, ae));
      }
    } catch (Z) {
      p(Z);
    }
  }
  function V(O) {
    const Z = O ? O.newValue : e.getItem(a);
    if (Z == null)
      return i && w != null && e.setItem(a, B.write(w)), w;
    if (!O && d) {
      const ae = B.read(Z);
      return typeof d == "function" ? d(ae, w) : v === "object" && !Array.isArray(ae) ? { ...w, ...ae } : ae;
    } else
      return typeof Z != "string" ? Z : B.read(Z);
  }
  function q(O) {
    if (!(O && O.storageArea !== e)) {
      if (O && O.key == null) {
        h.value = w;
        return;
      }
      if (!(O && O.key !== a)) {
        g();
        try {
          (O == null ? void 0 : O.newValue) !== B.write(h.value) && (h.value = V(O));
        } catch (Z) {
          p(Z);
        } finally {
          O ? Ne(S) : S();
        }
      }
    }
  }
  function G(O) {
    q(O.detail);
  }
  return h;
}
function sr(a) {
  return er("(prefers-color-scheme: dark)", a);
}
function rr(a = {}) {
  const {
    selector: o = "html",
    attribute: e = "class",
    initialValue: l = "auto",
    window: t = qe,
    storage: s,
    storageKey: r = "vueuse-color-scheme",
    listenToStorageChanges: u = !0,
    storageRef: i,
    emitAuto: d,
    disableTransition: f = !0
  } = a, c = {
    auto: "",
    light: "light",
    dark: "dark",
    ...a.modes || {}
  }, y = sr({ window: t }), p = _(() => y.value ? "dark" : "light"), b = i || (r == null ? vo(l) : nr(r, l, s, { window: t, listenToStorageChanges: u })), h = _(() => b.value === "auto" ? p.value : b.value), w = Ja(
    "updateHTMLAttrs",
    (S, C, x) => {
      const V = typeof S == "string" ? t == null ? void 0 : t.document.querySelector(S) : Ge(S);
      if (!V)
        return;
      let q;
      if (f && (q = t.document.createElement("style"), q.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")), t.document.head.appendChild(q)), C === "class") {
        const G = x.split(/\s/g);
        Object.values(c).flatMap((O) => (O || "").split(/\s/g)).filter(Boolean).forEach((O) => {
          G.includes(O) ? V.classList.add(O) : V.classList.remove(O);
        });
      } else
        V.setAttribute(C, x);
      f && (t.getComputedStyle(q).opacity, document.head.removeChild(q));
    }
  );
  function v(S) {
    var C;
    w(o, e, (C = c[S]) != null ? C : S);
  }
  function B(S) {
    a.onChanged ? a.onChanged(S, v) : v(S);
  }
  fe(h, B, { flush: "post", immediate: !0 }), mo(() => B(h.value));
  const g = _({
    get() {
      return d ? b.value : h.value;
    },
    set(S) {
      b.value = S;
    }
  });
  try {
    return Object.assign(g, { store: b, system: p, state: h });
  } catch {
    return g;
  }
}
function ir(a, o, e = {}) {
  const { window: l = qe, ...t } = e;
  let s;
  const r = Za(() => l && "MutationObserver" in l), u = () => {
    s && (s.disconnect(), s = void 0);
  }, i = _(() => {
    const y = ze(a), p = (Array.isArray(y) ? y : [y]).map(Ge).filter(co);
    return new Set(p);
  }), d = fe(
    () => i.value,
    (y) => {
      u(), r.value && l && y.size && (s = new MutationObserver(o), y.forEach((p) => s.observe(p, t)));
    },
    { immediate: !0, flush: "post" }
  ), f = () => s == null ? void 0 : s.takeRecords(), c = () => {
    u(), d();
  };
  return dt(c), {
    isSupported: r,
    stop: c,
    takeRecords: f
  };
}
function Qa(a, o = {}) {
  const {
    delayEnter: e = 0,
    delayLeave: l = 0,
    window: t = qe
  } = o, s = z(!1);
  let r;
  const u = (i) => {
    const d = i ? e : l;
    r && (clearTimeout(r), r = void 0), d ? r = setTimeout(() => s.value = i, d) : s.value = i;
  };
  return t && (Te(a, "mouseenter", () => u(!0), { passive: !0 }), Te(a, "mouseleave", () => u(!1), { passive: !0 })), s;
}
function ur(a, o, e = {}) {
  const {
    root: l,
    rootMargin: t = "0px",
    threshold: s = 0.1,
    window: r = qe,
    immediate: u = !0
  } = e, i = Za(() => r && "IntersectionObserver" in r), d = _(() => {
    const b = ze(a);
    return (Array.isArray(b) ? b : [b]).map(Ge).filter(co);
  });
  let f = Ze;
  const c = z(u), y = i.value ? fe(
    () => [d.value, Ge(l), c.value],
    ([b, h]) => {
      if (f(), !c.value || !b.length)
        return;
      const w = new IntersectionObserver(
        o,
        {
          root: Ge(h),
          rootMargin: t,
          threshold: s
        }
      );
      b.forEach((v) => v && w.observe(v)), f = () => {
        w.disconnect(), f = Ze;
      };
    },
    { immediate: u, flush: "post" }
  ) : Ze, p = () => {
    f(), y(), c.value = !1;
  };
  return dt(p), {
    isSupported: i,
    isActive: c,
    pause() {
      f(), c.value = !1;
    },
    resume() {
      c.value = !0;
    },
    stop: p
  };
}
function Fe(a, o = {}) {
  const { initialValue: e = !1, focusVisible: l = !1 } = o, t = z(!1), s = _(() => Ge(a));
  Te(s, "focus", (u) => {
    var i, d;
    (!l || (d = (i = u.target).matches) != null && d.call(i, ":focus-visible")) && (t.value = !0);
  }), Te(s, "blur", () => t.value = !1);
  const r = _({
    get: () => t.value,
    set(u) {
      var i, d;
      !u && t.value ? (i = s.value) == null || i.blur() : u && !t.value && ((d = s.value) == null || d.focus());
    }
  });
  return fe(
    s,
    () => {
      r.value = e;
    },
    { immediate: !0, flush: "post" }
  ), { focused: r };
}
function wa(a) {
  return typeof Window < "u" && a instanceof Window ? a.document.documentElement : typeof Document < "u" && a instanceof Document ? a.documentElement : a;
}
const dr = {
  page: (a) => [a.pageX, a.pageY],
  client: (a) => [a.clientX, a.clientY],
  screen: (a) => [a.screenX, a.screenY],
  movement: (a) => a instanceof Touch ? null : [a.movementX, a.movementY]
};
function cr(a = {}) {
  const {
    type: o = "page",
    touch: e = !0,
    resetOnTouchEnds: l = !1,
    initialValue: t = { x: 0, y: 0 },
    window: s = qe,
    target: r = s,
    scroll: u = !0,
    eventFilter: i
  } = a;
  let d = null;
  const f = z(t.x), c = z(t.y), y = z(null), p = typeof o == "function" ? o : dr[o], b = (C) => {
    const x = p(C);
    d = C, x && ([f.value, c.value] = x, y.value = "mouse");
  }, h = (C) => {
    if (C.touches.length > 0) {
      const x = p(C.touches[0]);
      x && ([f.value, c.value] = x, y.value = "touch");
    }
  }, w = () => {
    if (!d || !s)
      return;
    const C = p(d);
    d instanceof MouseEvent && C && (f.value = C[0] + s.scrollX, c.value = C[1] + s.scrollY);
  }, v = () => {
    f.value = t.x, c.value = t.y;
  }, B = i ? (C) => i(() => b(C), {}) : (C) => b(C), g = i ? (C) => i(() => h(C), {}) : (C) => h(C), S = i ? () => i(() => w(), {}) : () => w();
  if (r) {
    const C = { passive: !0 };
    Te(r, ["mousemove", "dragover"], B, C), e && o !== "movement" && (Te(r, ["touchstart", "touchmove"], g, C), l && Te(r, "touchend", v, C)), u && o === "page" && Te(s, "scroll", S, { passive: !0 });
  }
  return {
    x: f,
    y: c,
    sourceType: y
  };
}
function kl(a, o = {}) {
  const {
    handleOutside: e = !0,
    window: l = qe
  } = o, t = o.type || "page", { x: s, y: r, sourceType: u } = cr(o), i = z(a ?? (l == null ? void 0 : l.document.body)), d = z(0), f = z(0), c = z(0), y = z(0), p = z(0), b = z(0), h = z(!0);
  let w = () => {
  };
  return l && (w = fe(
    [i, s, r],
    () => {
      const v = Ge(i);
      if (!v)
        return;
      const {
        left: B,
        top: g,
        width: S,
        height: C
      } = v.getBoundingClientRect();
      c.value = B + (t === "page" ? l.pageXOffset : 0), y.value = g + (t === "page" ? l.pageYOffset : 0), p.value = C, b.value = S;
      const x = s.value - c.value, V = r.value - y.value;
      h.value = S === 0 || C === 0 || x < 0 || V < 0 || x > S || V > C, (e || !h.value) && (d.value = x, f.value = V);
    },
    { immediate: !0 }
  ), Te(document, "mouseleave", () => {
    h.value = !0;
  })), {
    x: s,
    y: r,
    sourceType: u,
    elementX: d,
    elementY: f,
    elementPositionX: c,
    elementPositionY: y,
    elementHeight: p,
    elementWidth: b,
    isOutside: h,
    stop: w
  };
}
function go(a) {
  const o = window.getComputedStyle(a);
  if (o.overflowX === "scroll" || o.overflowY === "scroll" || o.overflowX === "auto" && a.clientWidth < a.scrollWidth || o.overflowY === "auto" && a.clientHeight < a.scrollHeight)
    return !0;
  {
    const e = a.parentNode;
    return !e || e.tagName === "BODY" ? !1 : go(e);
  }
}
function fr(a) {
  const o = a || window.event, e = o.target;
  return go(e) ? !1 : o.touches.length > 1 ? !0 : (o.preventDefault && o.preventDefault(), !1);
}
const Jt = /* @__PURE__ */ new WeakMap();
function pr(a, o = !1) {
  const e = z(o);
  let l = null;
  fe(vo(a), (r) => {
    const u = wa(ze(r));
    if (u) {
      const i = u;
      Jt.get(i) || Jt.set(i, i.style.overflow), e.value && (i.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const t = () => {
    const r = wa(ze(a));
    !r || e.value || (Aa && (l = Te(
      r,
      "touchmove",
      (u) => {
        fr(u);
      },
      { passive: !1 }
    )), r.style.overflow = "hidden", e.value = !0);
  }, s = () => {
    var r;
    const u = wa(ze(a));
    !u || !e.value || (Aa && (l == null || l()), u.style.overflow = (r = Jt.get(u)) != null ? r : "", Jt.delete(u), e.value = !1);
  };
  return dt(s), _({
    get() {
      return e.value;
    },
    set(r) {
      r ? t() : s();
    }
  });
}
function vr(a, o = {}) {
  const {
    threshold: e = 50,
    onSwipe: l,
    onSwipeEnd: t,
    onSwipeStart: s,
    passive: r = !0,
    window: u = qe
  } = o, i = cl({ x: 0, y: 0 }), d = cl({ x: 0, y: 0 }), f = _(() => i.x - d.x), c = _(() => i.y - d.y), { max: y, abs: p } = Math, b = _(() => y(p(f.value), p(c.value)) >= e), h = z(!1), w = _(() => b.value ? p(f.value) > p(c.value) ? f.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), v = (G) => [G.touches[0].clientX, G.touches[0].clientY], B = (G, O) => {
    i.x = G, i.y = O;
  }, g = (G, O) => {
    d.x = G, d.y = O;
  };
  let S;
  const C = mr(u == null ? void 0 : u.document);
  r ? S = C ? { passive: !0 } : { capture: !1 } : S = C ? { passive: !1, capture: !0 } : { capture: !0 };
  const x = (G) => {
    h.value && (t == null || t(G, w.value)), h.value = !1;
  }, V = [
    Te(a, "touchstart", (G) => {
      if (G.touches.length !== 1)
        return;
      S.capture && !S.passive && G.preventDefault();
      const [O, Z] = v(G);
      B(O, Z), g(O, Z), s == null || s(G);
    }, S),
    Te(a, "touchmove", (G) => {
      if (G.touches.length !== 1)
        return;
      const [O, Z] = v(G);
      g(O, Z), !h.value && b.value && (h.value = !0), h.value && (l == null || l(G));
    }, S),
    Te(a, ["touchend", "touchcancel"], x, S)
  ];
  return {
    isPassiveEventSupported: C,
    isSwiping: h,
    direction: w,
    coordsStart: i,
    coordsEnd: d,
    lengthX: f,
    lengthY: c,
    stop: () => V.forEach((G) => G())
  };
}
function mr(a) {
  if (!a)
    return !1;
  let o = !1;
  const e = {
    get passive() {
      return o = !0, !1;
    }
  };
  return a.addEventListener("x", Ze, e), a.removeEventListener("x", Ze), o;
}
const br = ["id"], yr = ["id"], gr = ["innerHTML"], hr = ["innerHTML"], el = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BPopover",
  props: /* @__PURE__ */ ge({
    boundary: { default: "clippingAncestors" },
    boundaryPadding: { default: void 0 },
    click: { type: Boolean, default: !1 },
    content: { default: void 0 },
    customClass: { default: "" },
    delay: { default: () => ({ show: 100, hide: 300 }) },
    floatingMiddleware: { default: void 0 },
    html: { type: Boolean, default: !1 },
    id: { default: void 0 },
    inline: { type: Boolean, default: !1 },
    manual: { type: Boolean, default: !1 },
    modelValue: { type: Boolean },
    noAutoClose: { type: Boolean, default: !1 },
    noFade: { type: Boolean, default: !1 },
    noFlip: { type: Boolean, default: !1 },
    noHide: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 },
    noSize: { type: Boolean, default: !1 },
    noninteractive: { type: Boolean, default: !1 },
    offset: { default: null },
    placement: { default: "top" },
    persistent: { type: Boolean, default: !1 },
    realtime: { type: Boolean, default: !1 },
    reference: { default: null },
    strategy: { default: "absolute" },
    target: { default: null },
    title: { default: void 0 },
    tooltip: { type: Boolean, default: !1 },
    variant: { default: null },
    teleportDisabled: { default: !1 },
    teleportTo: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["hidden", "hide", "hide-prevented", "show", "show-prevented", "shown"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BPopover"), s = e, r = _e(a, "modelValue"), u = z(r.value), i = z(r.value);
    Pt(() => {
      r.value = u.value;
    }), fe(r, (U) => {
      U !== u.value && (U ? E() : D(new Event("update:modelValue")));
    });
    const d = we(() => t.id, "popover"), f = z(!1), c = z(null), y = z(null), p = z(null), b = z(null), h = z(null), w = _(
      () => t.title ? xt(t.title, $t) : ""
    ), v = _(
      () => t.content ? xt(t.content, $t) : ""
    ), B = k(() => t.placement.startsWith("auto")), g = he(() => t.offset ?? NaN), S = _(
      () => t.boundary === "document" || t.boundary === "viewport" ? void 0 : t.boundary
    ), C = _(
      () => t.boundary === "document" || t.boundary === "viewport" ? t.boundary : void 0
    ), x = z({}), V = _(() => {
      if (t.floatingMiddleware !== void 0)
        return t.floatingMiddleware;
      const U = t.offset !== null ? g.value : t.tooltip ? 6 : 8, ne = [Yl(U)];
      return t.noFlip === !1 && !B.value && ne.push(
        so({
          boundary: S.value,
          rootBoundary: C.value,
          padding: t.boundaryPadding
        })
      ), B.value && ne.push(
        xs({
          alignment: t.placement.split("-")[1] || void 0,
          boundary: S.value,
          rootBoundary: C.value,
          padding: t.boundaryPadding
        })
      ), t.noShift === !1 && ne.push(
        no({
          boundary: S.value,
          rootBoundary: C.value,
          padding: t.boundaryPadding
        })
      ), t.noHide === !1 && ne.push(
        Ss({
          boundary: S.value,
          rootBoundary: C.value,
          padding: t.boundaryPadding
        })
      ), t.inline === !0 && ne.push(As()), ne.push(Ps({ element: p, padding: 10 })), t.noSize === !1 && ne.push(
        ro({
          boundary: S.value,
          rootBoundary: C.value,
          padding: t.boundaryPadding,
          apply({ availableWidth: pe, availableHeight: Y }) {
            x.value = {
              maxHeight: Y ? `${Y}px` : void 0,
              maxWidth: pe ? `${pe}px` : void 0
            };
          }
        })
      ), ne;
    }), q = k(
      () => B.value ? void 0 : t.placement
    ), { floatingStyles: G, middlewareData: O, placement: Z, update: ae } = uo(y, c, {
      placement: q,
      middleware: V,
      strategy: k(() => t.strategy),
      whileElementsMounted: (...U) => oo(...U, { animationFrame: t.realtime })
    }), ie = z({ position: "absolute" });
    fe(O, () => {
      var U;
      if (t.noHide === !1 && ((U = O.value.hide) != null && U.referenceHidden ? f.value = !0 : f.value = !1), O.value.arrow) {
        const { x: ne, y: pe } = O.value.arrow;
        ie.value = {
          position: "absolute",
          top: pe ? `${pe}px` : "",
          left: ne ? `${ne}px` : ""
        };
      }
    });
    const X = _(() => {
      const U = t.tooltip ? "tooltip" : "popover";
      return [
        U,
        `b-${U}`,
        {
          [`b-${U}-${t.variant}`]: t.variant !== null,
          show: u.value && !f.value,
          "pe-none": !u.value,
          fade: !t.noFade,
          "d-none": !u.value && t.noFade,
          [`${t.customClass}`]: t.customClass !== void 0,
          [`bs-${U}-${_r(Z.value)}`]: Z.value !== void 0
        }
      ];
    }), { isOutside: j } = kl(c), { isOutside: T } = kl(b), N = (U) => {
      const ne = U ?? new Event("click");
      u.value ? D(ne) : E();
    }, F = (U, ne = {}) => new wt(U, {
      cancelable: !1,
      target: c.value || null,
      relatedTarget: null,
      trigger: null,
      ...ne,
      componentId: d.value
    });
    let W;
    const E = () => {
      const U = F("show", { cancelable: !0 });
      if (s("show", U), U.defaultPrevented) {
        s("show-prevented");
        return;
      }
      i.value = !0, Ne(() => {
        var ne;
        ae(), W = setTimeout(
          () => {
            ae(), u.value = !0, Ne(() => {
              s("shown", F("shown"));
            });
          },
          typeof t.delay == "number" ? t.delay : ((ne = t.delay) == null ? void 0 : ne.show) || 0
        );
      });
    }, D = (U) => {
      var Y;
      const ne = F("hide", { cancelable: !0 });
      if (s("hide", ne), ne.defaultPrevented) {
        s("hide-prevented");
        return;
      }
      W && (clearTimeout(W), W = void 0);
      const pe = typeof t.delay == "number" ? t.delay : ((Y = t.delay) == null ? void 0 : Y.hide) || 0;
      setTimeout(() => {
        var de, oe;
        (U == null ? void 0 : U.type) === "click" || (U == null ? void 0 : U.type) === "forceHide" || (U == null ? void 0 : U.type) === "update:modelValue" && t.manual || !t.noninteractive && j.value && T.value && !((de = c.value) != null && de.contains(document == null ? void 0 : document.activeElement)) && !((oe = b.value) != null && oe.contains(document == null ? void 0 : document.activeElement)) || t.noninteractive && T.value ? (u.value = !1, Ne(() => {
          setTimeout(
            () => {
              i.value = !1;
            },
            c.value ? xa(c.value) : 150
          ), s("hidden", F("hidden"));
        })) : setTimeout(
          () => {
            D(U);
          },
          pe < 50 ? 50 : pe
        );
      }, pe);
    };
    o({
      hide: D,
      show: E,
      toggle: N
    });
    const te = () => {
      var U;
      if (t.target) {
        const ne = gt(t.target);
        ne ? b.value = ne : console.warn("Target element not found", t.target);
      } else
        b.value = (U = h.value) == null ? void 0 : U.nextElementSibling;
      if (t.reference) {
        const ne = gt(t.reference);
        ne ? y.value = ne : console.warn("Reference element not found", t.reference);
      } else
        y.value = b.value;
      if (!(!b.value || t.manual) && ja) {
        if (b.value.addEventListener("forceHide", D), t.click) {
          b.value.addEventListener("click", N);
          return;
        }
        b.value.addEventListener("pointerenter", E), b.value.addEventListener("pointerleave", D), b.value.addEventListener("focus", E), b.value.addEventListener("blur", D);
      }
    }, re = () => {
      b.value && (b.value.removeEventListener("forceHide", D), b.value.removeEventListener("click", N), b.value.removeEventListener("pointerenter", E), b.value.removeEventListener("pointerleave", D), b.value.removeEventListener("focus", E), b.value.removeEventListener("blur", D));
    };
    return yo(
      c,
      () => {
        u.value && t.click && !t.noAutoClose && !t.manual && D(new Event("clickOutside"));
      },
      { ignore: [b] }
    ), fe([() => t.click, () => t.target, () => t.reference], () => {
      re(), te();
    }), Ue(te), Ra(re), (U, ne) => (m(), A(ve, null, [
      Q("span", {
        id: n(d) + "_placeholder",
        ref_key: "placeholder",
        ref: h
      }, null, 8, br),
      $(U.$slots, "target", {
        show: E,
        hide: D,
        toggle: N,
        showState: u.value
      }),
      (m(), P(_t, {
        to: n(t).teleportTo,
        disabled: !n(t).teleportTo || n(t).teleportDisabled
      }, [
        i.value || n(t).persistent ? (m(), A("div", K({
          key: 0,
          id: n(d)
        }, U.$attrs, {
          ref_key: "element",
          ref: c,
          class: X.value,
          role: "tooltip",
          tabindex: "-1",
          style: n(G)
        }), [
          Q("div", {
            ref_key: "arrow",
            ref: p,
            class: R(`${n(t).tooltip ? "tooltip" : "popover"}-arrow`),
            style: Le(ie.value),
            "data-popper-arrow": ""
          }, null, 6),
          Q("div", {
            class: "overflow-auto",
            style: Le(x.value)
          }, [
            n(t).title || U.$slots.title ? (m(), A(ve, { key: 0 }, [
              n(t).html ? (m(), A("div", {
                key: 1,
                class: R(["position-sticky top-0", n(t).tooltip ? "tooltip-inner" : "popover-header"]),
                innerHTML: w.value
              }, null, 10, gr)) : (m(), A("div", {
                key: 0,
                class: R(["position-sticky top-0", n(t).tooltip ? "tooltip-inner" : "popover-header"])
              }, [
                $(U.$slots, "title", {}, () => [
                  ue(J(n(t).title), 1)
                ])
              ], 2))
            ], 64)) : ee("", !0),
            n(t).tooltip && !U.$slots.title && !n(t).title || !n(t).tooltip ? (m(), A(ve, { key: 1 }, [
              n(t).html ? (m(), A("div", {
                key: 1,
                class: R(n(t).tooltip ? "tooltip-inner" : "popover-body"),
                innerHTML: v.value
              }, null, 10, hr)) : (m(), A("div", {
                key: 0,
                class: R(n(t).tooltip ? "tooltip-inner" : "popover-body")
              }, [
                $(U.$slots, "default", {}, () => [
                  ue(J(n(t).content), 1)
                ])
              ], 2))
            ], 64)) : ee("", !0)
          ], 4)
        ], 16, yr)) : ee("", !0)
      ], 8, ["to", "disabled"]))
    ], 64));
  }
}), Br = ({
  top: a,
  end: o,
  start: e,
  alignCenter: l,
  alignEnd: t
}) => {
  const s = a ? "top" : e ? "left" : o ? "right" : "bottom", r = t ? "end" : l ? null : "start";
  return `${s}${r ? `-${r}` : ""}`;
}, _r = (a) => {
  const [o] = a.split("-");
  switch (o) {
    case "left":
      return "start";
    case "right":
      return "end";
    default:
      return o;
  }
}, Rt = (a) => typeof a != "object" || a.active !== !1, da = (a, o) => {
  if (!Rt(a))
    return {};
  const l = typeof a > "u" || typeof a == "object" && !a.title && !a.content, t = o.getAttribute("title") || o.getAttribute("data-original-title");
  return l ? t ? (o.removeAttribute("title"), o.setAttribute("data-original-title", t), {
    content: xt(t, $t)
  }) : {} : typeof a == "string" ? {
    content: xt(a, $t)
  } : {
    title: a != null && a.title ? xt(a == null ? void 0 : a.title, $t) : void 0,
    content: a != null && a.content ? xt(a == null ? void 0 : a.content, $t) : void 0
  };
}, ca = (a, o) => ({
  target: o,
  modelValue: a.modifiers.show,
  inline: a.modifiers.inline,
  click: a.modifiers.click,
  realtime: a.modifiers.realtime,
  persistent: a.modifiers.persistent,
  placement: a.modifiers.left ? "left" : a.modifiers.right ? "right" : a.modifiers.bottom ? "bottom" : a.modifiers.top ? "top" : void 0,
  html: !0,
  ...typeof a.value == "object" ? a.value : {},
  ...a.modifiers.interactive ? { noninteractive: !1 } : {},
  title: null,
  content: null
}), fa = (a, o, e) => {
  var t;
  const l = document.createElement("span");
  o.modifiers.body ? document.body.appendChild(l) : o.modifiers.child ? a.appendChild(l) : (t = a.parentNode) == null || t.insertBefore(l, a.nextSibling), jl(Ie(el, e), l), a.$__element = l;
}, pa = (a) => {
  const o = a.$__element;
  o && jl(null, o), setTimeout(() => {
    o == null || o.remove();
  }, 0), delete a.$__element;
}, ho = (a, o, e) => {
  const l = Ee(a, o);
  return e && typeof e == "function" ? e(l, o, a) : l;
}, Qt = (a, o, e, l = e) => o.reduce((t, s) => (a[s] && t.push(
  [l, s.replace(e, ""), a[s]].filter((r) => r && typeof r != "boolean").join("-").toLowerCase()
), t), []), gt = (a) => {
  if (a)
    return typeof a == "string" ? typeof document > "u" ? void 0 : document.getElementById(a) ?? document.querySelector(a) ?? void 0 : a.$el ?? a;
}, wr = (a, o) => ((a == null ? void 0 : a()) ?? []).reduce((e, l) => (typeof l.type == "symbol" ? e = e.concat(l.children) : e.push(l), e), []).filter((e) => {
  var l;
  return ((l = e.type) == null ? void 0 : l.__name) === o;
}), Bo = /_/g, _o = /([a-z])([A-Z])/g, Cr = /^[0-9]*\.?[0-9]+$/, kr = /(\s|^)(\w)/g, Tr = /(\s|^)(\w)/, ea = /\s+/, $r = /^#/, xr = /^#[A-Za-z]+[\w\-:.]*$/, Sr = /[-/\\^$*+?.()|[\]{}]/g, Vr = /[\s\uFEFF\xA0]+/g, Ca = (a) => a.replace(Bo, " ").replace(_o, (o, e, l) => `${e} ${l}`).replace(Tr, (o, e, l) => e + l.toUpperCase()), Tl = (a) => a.replace(Bo, " ").replace(_o, (o, e, l) => `${e} ${l}`).replace(kr, (o, e, l) => e + l.toUpperCase()), Ar = (a) => {
  const o = a.trim();
  return o.charAt(0).toUpperCase() + o.slice(1);
}, Or = (a) => a.replace(Sr, "\\$&"), Ir = (a) => Or(a).replace(Vr, "\\s"), ta = (a) => typeof a == "string" ? Tl(a) : a.label !== void 0 ? a.label : typeof a.key == "string" ? Tl(a.key) : a.key, Pr = (a) => !!(a.href || a.to), wo = Symbol("bvn::carousel"), Co = Symbol("bvn::tabs"), ko = Symbol("bvn::progress"), To = Symbol("bvn::listGroup"), $o = Symbol("bvn::avatarGroup"), xo = Symbol("bvn::accordion"), So = Symbol("bvn::checkboxGroup"), Vo = Symbol("bvn::radioGroup"), tl = Symbol("bvn::collapse"), Ao = Symbol("bvn::collapse"), al = Symbol("bvn::navbar"), Oo = Symbol("bvn::toastPlugin"), Io = Symbol("bvn::rtlPlugin"), Po = Symbol("bvn::breadcrumbPlugin"), No = Symbol("bvn::modalControllerPlugin"), Eo = Symbol("bvn::modalManagerPlugin"), Fo = Symbol("bvn::idPluginKey"), aa = Symbol("bvn::defaults"), Lo = Symbol("bvn::inputGroup"), Lt = (a, o = {}, e = {}) => {
  const l = [a];
  let t;
  for (let s = 0; s < l.length && !t; s++) {
    const r = l[s];
    t = e[r];
  }
  return t && typeof t == "function" ? t(o) : t;
}, ha = (a, o) => Object.keys(a).filter((e) => !o.map((l) => l.toString()).includes(e)).reduce((e, l) => ({ ...e, [l]: a[l] }), {}), ll = (a, o) => [...o].reduce(
  (e, l) => (e[l] = a[l], e),
  {}
), Ee = (a, o, e) => {
  const l = o.split(/[.[\]]/g);
  let t = a;
  for (const s of l) {
    if (t === null || t === void 0)
      return e;
    s.trim() !== "" && (t = t[s]);
  }
  return t === void 0 ? e : t;
}, Nr = (a, o, e) => {
  const l = (i) => {
    if (((c) => c == null || typeof c != "object" && typeof c != "function")(i))
      return i;
    if (typeof i == "function")
      return i.bind({});
    const f = new i.constructor();
    return Object.getOwnPropertyNames(i).forEach((c) => {
      f[c] = i[c];
    }), f;
  }, t = (i, d) => {
    const f = d === void 0 ? 0 : d;
    if (i == null)
      return f;
    const c = Number.parseInt(i);
    return Number.isNaN(c) ? f : c;
  };
  if (!a)
    return {};
  if (!o || e === void 0)
    return a;
  const s = o.split(/[.[\]]/g).filter((i) => !!i.trim()), r = (i) => {
    if (s.length > 1) {
      const d = s.shift(), f = t(s[0], null) !== null;
      i[d] = i[d] === void 0 ? f ? [] : {} : i[d], r(i[d]);
    } else
      i[s[0]] = e;
  }, u = l(a);
  return r(u), u;
}, va = (a, o) => {
  const { all: e, ...l } = a, t = {};
  e && o.forEach((r) => {
    t[r] = e;
  });
  const s = { ...t, ...l };
  return Object.entries(s).filter(([r, u]) => !!u && o.includes(r)).map(([r]) => r);
}, $l = (a, o) => o + (a ? Ar(a) : ""), Ct = (a, o) => {
  const e = k(o), l = k(a), t = k(() => Pr(l.value)), s = _(
    () => t.value ? ll(
      l.value,
      e.value ?? [
        "active",
        "activeClass",
        "append",
        "href",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "variant",
        "opacity",
        "opacityHover",
        "underlineVariant",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover"
      ]
    ) : {}
  );
  return { computedLink: t, computedLinkProps: s };
}, zo = () => ({ ...Ve(Po) }), Er = (a = {}) => {
  const o = a.persist ?? !1, e = "data-bs-theme", l = "body";
  return rr({
    attribute: e,
    selector: l,
    storageKey: o === !0 ? `bv-color-${a.attribute ?? e}-${a.selector ?? l}` : null,
    ...a
  });
}, ot = (a) => _(() => {
  let o = Se(a);
  return o = {
    ...o,
    variant: o.variant ?? null,
    bgVariant: o.bgVariant ?? null,
    textVariant: o.textVariant ?? null
  }, {
    [`text-bg-${o.variant}`]: o.variant !== null,
    [`text-${o.textVariant}`]: o.textVariant !== null && o.variant === null,
    [`bg-${o.bgVariant}`]: o.bgVariant !== null && o.variant === null
  };
}), Fr = (a) => _(() => {
  const o = Se(a);
  return {
    container: o === !0,
    [`container-${o}`]: typeof o == "string"
  };
}), Ho = (a, o = z(1e3), e = {}) => {
  const l = Ye(k(a)), t = Ye(k(o)), s = z(!1), r = z(0), u = k(() => Math.ceil(l.value / t.value)), i = k(
    () => c.value || s.value ? Math.round(l.value - r.value * t.value) : 0
  ), { pause: d, resume: f, isActive: c } = bo(
    () => {
      r.value = r.value + 1;
    },
    o,
    e
  ), y = () => {
    s.value = !1, r.value = 0, f();
  }, p = () => {
    s.value = !1, r.value = u.value;
  };
  Pt(() => {
    r.value > u.value && (r.value = u.value), r.value === u.value && d();
  }), fe([t, l], () => {
    p(), y();
  });
  const b = () => {
    c.value !== !1 && (s.value = !0, d());
  }, h = () => {
    r.value !== u.value && (s.value = !1, f());
  };
  return {
    isActive: Ye(c),
    isPaused: Ye(s),
    restart: y,
    stop: p,
    pause: b,
    resume: h,
    value: i
  };
};
function Lr(a, o = Mo("injectSelf")) {
  const { provides: e } = o;
  if (e && a in e)
    return e[a];
}
function Mo(a, o) {
  const e = Bt();
  if (!e)
    throw new Error(`[Bvn] ${a} ${o || "must be called from inside a setup function"}`);
  return e;
}
const zr = (a = "") => a.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase(), xl = (a) => a !== null && typeof a == "object" && !Array.isArray(a);
function Ro(a = {}, o = {}, e) {
  const l = {};
  for (const t in a)
    l[t] = a[t];
  for (const t in o) {
    const s = a[t], r = o[t];
    if (xl(s) && xl(r)) {
      l[t] = Ro(s, r, e);
      continue;
    }
    if (Array.isArray(s) && Array.isArray(r) && e) {
      l[t] = e(s, r);
      continue;
    }
    l[t] = r;
  }
  return l;
}
const Hr = (a, o) => {
  var e, l;
  return typeof ((e = a.props) == null ? void 0 : e[o]) < "u" || typeof ((l = a.props) == null ? void 0 : l[zr(o)]) < "u";
};
function Mr(a = {}, o) {
  const e = Ve(aa, z({})), l = Mo("useDefaults");
  if (o = o ?? l.type.name ?? l.type.__name, !o)
    throw new Error("[Bvn] Could not determine component name");
  const t = _(() => {
    var i;
    return (i = e.value) == null ? void 0 : i[a._as ?? o];
  }), s = new Proxy(a, {
    get(i, d) {
      var c, y, p, b;
      const f = Reflect.get(i, d);
      return d === "class" || d === "style" ? [(c = t.value) == null ? void 0 : c[d], f].filter((h) => h != null) : typeof d == "string" && !Hr(l.vnode, d) ? ((y = t.value) == null ? void 0 : y[d]) ?? ((b = (p = e.value) == null ? void 0 : p.global) == null ? void 0 : b[d]) ?? f : f;
    }
  }), r = bt();
  Pt(() => {
    if (t.value) {
      const i = Object.entries(t.value).filter(
        ([d]) => d.startsWith(d[0].toUpperCase())
      );
      r.value = i.length ? Object.fromEntries(i) : void 0;
    } else
      r.value = void 0;
  });
  function u() {
    const i = Lr(aa, l);
    Xe(
      aa,
      _(
        () => r.value ? Ro((i == null ? void 0 : i.value) ?? {}, r.value) : i == null ? void 0 : i.value
      )
    );
  }
  return { props: s, provideSubDefaults: u };
}
function M(a, o) {
  const { props: e, provideSubDefaults: l } = Mr(a, o);
  return l(), e;
}
const kt = (a) => _(() => {
  const o = Se(a);
  return o === !0 ? "is-valid" : o === !1 ? "is-invalid" : null;
}), Do = (a) => _(() => {
  const o = Se(a);
  return {
    "form-check": o.plain === !1 && o.button === !1 && o.hasDefaultSlot,
    "form-check-reverse": o.reverse === !0,
    "form-check-inline": o.inline === !0,
    "form-switch": o.switch === !0,
    [`form-control-${o.size}`]: o.size !== void 0 && o.size !== "md" && o.button === !1
  };
}), jo = (a) => {
  const o = k(a), e = kt(() => o.value.state ?? null);
  return _(() => [
    e.value,
    {
      "form-check-input": o.value.plain === !1 && o.value.button === !1,
      "btn-check": o.value.button === !0
    }
  ]);
}, Go = (a) => _(() => {
  const o = Se(a);
  return {
    "form-check-label": o.plain === !1 && o.button === !1,
    btn: o.button === !0,
    [`btn-${o.buttonVariant}`]: o.button === !0 && o.buttonVariant !== void 0 && o.buttonVariant !== null,
    [`btn-${o.size}`]: o.button && o.size && o.size !== "md"
  };
}), Wo = (a) => {
  const o = k(a), e = ba(
    () => o.value.ariaInvalid,
    () => o.value.state
  );
  return _(() => ({
    "aria-invalid": e.value,
    "aria-required": o.value.required === !0 ? !0 : void 0
  }));
}, qo = (a) => _(() => {
  const o = Se(a);
  return {
    "was-validated": o.validated === !0,
    "btn-group": o.buttons === !0 && o.stacked === !1,
    "btn-group-vertical": o.stacked === !0 && o.buttons === !0,
    [`btn-group-${o.size}`]: o.size !== void 0
  };
}), we = (a, o) => _(() => Se(a) || Rr(o)), Rr = (a = "") => `__BVID__${Ve(Fo, () => Math.random().toString().slice(2, 8))()}___BV_${a}__`, Uo = (a, o, e) => {
  const l = z(null), t = we(() => a.id, "input"), s = he(() => a.debounce ?? 0), r = he(() => a.debounceMaxWait ?? NaN), u = Ks(
    (v) => {
      o.value = v;
    },
    () => e.lazy === !0 ? 0 : s.value,
    { maxWait: () => e.lazy === !0 ? NaN : r.value }
  ), i = (v, B = !1) => {
    e.lazy === !0 && B === !1 || u(v);
  }, { focused: d } = Fe(l, {
    initialValue: a.autofocus
  }), f = (v, B, g = !1) => a.formatter !== void 0 && (!a.lazyFormatter || g) ? a.formatter(v, B) : v;
  Ue(() => {
    var v;
    l.value && (l.value.value = ((v = o.value) == null ? void 0 : v.toString()) ?? "");
  }), Pn(() => {
    Ne(() => {
      a.autofocus && (d.value = !0);
    });
  });
  const c = ba(
    () => a.ariaInvalid,
    () => a.state
  );
  return {
    input: l,
    computedId: t,
    computedAriaInvalid: c,
    onInput: (v) => {
      const { value: B } = v.target, g = f(B, v);
      if (v.defaultPrevented) {
        v.preventDefault();
        return;
      }
      i(g);
    },
    onChange: (v) => {
      const { value: B } = v.target, g = f(B, v);
      if (v.defaultPrevented) {
        v.preventDefault();
        return;
      }
      const S = g;
      o.value !== S && i(g, !0);
    },
    onBlur: (v) => {
      if (!e.lazy && !a.lazyFormatter)
        return;
      const { value: B } = v.target, g = f(B, v, !0), S = g;
      o.value !== S && i(g, !0);
    },
    focus: () => {
      a.disabled || (d.value = !0);
    },
    blur: () => {
      a.disabled || (d.value = !1);
    }
  };
}, Xo = (a, o) => {
  const e = (r) => typeof r == "object" && r !== null && "label" in r, l = (r) => {
    if (typeof r == "string")
      return { value: r, text: r };
    if (typeof r == "number")
      return { value: r, text: `${r}` };
    if (r instanceof Date)
      return { value: r, text: r.toLocaleString() };
    const u = Ee(r, o.valueField), i = Ee(r, o.textField), d = Ee(r, o.htmlField), f = Ee(r, o.disabledField), c = o.optionsField ? Ee(r, o.optionsField) : void 0;
    return c !== void 0 ? {
      label: Ee(r, o.labelField) || i,
      options: c
    } : {
      value: u,
      text: i,
      html: d,
      disabled: f
    };
  }, t = (r) => r.map((u) => l(u));
  return { normalizedOptions: _(() => t(Se(a))), isComplex: e };
}, ka = "modal-open", ol = () => {
  const a = Ve(Eo), o = (l) => {
    a == null || a.removeStack(l), a == null || a.removeRegistry(l);
  }, e = Ja("updateHTMLAttrs", (l, t, s) => {
    const r = typeof l == "string" ? window == null ? void 0 : window.document.querySelector(l) : Ge(l);
    r && (t === "class" ? r.classList.toggle(ka, s === ka) : r.setAttribute(t, s));
  });
  return dt(() => {
    e("body", "class", "");
  }), fe(
    () => a == null ? void 0 : a.countStack.value,
    (l) => {
      l !== void 0 && e("body", "class", l > 0 ? ka : "");
    }
  ), {
    ...a,
    dispose: o
  };
}, Dr = (a) => {
  const { pushRegistry: o, pushStack: e, removeStack: l, stack: t, dispose: s, countStack: r } = ol(), u = Bt();
  if (!u || u.type.__name !== "BModal")
    throw new Error("useModalManager must only use in BModal component");
  return o == null || o(u), dt(() => {
    s(u);
  }), fe(
    a,
    (i, d) => {
      i ? e == null || e(u) : d && !i && (l == null || l(u));
    },
    { immediate: !0 }
  ), {
    activePosition: _(
      () => t == null ? void 0 : t.value.findIndex((i) => {
        var d, f;
        return ((d = i.exposed) == null ? void 0 : d.id) === ((f = u.exposed) == null ? void 0 : f.id);
      })
    ),
    activeModalCount: r
  };
}, jr = (a = void 0) => {
  const { registry: o } = ol(), e = Bt(), l = (r) => r.parent ? r.parent.type.__name === "BModal" ? r.parent : l(r.parent) : null, t = _(() => {
    const r = Se(a);
    return r ? (o == null ? void 0 : o.value.find((u) => {
      var i;
      return ((i = u.exposed) == null ? void 0 : i.id.value) === r;
    })) || null : e ? l(e) : null;
  }), s = k(() => {
    var r;
    return (r = t.value) == null ? void 0 : r.proxy;
  });
  return {
    show() {
      var r, u;
      (u = (r = t.value) == null ? void 0 : r.exposed) == null || u.show();
    },
    hide(r = "") {
      var u, i;
      (i = (u = t.value) == null ? void 0 : u.exposed) == null || i.hide(r);
    },
    modal: s
  };
}, Ko = () => {
  const { lastStack: a, stack: o } = ol();
  return {
    ...Ve(No),
    hide: (s = "") => {
      var r;
      a != null && a.value && ((r = a == null ? void 0 : a.value.exposed) == null || r.hide(s));
    },
    hideAll: (s = "") => {
      o == null || o.value.forEach((r) => {
        var u;
        (u = r.exposed) == null || u.hide(s);
      });
    }
    // Todo: Supports listening events globally in the future
  };
}, ma = (a, o = "px") => _(() => {
  const e = Se(a), l = Se(o);
  return Cr.test(String(e)) ? `${Number(e)}${l}` : e;
}), nl = (a) => {
  const o = (e, l) => {
    const t = l === null ? "" : `${l}-`;
    return e === "circle" ? `${t}rounded-circle` : e === "pill" ? `${t}rounded-pill` : typeof e == "number" || e === "0" || e === "1" || e === "2" || e === "3" || e === "4" || e === "5" ? `${t}rounded-${e}` : e === "none" ? `${t}rounded-0` : e === "sm" ? `${t}rounded-1` : e === "lg" ? `${t}rounded-5` : `${t}rounded`;
  };
  return _(() => {
    const e = Se(a);
    return {
      [`${o(e.rounded, null)}`]: !!e.rounded,
      [`${o(e.roundedTop, "top")}`]: !!e.roundedTop,
      [`${o(e.roundedBottom, "bottom")}`]: !!e.roundedBottom,
      [`${o(e.roundedStart, "start")}`]: !!e.roundedStart,
      [`${o(e.roundedEnd, "end")}`]: !!e.roundedEnd
    };
  });
}, Gr = () => {
  const a = Ve(Io);
  return Ue(() => {
    fe(
      [() => a == null ? void 0 : a.isRtl.value, () => a == null ? void 0 : a.locale.value],
      ([o, e]) => {
        const l = document.documentElement;
        l.setAttribute("dir", o ?? !1 ? "rtl" : "ltr"), l.setAttribute("lang", e ?? "");
      },
      { immediate: !0 }
    );
  }), { ...a };
}, Yo = (a, o) => {
  const e = Ye(k(a)), l = Ye(k(o)), t = k(() => !l.value);
  Ue(() => {
    const s = pr(
      document.body,
      e.value && t.value
    );
    fe([e, t], ([r, u]) => {
      s.value = r && u;
    });
  });
}, Zo = (a, o, e = {}) => {
  const l = k(a), t = k(o), s = z(gt(l.value)), r = z(gt(t.value));
  fe([l, t], () => {
    B();
  });
  const {
    contentQuery: u = ":scope > [id]",
    targetQuery: i = "[href]",
    manual: d = !1,
    root: f,
    rootMargin: c = "0px 0px -25%",
    threshold: y = [0.1, 0.5, 1],
    watchChanges: p = !0
  } = e, b = z(null), h = z([]), w = z([]);
  Bt() ? Ue(() => {
    Ia(l, s, {
      transform: {
        ltr: (O) => gt(O)
      },
      direction: "ltr",
      immediate: !0
    }), Ia(t, r, {
      transform: {
        ltr: (O) => gt(O)
      },
      direction: "ltr",
      immediate: !0
    }), B();
  }) : Ne(() => {
    B();
  });
  const B = () => {
    w.value = s.value ? Array.from(s.value.querySelectorAll(u)) : [], h.value = w.value.map((O) => ({
      id: O.id,
      el: O,
      visible: !1,
      text: O.textContent
    }));
  };
  let g = !0, S = 0;
  const C = _(
    () => s.value && getComputedStyle(s.value).overflowY === "visible" ? null : s.value
  ), x = ur(
    w,
    (O) => {
      var ie, X, j, T;
      const Z = (ie = C.value || (document == null ? void 0 : document.documentElement)) == null ? void 0 : ie.scrollTop;
      g = Z > S, S = Z, O.forEach((N) => {
        if (N.isIntersecting) {
          h.value.forEach((F) => {
            F.el === N.target && (F.visible = !0);
          });
          return;
        }
        h.value.forEach((F) => {
          F.el === N.target && (F.visible = !1);
        });
      });
      let ae = null;
      g ? ae = ((X = [...h.value].reverse().find((N) => N.visible)) == null ? void 0 : X.id) || null : ae = ((j = h.value.find((N) => N.visible)) == null ? void 0 : j.id) || null, ae !== null && (b.value = ae), b.value || (b.value = ((T = h.value[0]) == null ? void 0 : T.id) || null);
    },
    {
      root: f ? gt(f) : C,
      rootMargin: c,
      threshold: y
    }
  );
  fe(b, (O) => {
    var X;
    if (d)
      return;
    const Z = (X = r.value) == null ? void 0 : X.querySelectorAll(i);
    if (Z === void 0)
      return;
    let ae = !1, ie = null;
    Z.forEach((j) => {
      var N, F, W, E, D, te, re, U, ne, pe, Y;
      const T = j.closest(".dropdown");
      if ((N = j.getAttribute("href")) != null && N.includes(`#${O}`)) {
        ie = j, j.classList.add("active"), T && ((F = T == null ? void 0 : T.querySelector(".dropdown-toggle")) == null || F.classList.add("active"), ae = !0);
        let de = (W = j.closest(".nav")) == null ? void 0 : W.previousSibling;
        for (; (E = de == null ? void 0 : de.classList) != null && E.contains("nav-item"); )
          ae = !0, (D = de.querySelector(".nav-link")) == null || D.classList.add("active"), de = (te = de.closest(".nav")) == null ? void 0 : te.previousSibling;
      } else if (j.classList.remove("active"), T && !ae && ((re = T == null ? void 0 : T.querySelector(".dropdown-toggle")) == null || re.classList.remove("active")), !ae) {
        let de = (U = j.closest(".nav")) == null ? void 0 : U.previousSibling;
        for (; (ne = de == null ? void 0 : de.classList) != null && ne.contains("nav-item"); )
          ae = !0, de.querySelector(".nav-link") !== ie && ((pe = de.querySelector(".nav-link")) == null || pe.classList.remove("active")), de = (Y = de.closest(".nav")) == null ? void 0 : Y.previousSibling;
      }
    });
  });
  const V = p ? ir(
    s,
    () => {
      B();
    },
    {
      childList: !0
    }
  ) : { stop: () => {
  } }, q = (O, Z = !1) => {
    var X, j;
    O.preventDefault();
    const ae = (j = (X = O.target) == null ? void 0 : X.getAttribute) == null ? void 0 : j.call(X, "href"), ie = ae ? document == null ? void 0 : document.querySelector(ae) : null;
    ie && s.value && (s.value.scrollTo ? s.value.scrollTo({ top: ie.offsetTop, behavior: Z ? "smooth" : "auto" }) : s.value.scrollTop = ie.offsetTop);
  }, G = () => {
    x.stop(), V.stop();
  };
  return {
    current: Ye(b),
    list: h,
    content: s,
    target: r,
    scrollIntoView: q,
    updateList: B,
    cleanup: G
  };
}, Jo = () => ({ ...Ve(Oo) }), Et = /* @__PURE__ */ L({
  __name: "BTransition",
  props: {
    appear: { type: Boolean, default: !1 },
    mode: { default: void 0 },
    noFade: { type: Boolean, default: !1 },
    transProps: { default: void 0 }
  },
  emits: ["after-appear", "after-enter", "after-leave", "appear", "before-appear", "before-enter", "before-leave", "enter", "appear-cancelled", "enter-cancelled", "leave", "leave-cancelled"],
  setup(a, { emit: o }) {
    const l = M(a, "BTransition"), t = o, s = _(() => {
      const u = {
        name: "",
        enterActiveClass: "",
        enterToClass: "",
        leaveActiveClass: "",
        leaveToClass: "showing",
        enterFromClass: "showing",
        leaveFromClass: ""
      }, i = {
        ...u,
        enterActiveClass: "fade showing",
        leaveActiveClass: "fade showing"
      };
      return l.noFade ? u : i;
    }), r = _(() => ({ mode: l.mode, css: !0, ...s.value }));
    return (u, i) => (m(), P(Nn, K({ ...r.value, ...n(l).transProps }, {
      appear: n(l).appear,
      onAfterAppear: i[0] || (i[0] = (d) => t("after-appear", d)),
      onAfterEnter: i[1] || (i[1] = (d) => t("after-enter", d)),
      onAfterLeave: i[2] || (i[2] = (d) => t("after-leave", d)),
      onAppear: i[3] || (i[3] = (d) => t("appear", d)),
      onBeforeAppear: i[4] || (i[4] = (d) => t("before-appear", d)),
      onBeforeEnter: i[5] || (i[5] = (d) => t("before-enter", d)),
      onBeforeLeave: i[6] || (i[6] = (d) => t("before-leave", d)),
      onEnter: i[7] || (i[7] = (d) => t("enter", d)),
      onAppearCancelled: i[8] || (i[8] = (d) => t("appear-cancelled", d)),
      onEnterCancelled: i[9] || (i[9] = (d) => t("enter-cancelled", d)),
      onLeave: i[10] || (i[10] = (d) => t("leave", d)),
      onLeaveCancelled: i[11] || (i[11] = (d) => t("leave-cancelled", d))
    }), {
      default: I(() => [
        $(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["appear"]));
  }
}), Wr = ["type", "disabled", "aria-label"], Ft = /* @__PURE__ */ L({
  __name: "BCloseButton",
  props: {
    ariaLabel: { default: "Close" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BCloseButton"), t = o;
    return (s, r) => (m(), A("button", {
      type: n(l).type,
      class: "btn-close",
      disabled: n(l).disabled,
      "aria-label": n(l).ariaLabel,
      onClick: r[0] || (r[0] = (u) => t("click", u))
    }, null, 8, Wr));
  }
}), Sl = "active", st = /* @__PURE__ */ L({
  __name: "BLink",
  props: {
    active: { type: Boolean, default: void 0 },
    activeClass: { default: "router-link-active" },
    disabled: { type: Boolean, default: !1 },
    exactActiveClass: { default: "router-link-exact-active" },
    href: { default: void 0 },
    icon: { type: Boolean, default: !1 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: !1 },
    routerComponentName: { default: "router-link" },
    routerTag: { default: "a" },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: null },
    variant: { default: null }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BLink"), t = o, s = Dt(), r = Ve(tl, null), u = Ve(al, null), i = Bt(), d = _(() => {
      const h = l.routerComponentName.split("-").map((v) => v.charAt(0).toUpperCase() + v.slice(1)).join("");
      return !((i == null ? void 0 : i.appContext.app.component(h)) !== void 0) || l.disabled || !l.to ? "a" : l.routerComponentName;
    }), f = _(() => {
      const h = "#";
      if (l.href)
        return l.href;
      if (typeof l.to == "string")
        return l.to || h;
      const { to: w } = l;
      if (w !== void 0 && "path" in w) {
        const v = w.path || "", B = w.query ? `?${Object.keys(w.query).map((S) => {
          var C;
          return `${S}=${(C = w.query) == null ? void 0 : C[S]}`;
        }).join("=")}` : "", g = !w.hash || w.hash.charAt(0) === "#" ? w.hash || "" : `#${w.hash}`;
        return `${v}${B}${g}` || h;
      }
      return h;
    }), c = _(() => ({
      [`link-${l.variant}`]: l.variant !== null,
      [`link-opacity-${l.opacity}`]: l.opacity !== void 0,
      [`link-opacity-${l.opacityHover}-hover`]: l.opacityHover !== void 0,
      [`link-underline-${l.underlineVariant}`]: l.underlineVariant !== null,
      [`link-offset-${l.underlineOffset}`]: l.underlineOffset !== void 0,
      [`link-offset-${l.underlineOffsetHover}-hover`]: l.underlineOffsetHover !== void 0,
      [`link-underline-opacity-${l.underlineOpacity}`]: l.underlineOpacity !== void 0,
      [`link-underline-opacity-${l.underlineOpacityHover}-hover`]: l.underlineOpacityHover !== void 0,
      "icon-link": l.icon === !0,
      "stretched-link": l.stretched === !0
    })), y = _(() => ({
      class: c.value,
      to: l.to,
      replace: l.replace,
      href: f.value,
      target: l.target,
      rel: l.target === "_blank" ? l.rel ?? "noopener" : void 0,
      tabindex: l.disabled ? "-1" : typeof s.tabindex > "u" ? null : s.tabindex,
      "aria-disabled": l.disabled ? !0 : null
    })), p = _(() => ({
      [Sl]: l.active,
      disabled: l.disabled
    })), b = (h) => {
      var w, v, B;
      if (l.disabled) {
        h.preventDefault(), h.stopImmediatePropagation();
        return;
      }
      (((w = r == null ? void 0 : r.isNav) == null ? void 0 : w.value) === !0 && u === null || u !== null && ((v = u.autoClose) == null ? void 0 : v.value) === !0) && ((B = r == null ? void 0 : r.hide) == null || B.call(r)), t("click", h);
    };
    return (h, w) => d.value === "router-link" ? (m(), P(ce(d.value), K({ key: 0 }, y.value, { custom: "" }), {
      default: I(({ href: v, navigate: B, isActive: g, isExactActive: S }) => [
        (m(), P(ce(n(l).routerTag), K({
          href: v,
          class: {
            [Sl]: n(l).active,
            [n(l).activeClass]: g,
            [n(l).exactActiveClass]: S
          }
        }, h.$attrs, {
          onClick: (C) => {
            B(C), b(C);
          }
        }), {
          default: I(() => [
            $(h.$slots, "default")
          ]),
          _: 2
        }, 1040, ["href", "class", "onClick"]))
      ]),
      _: 3
    }, 16)) : (m(), P(ce(d.value), K({
      key: 1,
      class: p.value
    }, y.value, { onClick: b }), {
      default: I(() => [
        $(h.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), qr = ["aria-valuenow", "aria-valuemax"], Qo = /* @__PURE__ */ L({
  __name: "BProgressBar",
  props: {
    animated: { type: Boolean, default: !1 },
    label: { default: void 0 },
    labelHtml: { default: void 0 },
    max: { default: void 0 },
    precision: { default: 0 },
    showProgress: { type: Boolean, default: !1 },
    showValue: { type: Boolean, default: !1 },
    striped: { type: Boolean, default: !1 },
    value: { default: 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(a) {
    const e = M(a, "BProgressBar"), l = Ve(ko, null), t = ot(e), s = _(() => [
      t.value,
      {
        "progress-bar-animated": e.animated || (l == null ? void 0 : l.animated.value),
        "progress-bar-striped": e.striped || (l == null ? void 0 : l.striped.value) || e.animated || (l == null ? void 0 : l.animated.value)
      }
    ]), r = he(() => e.precision), u = he(() => e.value), i = he(() => e.max ?? NaN), d = he(() => (l == null ? void 0 : l.max.value) ?? NaN), f = _(
      () => e.labelHtml !== void 0 ? e.labelHtml : e.showValue || l != null && l.showValue.value ? u.value.toFixed(r.value) : e.showProgress || l != null && l.showProgress.value ? (u.value * 100 / (i.value || 100)).toFixed(r.value) : e.label !== void 0 ? e.label : ""
    ), c = _(
      () => d.value ? `${u.value * 100 / d.value}%` : i.value ? `${u.value * 100 / i.value}%` : typeof e.value == "string" ? e.value : `${e.value}%`
    );
    return (y, p) => (m(), A("div", {
      class: R(["progress-bar", s.value]),
      role: "progressbar",
      "aria-valuenow": n(e).value,
      "aria-valuemin": "0",
      "aria-valuemax": n(e).max,
      style: Le({ width: c.value })
    }, [
      $(y.$slots, "default", {}, () => [
        ue(J(f.value), 1)
      ])
    ], 14, qr));
  }
}), en = /* @__PURE__ */ L({
  __name: "BProgress",
  props: {
    height: { default: void 0 },
    animated: { type: Boolean, default: void 0 },
    max: { default: 100 },
    precision: { default: void 0 },
    showProgress: { type: Boolean, default: void 0 },
    showValue: { type: Boolean, default: void 0 },
    striped: { type: Boolean, default: void 0 },
    value: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BProgress");
    return Xe(ko, {
      animated: k(() => e.animated),
      max: k(() => e.max),
      showProgress: k(() => e.showProgress),
      showValue: k(() => e.showValue),
      striped: k(() => e.striped)
    }), (l, t) => (m(), A("div", {
      class: "progress",
      style: Le({ height: n(e).height })
    }, [
      $(l.$slots, "default", {}, () => [
        ye(Qo, {
          animated: n(e).animated,
          max: n(e).max,
          precision: n(e).precision,
          "show-progress": n(e).showProgress,
          "show-value": n(e).showValue,
          striped: n(e).striped,
          value: n(e).value,
          variant: n(e).variant,
          "text-variant": n(e).textVariant,
          "bg-variant": n(e).bgVariant
        }, null, 8, ["animated", "max", "precision", "show-progress", "show-value", "striped", "value", "variant", "text-variant", "bg-variant"])
      ])
    ], 4));
  }
}), Ur = ["id", "role", "aria-live", "aria-atomic"], Xr = { class: "me-auto" }, tn = /* @__PURE__ */ L({
  __name: "BToast",
  props: /* @__PURE__ */ ge({
    body: { default: void 0 },
    bodyClass: { default: void 0 },
    headerClass: { default: void 0 },
    headerTag: { default: "div" },
    id: { default: void 0 },
    interval: { default: 1e3 },
    isStatus: { type: Boolean, default: !1 },
    modelValue: { type: [Boolean, Number] },
    noCloseButton: { type: Boolean, default: !1 },
    noFade: { type: Boolean, default: !1 },
    noHoverPause: { type: Boolean, default: !1 },
    progressProps: { default: void 0 },
    showOnPause: { type: Boolean, default: !0 },
    solid: { type: Boolean, default: !1 },
    title: { default: void 0 },
    toastClass: { default: void 0 },
    transProps: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: null },
    textVariant: { default: null },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 }
  }, {
    modelValue: { type: [Boolean, Number], default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["close", "close-countdown", "hide", "hidden", "show", "shown", "show-prevented", "hide-prevented"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BToast"), s = e, r = z(null), u = Qa(r), i = _e(a, "modelValue"), { computedLink: d, computedLinkProps: f } = Ct(t), c = he(() => t.interval), y = ot(t), p = k(() => typeof i.value == "boolean" ? 0 : i.value), {
      isActive: b,
      pause: h,
      restart: w,
      resume: v,
      stop: B,
      isPaused: g,
      value: S
    } = Ho(p, c, {
      immediate: typeof i.value == "number"
    });
    Pt(() => {
      s("close-countdown", S.value);
    });
    const C = k(() => d.value ? st : "div"), x = k(
      () => typeof i.value == "boolean" ? i.value : b.value || t.showOnPause && g.value
    ), V = _(() => [
      y.value,
      {
        show: x.value
      }
    ]), q = () => {
      t.noHoverPause || h();
    };
    fe(u, (j) => {
      if (j) {
        q();
        return;
      }
      v();
    });
    const G = (j, T = {}) => new wt(j, {
      cancelable: !1,
      target: r.value || null,
      relatedTarget: null,
      trigger: null,
      ...T,
      componentId: t.id
    }), O = () => {
      const j = G("show", { cancelable: !0 });
      if (s("show", j), j.defaultPrevented) {
        i.value && (i.value = !1), s("show-prevented");
        return;
      }
      i.value || (i.value = !0);
    }, Z = (j = "") => {
      const T = G("hide", { cancelable: j !== "", trigger: j });
      if (s("hide", T), j === "close" && s("close", T), T.defaultPrevented) {
        s("hide-prevented"), i.value || (i.value = !0);
        return;
      }
      typeof i.value == "boolean" ? i.value = !1 : (i.value = 0, B());
    }, ae = () => {
      O();
    }, ie = () => {
      s("shown", G("shown"));
    }, X = () => {
      s("hidden", G("hidden"));
    };
    return fe(b, (j) => {
      j === !1 && g.value === !1 && i.value && Z();
    }), Ra(B), o({
      pause: h,
      restart: w,
      resume: v,
      stop: B
    }), (j, T) => (m(), P(Et, K({
      "no-fade": n(t).noFade
    }, n(t).transProps, {
      onBeforeEnter: ae,
      onAfterEnter: ie,
      onAfterLeave: X
    }), {
      default: I(() => [
        x.value ? (m(), A("div", {
          key: 0,
          id: n(t).id,
          ref_key: "element",
          ref: r,
          class: R(["toast", [n(t).toastClass, V.value]]),
          tabindex: "0",
          role: x.value ? n(t).isStatus ? "status" : "alert" : void 0,
          "aria-live": x.value ? n(t).isStatus ? "polite" : "assertive" : void 0,
          "aria-atomic": x.value ? !0 : void 0
        }, [
          j.$slots.title || n(t).title ? (m(), P(ce(n(t).headerTag), {
            key: 0,
            class: "toast-header"
          }, {
            default: I(() => [
              $(j.$slots, "title", { hide: Z }, () => [
                Q("strong", Xr, J(n(t).title), 1)
              ]),
              n(t).noCloseButton ? ee("", !0) : (m(), P(Ft, {
                key: 0,
                onClick: T[0] || (T[0] = (N) => Z("close"))
              }))
            ]),
            _: 3
          })) : ee("", !0),
          j.$slots.default || n(t).body ? (m(), P(ce(C.value), K({
            key: 1,
            class: ["toast-body", n(t).bodyClass],
            style: { display: "block" }
          }, n(f), {
            onClick: T[1] || (T[1] = (N) => n(d) ? Z() : () => {
            })
          }), {
            default: I(() => [
              $(j.$slots, "default", { hide: Z }, () => [
                ue(J(n(t).body), 1)
              ])
            ]),
            _: 3
          }, 16, ["class"])) : ee("", !0),
          typeof i.value == "number" && n(t).progressProps !== void 0 ? (m(), P(en, {
            key: 2,
            animated: n(t).progressProps.animated,
            precision: n(t).progressProps.precision,
            "show-progress": n(t).progressProps.showProgress,
            "show-value": n(t).progressProps.showValue,
            striped: n(t).progressProps.striped,
            variant: n(t).progressProps.variant,
            max: i.value,
            value: n(S),
            height: "4px"
          }, null, 8, ["animated", "precision", "show-progress", "show-value", "striped", "variant", "max", "value"])) : ee("", !0)
        ], 10, Ur)) : ee("", !0)
      ]),
      _: 3
    }, 16, ["no-fade"]));
  }
}), Kr = "top-right", Yr = {
  install(a) {
    const o = bt([]), e = z(!1), l = (r) => {
      e.value = r;
    }, t = (r) => {
      const u = Symbol(), i = _(() => {
        const d = Se(r.props);
        return {
          component: Se(r.component) ?? tn,
          props: {
            ...d,
            pos: (d == null ? void 0 : d.pos) || Kr,
            _modelValue: (d == null ? void 0 : d.value) || 5e3,
            _self: u
          }
        };
      });
      return (i.value.props.appendToast !== void 0 ? i.value.props.appendToast : e.value) ? o.value = [...o.value, i] : o.value = [i, ...o.value], u;
    }, s = (r) => {
      o.value = o.value.filter((u) => u.value.props._self !== r);
    };
    a.provide(Oo, {
      _setIsAppend: l,
      toasts: o,
      show: t,
      remove: s
    });
  }
}, Zr = {
  install(a) {
    const o = z([]), e = () => {
      o.value.splice(0, o.value.length);
    };
    a.provide(Po, { items: o, reset: e });
  }
}, Jr = {
  install(a, o) {
    (o == null ? void 0 : o.id) instanceof Object && typeof o.id.getId == "function" && a.provide(Fo, o.id.getId);
  }
}, Qr = {
  key: 0,
  class: "visually-hidden"
}, Ba = /* @__PURE__ */ L({
  __name: "BSpinner",
  props: {
    label: { default: void 0 },
    role: { default: "status" },
    small: { type: Boolean, default: !1 },
    tag: { default: "span" },
    type: { default: "border" },
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BSpinner"), l = He(), t = _(() => [
      `spinner-${e.type}`,
      {
        [`spinner-${e.type}-sm`]: e.small,
        [`text-${e.variant}`]: e.variant !== null
      }
    ]), s = k(() => !Ae(l.label));
    return (r, u) => (m(), P(ce(n(e).tag), {
      class: R(t.value),
      role: n(e).label || s.value ? n(e).role : null,
      "aria-hidden": n(e).label || s.value ? null : !0
    }, {
      default: I(() => [
        n(e).label || s.value ? (m(), A("span", Qr, [
          $(r.$slots, "label", {}, () => [
            ue(J(n(e).label), 1)
          ])
        ])) : ee("", !0)
      ]),
      _: 3
    }, 8, ["class", "role", "aria-hidden"]));
  }
}), mt = /* @__PURE__ */ L({
  __name: "BButton",
  props: /* @__PURE__ */ ge({
    loading: { type: Boolean, default: !1 },
    loadingFill: { type: Boolean, default: !1 },
    loadingText: { default: "Loading..." },
    pill: { type: Boolean, default: !1 },
    pressed: { type: Boolean },
    size: { default: "md" },
    squared: { type: Boolean, default: !1 },
    tag: { default: "button" },
    type: { default: "button" },
    variant: { default: "secondary" },
    active: { type: Boolean, default: !1 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    routerTag: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 }
  }, {
    pressed: { type: Boolean, default: void 0 },
    pressedModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["click"], ["update:pressed"]),
  setup(a, { emit: o }) {
    const l = M(a, "BButton"), t = o, s = _e(a, "pressed"), { computedLink: r, computedLinkProps: u } = Ct(l, [
      "active-class",
      "exact-active-class",
      "replace",
      "routerComponentName",
      "routerTag"
    ]), i = k(() => typeof l.pressed == "boolean"), d = k(
      () => l.tag === "button" && l.href === void 0 && l.to === void 0
    ), f = k(() => l.to !== void 0), c = k(() => l.href !== void 0 ? !1 : !d.value), y = _(() => f.value ? u.value : []), p = _(() => [
      [`btn-${l.size}`],
      {
        [`btn-${l.variant}`]: l.variant !== null,
        active: l.active || l.pressed,
        "rounded-pill": l.pill,
        "rounded-0": l.squared,
        disabled: l.disabled
      }
    ]), b = k(() => f.value ? st : l.href ? "a" : l.tag), h = (w) => {
      if (l.disabled) {
        w.preventDefault(), w.stopPropagation();
        return;
      }
      t("click", w), i.value && (s.value = !l.pressed);
    };
    return (w, v) => (m(), P(ce(b.value), K({ class: "btn" }, y.value, {
      class: p.value,
      "aria-disabled": c.value ? n(l).disabled : null,
      "aria-pressed": i.value ? n(l).pressed : null,
      autocomplete: i.value ? "off" : null,
      disabled: d.value ? n(l).disabled : null,
      href: n(l).href,
      rel: n(r) ? n(l).rel : null,
      role: c.value || n(r) ? "button" : null,
      target: n(r) ? n(l).target : null,
      type: d.value ? n(l).type : null,
      to: d.value ? null : n(l).to,
      onClick: h
    }), {
      default: I(() => [
        n(l).loading ? $(w.$slots, "loading", { key: 0 }, () => [
          n(l).loadingFill ? ee("", !0) : (m(), A(ve, { key: 0 }, [
            ue(J(n(l).loadingText), 1)
          ], 64)),
          $(w.$slots, "loading-spinner", {}, () => [
            ye(Ba, {
              small: n(l).size !== "lg",
              label: n(l).loadingFill ? n(l).loadingText : void 0
            }, null, 8, ["small", "label"])
          ])
        ]) : $(w.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 16, ["class", "aria-disabled", "aria-pressed", "autocomplete", "disabled", "href", "rel", "role", "target", "type", "to"]));
  }
}), qt = L({
  name: "RenderComponentOrSkip",
  inheritAttrs: !1,
  slots: Object,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    to: {
      type: [String, Object],
      default: null
    },
    skip: {
      type: Boolean,
      default: !1
    }
  },
  setup(a, { slots: o, attrs: e }) {
    return () => {
      var l, t, s;
      return a.skip ? (l = o.default) == null ? void 0 : l.call(o) : a.tag === "Teleport" ? Ie(_t, { to: a.to }, [(t = o.default) == null ? void 0 : t.call(o)]) : Ie(a.tag, { ...e }, [(s = o.default) == null ? void 0 : s.call(o)]);
    };
  }
}), _a = /* @__PURE__ */ L({
  __name: "BOverlay",
  props: {
    bgColor: { default: void 0 },
    blur: { default: "2px" },
    fixed: { type: Boolean, default: !1 },
    noCenter: { type: Boolean, default: !1 },
    noFade: { type: Boolean, default: !1 },
    noSpinner: { type: Boolean, default: !1 },
    noWrap: { type: Boolean, default: !1 },
    opacity: { default: 0.85 },
    overlayTag: { default: "div" },
    show: { type: Boolean, default: !1 },
    spinnerSmall: { type: Boolean, default: !1 },
    spinnerType: { default: "border" },
    spinnerVariant: { default: void 0 },
    variant: { default: "light" },
    wrapTag: { default: "div" },
    zIndex: { default: 10 },
    rounded: { type: [Boolean, String, Number], default: !1 },
    roundedTop: { type: [Boolean, String, Number], default: void 0 },
    roundedBottom: { type: [Boolean, String, Number], default: void 0 },
    roundedStart: { type: [Boolean, String, Number], default: void 0 },
    roundedEnd: { type: [Boolean, String, Number], default: void 0 }
  },
  emits: ["click", "hidden", "shown"],
  setup(a, { emit: o }) {
    const l = M(a, "BOverlay"), t = o, s = { top: 0, left: 0, bottom: 0, right: 0 }, r = nl(() => ({
      rounded: l.rounded,
      roundedTop: l.roundedTop,
      roundedBottom: l.roundedBottom,
      roundedStart: l.roundedStart,
      roundedEnd: l.roundedEnd
    })), u = k(
      () => l.variant !== null && !l.bgColor ? `bg-${l.variant}` : ""
    ), i = k(() => l.show ? !0 : null), d = _(() => ({
      type: l.spinnerType,
      variant: l.spinnerVariant,
      small: l.spinnerSmall
    })), f = _(() => ({
      ...s,
      zIndex: l.zIndex || 10
    })), c = _(() => ({
      "position-absolute": !l.noWrap || !l.fixed,
      "position-fixed": l.noWrap && l.fixed
    })), y = _(() => [u.value, r.value]), p = _(() => ({
      ...s,
      opacity: l.opacity,
      backgroundColor: l.bgColor || void 0,
      backdropFilter: l.blur ? `blur(${l.blur})` : void 0
    })), b = _(
      () => l.noCenter ? s : {
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)"
      }
    );
    return (h, w) => (m(), P(qt, {
      tag: n(l).wrapTag,
      class: "b-overlay-wrap position-relative",
      "aria-busy": i.value,
      skip: n(l).noWrap
    }, {
      default: I(() => [
        $(h.$slots, "default"),
        ye(Et, {
          "no-fade": n(l).noFade,
          "trans-props": { enterToClass: "show" },
          name: "fade",
          onAfterEnter: w[1] || (w[1] = (v) => t("shown")),
          onAfterLeave: w[2] || (w[2] = (v) => t("hidden"))
        }, {
          default: I(() => [
            n(l).show ? (m(), P(ce(n(l).overlayTag), {
              key: 0,
              class: R(["b-overlay", c.value]),
              style: Le(f.value),
              onClick: w[0] || (w[0] = (v) => t("click", v))
            }, {
              default: I(() => [
                Q("div", {
                  class: R(["position-absolute", y.value]),
                  style: Le(p.value)
                }, null, 6),
                Q("div", {
                  class: "position-absolute",
                  style: Le(b.value)
                }, [
                  $(h.$slots, "overlay", Be(Ce(d.value)), () => [
                    n(l).noSpinner ? ee("", !0) : (m(), P(Ba, Be(K({ key: 0 }, d.value)), null, 16))
                  ])
                ], 4)
              ]),
              _: 3
            }, 8, ["class", "style"])) : ee("", !0)
          ]),
          _: 3
        }, 8, ["no-fade"])
      ]),
      _: 3
    }, 8, ["tag", "aria-busy", "skip"]));
  }
}), ei = ["id", "aria-labelledby", "aria-describedby"], ti = ["id"], Vl = 1056, ai = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BModal",
  props: /* @__PURE__ */ ge({
    autoFocus: { type: Boolean, default: !0 },
    autoFocusButton: { default: void 0 },
    body: { default: void 0 },
    backdropVariant: { default: void 0 },
    bodyAttrs: { default: void 0 },
    bodyBgVariant: { default: null },
    bodyClass: { default: null },
    bodyScrolling: { type: Boolean, default: !1 },
    bodyTextVariant: { default: null },
    bodyVariant: { default: null },
    busy: { type: Boolean, default: !1 },
    buttonSize: { default: "md" },
    cancelDisabled: { type: Boolean, default: !1 },
    cancelTitle: { default: "Cancel" },
    cancelVariant: { default: "secondary" },
    centered: { type: Boolean, default: !1 },
    contentClass: { default: void 0 },
    dialogClass: { default: void 0 },
    footerBgVariant: { default: null },
    footerBorderVariant: { default: null },
    footerClass: { default: void 0 },
    footerTextVariant: { default: null },
    footerVariant: { default: null },
    fullscreen: { type: [Boolean, String], default: !1 },
    headerBgVariant: { default: null },
    headerBorderVariant: { default: null },
    headerClass: { default: void 0 },
    headerCloseClass: { default: void 0 },
    headerCloseLabel: { default: "Close" },
    headerCloseVariant: { default: "secondary" },
    headerTextVariant: { default: null },
    headerVariant: { default: null },
    hideBackdrop: { type: Boolean, default: !1 },
    hideFooter: { type: Boolean, default: !1 },
    hideHeader: { type: Boolean, default: !1 },
    hideHeaderClose: { type: Boolean, default: !1 },
    id: { default: void 0 },
    lazy: { type: Boolean, default: !1 },
    modalClass: { default: void 0 },
    modelValue: { type: Boolean },
    noCloseOnBackdrop: { type: Boolean, default: !1 },
    noCloseOnEsc: { type: Boolean, default: !1 },
    noFade: { type: Boolean, default: !1 },
    okDisabled: { type: Boolean, default: !1 },
    okOnly: { type: Boolean, default: !1 },
    okTitle: { default: "Ok" },
    okVariant: { default: "primary" },
    scrollable: { type: Boolean, default: !1 },
    size: { default: "md" },
    title: { default: void 0 },
    titleClass: { default: void 0 },
    titleSrOnly: { type: Boolean, default: !1 },
    titleTag: { default: "h5" },
    transProps: { default: void 0 },
    teleportDisabled: { default: !1 },
    teleportTo: { default: "body" }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["cancel", "close", "hidden", "hide", "hide-prevented", "ok", "show", "show-prevented", "shown"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BModal"), s = e, r = He(), u = we(() => t.id, "modal"), i = _e(a, "modelValue"), d = z(null), f = z(null), c = z(null), y = z(null), p = z(i.value), b = z(!1);
    De(
      "Escape",
      () => {
        W("esc");
      },
      { target: d }
    ), Yo(i, () => t.bodyScrolling);
    const { focused: h } = Fe(d, {
      initialValue: i.value && t.autoFocusButton === void 0
    }), { focused: w } = Fe(f, {
      initialValue: i.value && t.autoFocusButton === "ok"
    }), { focused: v } = Fe(c, {
      initialValue: i.value && t.autoFocusButton === "cancel"
    }), { focused: B } = Fe(y, {
      initialValue: i.value && t.autoFocusButton === "close"
    }), g = _(() => [
      t.modalClass,
      {
        fade: !t.noFade,
        show: p.value
      }
    ]), S = k(
      () => t.lazy === !1 || t.lazy === !0 && b.value === !0 || t.lazy === !0 && i.value === !0
    ), C = k(
      () => t.backdropVariant !== void 0 ? t.backdropVariant : t.hideBackdrop ? "transparent" : "dark"
    ), x = k(() => !Ae(r["header-close"])), V = _(() => [
      t.dialogClass,
      {
        "modal-fullscreen": t.fullscreen === !0,
        [`modal-fullscreen-${t.fullscreen}-down`]: typeof t.fullscreen == "string",
        [`modal-${t.size}`]: t.size !== "md",
        "modal-dialog-centered": t.centered,
        "modal-dialog-scrollable": t.scrollable
      }
    ]), q = ot(() => ({
      bgVariant: t.bodyBgVariant,
      textVariant: t.bodyTextVariant,
      variant: t.bodyVariant
    })), G = _(() => [t.bodyClass, q.value]), O = ot(() => ({
      bgVariant: t.headerBgVariant,
      textVariant: t.headerTextVariant,
      variant: t.headerVariant
    })), Z = _(() => [
      t.headerClass,
      O.value,
      {
        [`border-${t.headerBorderVariant}`]: t.headerBorderVariant !== null
      }
    ]), ae = _(() => ({
      variant: x.value ? t.headerCloseVariant : void 0,
      class: t.headerCloseClass
    })), ie = ot(() => ({
      bgVariant: t.footerBgVariant,
      textVariant: t.footerTextVariant,
      variant: t.footerVariant
    })), X = _(() => [
      t.footerClass,
      ie.value,
      {
        [`border-${t.footerBorderVariant}`]: t.footerBorderVariant !== null
      }
    ]), j = _(() => [
      t.titleClass,
      {
        "visually-hidden": t.titleSrOnly
      }
    ]), T = k(() => t.cancelDisabled || t.busy), N = k(() => t.okDisabled || t.busy), F = (le, H = {}) => new wt(le, {
      cancelable: !1,
      target: d.value || null,
      relatedTarget: null,
      trigger: null,
      ...H,
      componentId: u.value
    });
    fe(i, (le, H) => {
      le !== H && (le === !0 ? E() : W());
    });
    const W = (le = "") => {
      if (le === "backdrop" && t.noCloseOnBackdrop || le === "esc" && t.noCloseOnEsc) {
        s("hide-prevented");
        return;
      }
      const H = F("hide", { cancelable: le !== "", trigger: le });
      if (le === "ok" && s(le, H), le === "cancel" && s(le, H), le === "close" && s(le, H), s("hide", H), H.defaultPrevented) {
        s("hide-prevented"), i.value || (i.value = !0);
        return;
      }
      i.value && (i.value = !1);
    }, E = () => {
      if (p.value)
        return;
      const le = F("show", { cancelable: !0 });
      if (s("show", le), le.defaultPrevented) {
        i.value && (i.value = !1), s("show-prevented");
        return;
      }
      i.value || (i.value = !0);
    }, D = () => {
      t.autoFocus !== !1 && (t.autoFocusButton === "ok" ? w.value = !0 : t.autoFocusButton === "close" ? B.value = !0 : t.autoFocusButton === "cancel" ? v.value = !0 : h.value = !0);
    }, te = () => {
      E();
    }, re = () => {
      p.value = !0, D(), s("shown", F("shown")), t.lazy === !0 && (b.value = !0);
    }, U = () => {
      p.value = !1;
    }, ne = () => {
      s("hidden", F("hidden")), t.lazy === !0 && (b.value = !1);
    }, { activePosition: pe, activeModalCount: Y } = Dr(p), de = _(() => ({
      // Make sure that newly opened modals have a higher z-index than currently active ones.
      // All active modals have a z-index of ('defaultZIndex' - 'stackSize' - 'positionInStack').
      //
      // This means inactive modals will already be higher than active ones when opened.
      "z-index": p.value ? Vl - (((Y == null ? void 0 : Y.value) ?? 0) - ((pe == null ? void 0 : pe.value) ?? 0)) : Vl
    }));
    Te(d, "bv-toggle", () => {
      i.value ? W() : E();
    });
    const oe = _(() => ({
      cancel: () => {
        W("cancel");
      },
      close: () => {
        W("close");
      },
      hide: W,
      ok: () => {
        W("ok");
      },
      visible: i.value
    }));
    return o({
      hide: W,
      id: u,
      show: E
    }), (le, H) => {
      var se;
      return m(), P(_t, {
        to: n(t).teleportTo,
        disabled: n(t).teleportDisabled
      }, [
        ye(Et, K({ "no-fade": !0 }, n(t).transProps, {
          "trans-props": { enterToClass: "show", ...(se = n(t).transProps) == null ? void 0 : se.transProps },
          onBeforeEnter: te,
          onAfterEnter: re,
          onLeave: U,
          onAfterLeave: ne
        }), {
          default: I(() => [
            ct(Q("div", K({
              id: n(u),
              ref_key: "element",
              ref: d,
              class: ["modal", g.value],
              role: "dialog",
              "aria-labelledby": n(t).hideHeader ? void 0 : `${n(u)}-label`,
              "aria-describedby": `${n(u)}-body`,
              tabindex: "-1"
            }, le.$attrs, { style: de.value }), [
              Q("div", {
                class: R(["modal-dialog", V.value])
              }, [
                S.value ? (m(), A("div", {
                  key: 0,
                  class: R(["modal-content", n(t).contentClass])
                }, [
                  n(t).hideHeader ? ee("", !0) : (m(), A("div", {
                    key: 0,
                    class: R(["modal-header", Z.value])
                  }, [
                    $(le.$slots, "header", Be(Ce(oe.value)), () => [
                      (m(), P(ce(n(t).titleTag), {
                        id: `${n(u)}-label`,
                        class: R(["modal-title", j.value])
                      }, {
                        default: I(() => [
                          $(le.$slots, "title", Be(Ce(oe.value)), () => [
                            ue(J(n(t).title), 1)
                          ], !0)
                        ]),
                        _: 3
                      }, 8, ["id", "class"])),
                      n(t).hideHeaderClose ? ee("", !0) : (m(), A(ve, { key: 0 }, [
                        x.value ? (m(), P(mt, K({ key: 0 }, ae.value, {
                          onClick: H[0] || (H[0] = (be) => W("close"))
                        }), {
                          default: I(() => [
                            $(le.$slots, "header-close", {}, void 0, !0)
                          ]),
                          _: 3
                        }, 16)) : (m(), P(Ft, K({
                          key: 1,
                          "aria-label": n(t).headerCloseLabel
                        }, ae.value, {
                          onClick: H[1] || (H[1] = (be) => W("close"))
                        }), null, 16, ["aria-label"]))
                      ], 64))
                    ], !0)
                  ], 2)),
                  Q("div", K({
                    id: `${n(u)}-body`,
                    class: ["modal-body", G.value]
                  }, n(t).bodyAttrs), [
                    $(le.$slots, "default", Be(Ce(oe.value)), () => [
                      ue(J(n(t).body), 1)
                    ], !0)
                  ], 16, ti),
                  n(t).hideFooter ? ee("", !0) : (m(), A("div", {
                    key: 1,
                    class: R(["modal-footer", X.value])
                  }, [
                    $(le.$slots, "footer", Be(Ce(oe.value)), () => [
                      $(le.$slots, "cancel", Be(Ce(oe.value)), () => [
                        n(t).okOnly ? ee("", !0) : (m(), P(mt, {
                          key: 0,
                          ref_key: "cancelButton",
                          ref: c,
                          disabled: T.value,
                          size: n(t).buttonSize,
                          variant: n(t).cancelVariant,
                          onClick: H[2] || (H[2] = (be) => W("cancel"))
                        }, {
                          default: I(() => [
                            ue(J(n(t).cancelTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "size", "variant"]))
                      ], !0),
                      $(le.$slots, "ok", Be(Ce(oe.value)), () => [
                        ye(mt, {
                          ref_key: "okButton",
                          ref: f,
                          disabled: N.value,
                          size: n(t).buttonSize,
                          variant: n(t).okVariant,
                          onClick: H[3] || (H[3] = (be) => W("ok"))
                        }, {
                          default: I(() => [
                            ue(J(n(t).okTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "size", "variant"])
                      ], !0)
                    ], !0)
                  ], 2))
                ], 2)) : ee("", !0)
              ], 2),
              $(le.$slots, "backdrop", {}, () => [
                ye(_a, {
                  variant: C.value,
                  show: i.value,
                  "no-spinner": "",
                  fixed: "",
                  "no-wrap": "",
                  blur: null,
                  onClick: H[4] || (H[4] = (be) => W("backdrop"))
                }, null, 8, ["variant", "show"])
              ], !0)
            ], 16, ei), [
              [jt, i.value]
            ])
          ]),
          _: 3
        }, 16, ["trans-props"])
      ], 8, ["to", "disabled"]);
    };
  }
}), an = (a, o) => {
  const e = a.__vccOpts || a;
  for (const [l, t] of o)
    e[l] = t;
  return e;
}, Pa = /* @__PURE__ */ an(ai, [["__scopeId", "data-v-d3e62049"]]), li = {
  install(a) {
    const o = bt([]), e = () => {
      let r = () => {
      };
      return {
        value: new Promise((i) => {
          r = i;
        }),
        resolve: r
      };
    }, l = (r) => {
      const u = e(), i = Symbol();
      return o.value = [
        ...o.value,
        _(() => ({
          component: Se(r.component) ?? Pa,
          props: { ...Se(r.props), _isConfirm: !1, _promise: u, _self: i, _modelValue: !0 }
        }))
      ], u.value;
    }, t = (r) => {
      const u = e(), i = Symbol();
      return o.value = [
        ...o.value,
        _(() => ({
          component: Se(r.component) ?? Pa,
          props: { ...Se(r.props), _isConfirm: !0, _promise: u, _self: i, _modelValue: !0 }
        }))
      ], u.value;
    }, s = (r) => {
      o.value = o.value.filter((u) => u.value.props._self !== r);
    };
    a.provide(No, {
      modals: o,
      remove: s,
      show: l,
      confirm: t
    });
  }
}, oi = {
  install(a) {
    const o = bt([]), e = k(() => o.value.length), l = k(() => o.value[o.value.length - 1]), t = (d) => {
      o.value = [...o.value, d];
    }, s = (d) => {
      o.value = o.value.filter((f) => f.uid !== d.uid);
    }, r = bt([]), u = (d) => {
      r.value = [...r.value, d];
    }, i = (d) => {
      r.value = r.value.filter((f) => f.uid !== d.uid);
    };
    a.provide(Eo, {
      stack: o,
      countStack: e,
      lastStack: l,
      registry: r,
      pushStack: t,
      removeStack: s,
      pushRegistry: u,
      removeRegistry: i
    });
  }
}, ni = {
  install(a, o) {
    var i, d;
    const t = typeof (o == null ? void 0 : o.rtl) == "boolean" ? !1 : ((i = o == null ? void 0 : o.rtl) == null ? void 0 : i.rtlInitial) ?? !1, s = typeof (o == null ? void 0 : o.rtl) == "boolean" ? void 0 : ((d = o == null ? void 0 : o.rtl) == null ? void 0 : d.localeInitial) ?? void 0, r = z(t), u = z(s);
    a.provide(Io, { isRtl: r, locale: u });
  }
}, si = {
  install(a, o) {
    const e = (o == null ? void 0 : o.components) ?? {};
    a.provide(aa, z(e));
  }
}, ri = ["id"], ii = /* @__PURE__ */ L({
  __name: "BAccordion",
  props: /* @__PURE__ */ ge({
    flush: { type: Boolean, default: !1 },
    free: { type: Boolean, default: !1 },
    id: { default: void 0 },
    modelValue: {}
  }, {
    modelValue: {
      default: void 0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const e = M(a, "BAccordion"), l = _e(a, "modelValue"), t = we(() => e.id, "accordion"), s = _(() => ({
      "accordion-flush": e.flush
    }));
    return Xe(xo, {
      openItem: Ye(l),
      free: k(() => e.free),
      setOpenItem: (r) => {
        l.value = r;
      }
    }), (r, u) => (m(), A("div", {
      id: n(t),
      class: R(["accordion", s.value])
    }, [
      $(r.$slots, "default")
    ], 10, ri));
  }
}), ln = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BCollapse",
  props: /* @__PURE__ */ ge({
    horizontal: { type: Boolean, default: !1 },
    id: { default: void 0 },
    isNav: { type: Boolean, default: !1 },
    modelValue: { type: Boolean },
    skipAnimation: { type: Boolean, default: !1 },
    tag: { default: "div" },
    toggle: { type: Boolean, default: !1 },
    visible: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["hidden", "hide", "hide-prevented", "show", "show-prevented", "shown"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BCollapse"), s = e, r = (x, V = {}) => new wt(x, {
      cancelable: !1,
      target: d.value || null,
      relatedTarget: null,
      trigger: null,
      ...V,
      componentId: i.value
    }), u = _e(a, "modelValue"), i = we(() => t.id, "collapse"), d = z(null), f = z(!1), c = z(u.value), y = _(() => ({
      show: c.value,
      "navbar-collapse": t.isNav,
      collapsing: f.value,
      closing: c.value && !u.value,
      "collapse-horizontal": t.horizontal
    })), p = () => {
      u.value = !1;
    }, b = () => {
      u.value = !0;
    }, h = () => {
      u.value = !u.value;
    }, w = _(() => ({
      toggle: h,
      show: b,
      hide: p,
      id: i.value,
      visible: u.value
    }));
    let v, B, g = t.skipAnimation;
    const S = () => {
      const x = r("show", { cancelable: !0 });
      if (s("show", x), x.defaultPrevented) {
        s("show-prevented");
        return;
      }
      clearTimeout(B), clearTimeout(v), c.value = !0, !g && (f.value = !0, Ne(() => {
        d.value !== null && (t.horizontal ? d.value.style.width = `${d.value.scrollWidth}px` : d.value.style.height = `${d.value.scrollHeight}px`, v = setTimeout(() => {
          f.value = !1, s("shown"), d.value !== null && (d.value.style.height = "", d.value.style.width = "");
        }, xa(d.value)));
      }));
    }, C = () => {
      const x = r("hide", { cancelable: !0 });
      if (s("hide", x), x.defaultPrevented) {
        s("hide-prevented");
        return;
      }
      if (clearTimeout(v), clearTimeout(B), d.value !== null) {
        if (g) {
          c.value = !1;
          return;
        }
        f.value ? (d.value.style.height = "", d.value.style.width = "") : t.horizontal ? d.value.style.width = `${d.value.scrollWidth}px` : d.value.style.height = `${d.value.scrollHeight}px`, d.value.offsetHeight, f.value = !0, Ne(() => {
          d.value !== null && (d.value.style.height = "", d.value.style.width = "", B = setTimeout(() => {
            c.value = !1, f.value = !1, s("hidden");
          }, xa(d.value)));
        });
      }
    };
    return fe(u, () => {
      u.value ? S() : C();
    }), Ue(() => {
      d.value !== null && !u.value && t.toggle && Ne(() => {
        u.value = !0;
      });
    }), fe(
      () => t.skipAnimation,
      (x) => {
        g = x;
      }
    ), t.visible && (g = !0, u.value = !0, Ne(() => {
      g = t.skipAnimation;
    })), fe(
      () => t.visible,
      (x) => {
        g = !0, x ? b() : p(), Ne(() => {
          g = t.skipAnimation;
        });
      }
    ), Te(d, "bv-toggle", () => {
      u.value = !u.value;
    }), o({
      hide: p,
      isNav: t.isNav,
      show: b,
      toggle: h,
      visible: Ye(c)
    }), Xe(tl, {
      id: i,
      hide: p,
      show: b,
      toggle: h,
      visible: Ye(c),
      isNav: k(() => t.isNav)
    }), (x, V) => (m(), A(ve, null, [
      $(x.$slots, "header", Be(Ce(w.value))),
      (m(), P(ce(n(t).tag), K({
        id: n(i),
        ref_key: "element",
        ref: d,
        class: ["collapse", y.value],
        "is-nav": n(t).isNav
      }, x.$attrs), {
        default: I(() => [
          $(x.$slots, "default", Be(Ce(w.value)))
        ]),
        _: 3
      }, 16, ["id", "class", "is-nav"])),
      $(x.$slots, "footer", Be(Ce(w.value)))
    ], 64));
  }
}), ui = ["aria-expanded", "aria-controls", "onClick"], di = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BAccordionItem",
  props: /* @__PURE__ */ ge({
    bodyAttrs: { default: void 0 },
    bodyClass: { default: void 0 },
    buttonAttrs: { default: void 0 },
    buttonClass: { default: void 0 },
    collapseClass: { default: void 0 },
    headerAttrs: { default: void 0 },
    headerClass: { default: void 0 },
    headerTag: { default: "h2" },
    horizontal: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    isNav: { type: Boolean, default: void 0 },
    modelValue: { type: Boolean },
    tag: { default: void 0 },
    title: { default: void 0 },
    toggle: { type: Boolean, default: void 0 },
    visible: { type: Boolean, default: !1 },
    wrapperAttrs: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["hidden", "hide", "hide-prevented", "show", "show-prevented", "shown"], ["update:modelValue"]),
  setup(a, { emit: o }) {
    const { class: e, ...l } = Dt(), s = M(a, "BAccordionItem"), r = o, u = _e(a, "modelValue"), i = Ve(xo, null), d = we(() => s.id, "accordion_item");
    return Ue(() => {
      u.value && !(i != null && i.free.value) && (i == null || i.setOpenItem(d.value)), !u.value && (i == null ? void 0 : i.openItem.value) === d.value && (u.value = !0);
    }), fe(
      () => i == null ? void 0 : i.openItem.value,
      () => u.value = (i == null ? void 0 : i.openItem.value) === d.value && !(i != null && i.free.value)
    ), fe(u, () => {
      u.value && !(i != null && i.free.value) && (i == null || i.setOpenItem(d.value));
    }), (f, c) => (m(), A("div", K({ class: "accordion-item" }, n(s).wrapperAttrs, { class: n(e) }), [
      ye(ln, K({
        id: n(d),
        modelValue: u.value,
        "onUpdate:modelValue": c[0] || (c[0] = (y) => u.value = y),
        class: ["accordion-collapse", n(s).collapseClass],
        "aria-labelledby": `${n(d)}-heading`
      }, l, {
        tag: n(s).tag,
        toggle: n(s).toggle,
        horizontal: n(s).horizontal,
        visible: n(s).visible,
        "is-nav": n(s).isNav,
        onShow: c[1] || (c[1] = (y) => r("show", y)),
        onShown: c[2] || (c[2] = (y) => r("shown")),
        onHide: c[3] || (c[3] = (y) => r("hide", y)),
        onHidden: c[4] || (c[4] = (y) => r("hidden")),
        onHidePrevented: c[5] || (c[5] = (y) => r("hide-prevented")),
        onShowPrevented: c[6] || (c[6] = (y) => r("show-prevented"))
      }), {
        header: I(({ visible: y, toggle: p }) => [
          (m(), P(ce(n(s).headerTag), K({
            id: `${n(d)}-heading`,
            class: ["accordion-header", n(s).headerClass]
          }, n(s).headerAttrs), {
            default: I(() => [
              Q("button", K({ class: "accordion-button" }, n(s).buttonAttrs, {
                class: [{ collapsed: !y }, n(s).buttonClass],
                type: "button",
                "aria-expanded": y ? "true" : "false",
                "aria-controls": n(d),
                onClick: p
              }), [
                $(f.$slots, "title", {}, () => [
                  ue(J(n(s).title), 1)
                ])
              ], 16, ui)
            ]),
            _: 2
          }, 1040, ["id", "class"]))
        ]),
        default: I(() => [
          Q("div", K({ class: "accordion-body" }, n(s).bodyAttrs, {
            class: n(s).bodyClass
          }), [
            $(f.$slots, "default")
          ], 16)
        ]),
        _: 3
      }, 16, ["id", "modelValue", "class", "aria-labelledby", "tag", "toggle", "horizontal", "visible", "is-nav"])
    ], 16));
  }
}), ci = /* @__PURE__ */ L({
  __name: "BAlert",
  props: /* @__PURE__ */ ge({
    closeClass: { default: void 0 },
    closeContent: { default: void 0 },
    closeLabel: { default: "Close" },
    closeVariant: { default: "secondary" },
    dismissible: { type: Boolean, default: !1 },
    fade: { type: Boolean, default: !1 },
    immediate: { type: Boolean, default: !0 },
    interval: { default: 1e3 },
    modelValue: { type: [Boolean, Number] },
    noHoverPause: { type: Boolean, default: !1 },
    showOnPause: { type: Boolean, default: !0 },
    variant: { default: "info" }
  }, {
    modelValue: { type: [Boolean, Number], default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["close", "close-countdown", "closed"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BAlert"), s = e, r = He(), u = z(null), i = _e(a, "modelValue"), d = Qa(u), f = he(() => t.interval), c = k(() => !Ae(r.close)), y = k(() => typeof i.value == "boolean" ? 0 : i.value), p = _(() => ({
      [`alert-${t.variant}`]: t.variant !== null,
      "alert-dismissible": t.dismissible
    })), b = _(() => [t.closeClass, { "btn-close-custom": c.value }]), {
      isActive: h,
      pause: w,
      restart: v,
      resume: B,
      stop: g,
      isPaused: S,
      value: C
    } = Ho(y, f, {
      immediate: typeof i.value == "number" && t.immediate
    }), x = k(
      () => typeof i.value == "boolean" ? i.value : h.value || t.showOnPause && S.value
    ), V = _(() => ({
      variant: c.value ? t.closeVariant : void 0,
      class: b.value
    }));
    Pt(() => {
      s("close-countdown", C.value);
    });
    const q = () => {
      s("close"), typeof i.value == "boolean" ? i.value = !1 : (i.value = 0, g()), s("closed");
    }, G = () => {
      t.noHoverPause || w();
    };
    return fe(d, (O) => {
      if (O) {
        G();
        return;
      }
      B();
    }), Ra(g), o({
      pause: w,
      restart: v,
      resume: B,
      stop: g
    }), (O, Z) => (m(), P(Et, {
      "no-fade": !n(t).fade,
      "trans-props": { enterToClass: "show" }
    }, {
      default: I(() => [
        x.value ? (m(), A("div", {
          key: 0,
          ref_key: "element",
          ref: u,
          class: R(["alert", p.value]),
          role: "alert",
          "aria-live": "polite",
          "aria-atomic": "true"
        }, [
          $(O.$slots, "default", {}, void 0, !0),
          n(t).dismissible ? (m(), A(ve, { key: 0 }, [
            c.value || n(t).closeContent ? (m(), P(mt, K({ key: 0 }, V.value, { onClick: q }), {
              default: I(() => [
                $(O.$slots, "close", {}, () => [
                  ue(J(n(t).closeContent), 1)
                ], !0)
              ]),
              _: 3
            }, 16)) : (m(), P(Ft, K({
              key: 1,
              "aria-label": n(t).closeLabel
            }, V.value, { onClick: q }), null, 16, ["aria-label"]))
          ], 64)) : ee("", !0)
        ], 2)) : ee("", !0)
      ]),
      _: 3
    }, 8, ["no-fade"]));
  }
}), fi = /* @__PURE__ */ an(ci, [["__scopeId", "data-v-96a91b13"]]), on = /* @__PURE__ */ L({
  __name: "BBadge",
  props: {
    dotIndicator: { type: Boolean, default: !1 },
    pill: { type: Boolean, default: !1 },
    tag: { default: "span" },
    textIndicator: { type: Boolean },
    placement: { default: void 0 },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: "secondary" },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(a) {
    const e = M(a, "BBadge"), l = ot(e), { computedLink: t, computedLinkProps: s } = Ct(e, [
      "active",
      "activeClass",
      "append",
      "disabled",
      "href",
      "rel",
      "replace",
      "routerComponentName",
      "target",
      "to",
      "opacity",
      "opacityHover",
      "underlineVariant",
      "underlineOffset",
      "underlineOffsetHover",
      "underlineOpacity",
      "underlineOpacityHover",
      "icon"
    ]), r = k(() => t.value ? st : e.tag), u = _(() => {
      const d = e.placement ?? (e.dotIndicator ? "top-end" : void 0);
      return [
        "position-absolute",
        "translate-middle",
        {
          "start-0 top-0": d === "top-start",
          "start-0 top-50": d === "start",
          "start-0 top-100": d === "bottom-start",
          "start-50 top-0": d === "top",
          "start-50 top-100": d === "bottom",
          "start-100 top-0": d === "top-end",
          "start-100 top-50": d === "end",
          "start-100 top-100": d === "bottom-end"
        }
      ];
    }), i = _(() => [
      l.value,
      e.placement !== void 0 || e.dotIndicator === !0 ? u.value : void 0,
      {
        active: e.active,
        disabled: e.disabled,
        "rounded-pill": e.pill,
        "p-2 border border-light rounded-circle": e.dotIndicator,
        "text-decoration-none": t.value
      }
    ]);
    return (d, f) => (m(), P(ce(r.value), K({
      class: ["badge", i.value]
    }, n(s)), {
      default: I(() => [
        ye(qt, K({
          skip: n(e).dotIndicator !== !0,
          tag: "span"
        }, n(e).dotIndicator ? { class: "visually-hidden" } : {}), {
          default: I(() => [
            $(d.$slots, "default")
          ]),
          _: 3
        }, 16, ["skip"])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), pi = {
  key: 0,
  class: "b-avatar-custom"
}, vi = {
  key: 1,
  class: "b-avatar-img"
}, mi = ["src", "alt"], Al = 0.4, bi = /* @__PURE__ */ L({
  __name: "BAvatar",
  props: {
    alt: { default: "avatar" },
    badge: { type: [Boolean, String], default: !1 },
    badgeBgVariant: { default: null },
    badgePlacement: { default: "top-end" },
    badgeTextVariant: { default: null },
    badgeVariant: { default: "primary" },
    badgePill: { type: Boolean, default: !1 },
    badgeDotIndicator: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    buttonType: { default: "button" },
    size: { default: void 0 },
    square: { type: Boolean, default: !1 },
    src: { default: void 0 },
    text: { default: void 0 },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: "secondary" },
    bgVariant: { default: null },
    textVariant: { default: null },
    rounded: { type: [Boolean, String, Number], default: !1 },
    roundedTop: { type: [Boolean, String, Number], default: void 0 },
    roundedBottom: { type: [Boolean, String, Number], default: void 0 },
    roundedStart: { type: [Boolean, String, Number], default: void 0 },
    roundedEnd: { type: [Boolean, String, Number], default: void 0 }
  },
  emits: ["click", "img-error"],
  setup(a, { emit: o }) {
    const e = a, l = o, t = He(), { computedLink: s, computedLinkProps: r } = Ct(e), u = Ve($o, null), i = ["sm", null, "lg"], d = Al * 0.7, f = k(() => !Ae(t.default)), c = k(() => !Ae(t.badge)), y = k(() => !!e.badge || e.badge === "" || c.value), p = k(() => (u == null ? void 0 : u.size.value) ?? e.square), b = ma(() => e.size), h = ma(() => u == null ? void 0 : u.size.value), w = _(() => h.value ?? b.value), v = k(() => (u == null ? void 0 : u.variant.value) ?? e.variant), B = k(() => (u == null ? void 0 : u.rounded.value) ?? e.rounded), g = k(() => (u == null ? void 0 : u.roundedTop.value) ?? e.roundedTop), S = k(() => (u == null ? void 0 : u.roundedBottom.value) ?? e.roundedBottom), C = k(() => (u == null ? void 0 : u.roundedStart.value) ?? e.roundedStart), x = k(() => (u == null ? void 0 : u.roundedEnd.value) ?? e.roundedEnd), V = nl(() => ({
      rounded: B.value,
      roundedTop: g.value,
      roundedBottom: S.value,
      roundedStart: C.value,
      roundedEnd: x.value
    })), q = k(() => e.badge === !0 ? "" : e.badge), G = _(() => !q.value && !c.value), O = k(() => (u == null ? void 0 : u.textVariant.value) ?? e.textVariant), Z = k(() => (u == null ? void 0 : u.bgVariant.value) ?? e.bgVariant), ae = ot(() => ({
      bgVariant: Z.value,
      textVariant: O.value,
      variant: v.value
    })), ie = _(() => [
      ae.value,
      // Square overwrites all else
      p.value === !0 ? void 0 : V.value,
      {
        [`b-avatar-${e.size}`]: !!e.size && i.indexOf(b.value) !== -1,
        [`btn-${v.value}`]: e.button ? v.value !== null : !1,
        badge: !e.button && v.value !== null && f.value,
        btn: e.button,
        // Square is the same as rounded-0 class
        "rounded-0": p.value === !0
      }
    ]), X = _(() => ({
      fontSize: i.indexOf(w.value || null) === -1 ? `calc(${w.value} * ${d})` : ""
    })), j = _(() => {
      const D = i.indexOf(w.value || null) === -1 ? `calc(${w.value} * ${Al})` : null;
      return D ? { fontSize: D } : {};
    }), T = _(() => {
      var re;
      const D = ((re = u == null ? void 0 : u.overlapScale) == null ? void 0 : re.value) || 0, te = w.value && D ? `calc(${w.value} * -${D})` : null;
      return te ? { marginLeft: te, marginRight: te } : {};
    }), N = k(() => s.value ? st : e.button ? "button" : "span"), F = _(() => ({
      ...T.value,
      width: w.value ?? void 0,
      height: w.value ?? void 0
    })), W = (D) => {
      !e.disabled && (s.value || e.button) && l("click", D);
    }, E = (D) => {
      l("img-error", D);
    };
    return (D, te) => (m(), P(ce(N.value), K({
      class: ["b-avatar", ie.value],
      style: F.value
    }, n(r), {
      type: e.button && !n(s) ? e.buttonType : void 0,
      disabled: e.disabled || null,
      onClick: W
    }), {
      default: I(() => [
        f.value ? (m(), A("span", pi, [
          $(D.$slots, "default")
        ])) : e.src ? (m(), A("span", vi, [
          Q("img", {
            src: e.src,
            alt: e.alt,
            onError: E
          }, null, 40, mi)
        ])) : e.text ? (m(), A("span", {
          key: 2,
          class: "b-avatar-text",
          style: Le(j.value)
        }, J(e.text), 5)) : ee("", !0),
        y.value ? (m(), P(on, {
          key: 3,
          pill: e.badgePill,
          "dot-indicator": e.badgeDotIndicator || G.value,
          variant: e.badgeVariant,
          "bg-variant": e.badgeBgVariant,
          "text-variant": e.badgeTextVariant,
          style: Le(X.value),
          placement: e.badgePlacement
        }, {
          default: I(() => [
            $(D.$slots, "badge", {}, () => [
              ue(J(q.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["pill", "dot-indicator", "variant", "bg-variant", "text-variant", "style", "placement"])) : ee("", !0)
      ]),
      _: 3
    }, 16, ["class", "style", "type", "disabled"]));
  }
}), yi = /* @__PURE__ */ L({
  __name: "BAvatarGroup",
  props: {
    overlap: { default: 0.3 },
    size: { default: void 0 },
    square: { type: Boolean, default: !1 },
    tag: { default: "div" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null },
    rounded: { type: [Boolean, String, Number], default: !1 },
    roundedTop: { type: [Boolean, String, Number], default: void 0 },
    roundedBottom: { type: [Boolean, String, Number], default: void 0 },
    roundedStart: { type: [Boolean, String, Number], default: void 0 },
    roundedEnd: { type: [Boolean, String, Number], default: void 0 }
  },
  setup(a) {
    const e = M(a, "BAvatarGroup"), l = he(() => e.overlap), t = ma(() => e.size), s = k(() => Math.min(Math.max(l.value, 0), 1) / 2), r = _(() => {
      const u = t.value ? `calc(${t.value} * ${s.value})` : null;
      return u ? { paddingLeft: u, paddingRight: u } : {};
    });
    return Xe($o, {
      overlapScale: s,
      size: k(() => e.size),
      square: k(() => e.square),
      rounded: k(() => e.rounded),
      roundedTop: k(() => e.roundedTop),
      roundedBottom: k(() => e.roundedBottom),
      roundedStart: k(() => e.roundedStart),
      roundedEnd: k(() => e.roundedEnd),
      variant: k(() => e.variant),
      bgVariant: k(() => e.bgVariant),
      textVariant: k(() => e.textVariant)
    }), (u, i) => (m(), P(ce(n(e).tag), {
      class: "b-avatar-group",
      role: "group"
    }, {
      default: I(() => [
        Q("div", {
          class: "b-avatar-group-inner",
          style: Le(r.value)
        }, [
          $(u.$slots, "default")
        ], 4)
      ]),
      _: 3
    }));
  }
}), nn = /* @__PURE__ */ L({
  __name: "BBreadcrumbItem",
  props: {
    ariaCurrent: { default: "location" },
    text: { default: void 0 },
    active: { type: Boolean, default: !1 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: void 0 }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BBreadcrumbItem"), t = o, s = _(() => ({
      active: l.active
    })), r = k(() => l.active ? "span" : st), u = k(() => l.active ? l.ariaCurrent : void 0), i = _(
      () => r.value !== "span" ? ll(l, [
        "active",
        "activeClass",
        "append",
        "disabled",
        "href",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "variant",
        "opacity",
        "opacityHover",
        "underlineVariant",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover",
        "icon"
      ]) : {}
    ), d = (f) => {
      if (l.disabled || l.active) {
        f.preventDefault(), f.stopImmediatePropagation();
        return;
      }
      l.disabled || t("click", f);
    };
    return (f, c) => (m(), A("li", {
      class: R(["breadcrumb-item", s.value])
    }, [
      (m(), P(ce(r.value), K({ "aria-current": u.value }, i.value, { onClick: d }), {
        default: I(() => [
          $(f.$slots, "default", {}, () => [
            ue(J(n(l).text), 1)
          ])
        ]),
        _: 3
      }, 16, ["aria-current"]))
    ], 2));
  }
}), gi = { "aria-label": "breadcrumb" }, hi = { class: "breadcrumb" }, Bi = /* @__PURE__ */ L({
  __name: "BBreadcrumb",
  props: {
    items: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BBreadcrumb"), l = zo(), t = _(() => {
      var i;
      const s = e.items || ((i = l.items) == null ? void 0 : i.value) || [];
      let r = !1;
      return s.map((d, f) => (typeof d == "string" && (d = { text: d }, f < s.length - 1 && (d.href = "#")), d.active && (r = !0), !d.active && !r && (d.active = f + 1 === s.length), d));
    });
    return (s, r) => (m(), A("nav", gi, [
      Q("ol", hi, [
        $(s.$slots, "prepend"),
        (m(!0), A(ve, null, ke(t.value, (u, i) => (m(), P(nn, K({
          key: i,
          ref_for: !0
        }, u), {
          default: I(() => [
            ue(J(u.text), 1)
          ]),
          _: 2
        }, 1040))), 128)),
        $(s.$slots, "default"),
        $(s.$slots, "append")
      ])
    ]));
  }
}), _i = /* @__PURE__ */ L({
  __name: "BButtonGroup",
  props: {
    ariaLabel: { default: "Group" },
    size: { default: "md" },
    tag: { default: "div" },
    vertical: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BButtonGroup"), l = _(() => ({
      "btn-group": !e.vertical,
      [`btn-group-${e.size}`]: e.size !== "md",
      "btn-group-vertical": e.vertical
    }));
    return (t, s) => (m(), P(ce(n(e).tag), {
      class: R(l.value),
      role: "group",
      "aria-label": n(e).ariaLabel
    }, {
      default: I(() => [
        $(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "aria-label"]));
  }
}), wi = ["role", "aria-label"], Ci = /* @__PURE__ */ L({
  __name: "BButtonToolbar",
  props: {
    ariaLabel: { default: "Group" },
    justify: { type: Boolean, default: !1 },
    role: { default: "toolbar" }
  },
  setup(a) {
    const e = M(a, "BButtonToolbar"), l = _(() => ({
      "justify-content-between": e.justify
    }));
    return (t, s) => (m(), A("div", {
      class: R([l.value, "btn-toolbar"]),
      role: n(e).role,
      "aria-label": n(e).ariaLabel
    }, [
      $(t.$slots, "default")
    ], 10, wi));
  }
}), ki = ["src", "width", "height", "srcset", "sizes", "loading"], sl = /* @__PURE__ */ L({
  __name: "BImg",
  props: {
    blank: { type: Boolean, default: !1 },
    blankColor: { default: "transparent" },
    block: { type: Boolean, default: !1 },
    fluid: { type: Boolean, default: !1 },
    fluidGrow: { type: Boolean, default: !1 },
    height: { default: void 0 },
    lazy: { type: Boolean, default: !1 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    thumbnail: { type: Boolean, default: !1 },
    width: { default: void 0 },
    placement: { default: void 0 },
    rounded: { type: [Boolean, String, Number], default: !1 },
    roundedTop: { type: [Boolean, String, Number], default: void 0 },
    roundedBottom: { type: [Boolean, String, Number], default: void 0 },
    roundedStart: { type: [Boolean, String, Number], default: void 0 },
    roundedEnd: { type: [Boolean, String, Number], default: void 0 }
  },
  setup(a) {
    const e = M(a, "BImg"), l = he(() => e.height ?? NaN), t = he(() => e.width ?? NaN), s = nl(() => ({
      rounded: e.rounded,
      roundedTop: e.roundedTop,
      roundedBottom: e.roundedBottom,
      roundedStart: e.roundedStart,
      roundedEnd: e.roundedEnd
    })), r = _(
      () => typeof e.srcset == "string" ? e.srcset.split(",").filter((p) => p).join(",") : Array.isArray(e.srcset) ? e.srcset.filter((p) => p).join(",") : void 0
    ), u = _(
      () => typeof e.sizes == "string" ? e.sizes.split(",").filter((p) => p).join(",") : Array.isArray(e.sizes) ? e.sizes.filter((p) => p).join(",") : void 0
    ), i = _(() => {
      const p = Number.isNaN(t.value) ? void 0 : t.value, b = Number.isNaN(l.value) ? void 0 : l.value;
      if (e.blank) {
        if (p !== void 0 && b === void 0)
          return { height: p, width: p };
        if (p === void 0 && b !== void 0)
          return { height: b, width: b };
        if (p === void 0 && b === void 0)
          return { height: 1, width: 1 };
      }
      return {
        width: p,
        height: b
      };
    }), d = k(
      () => y(i.value.width, i.value.height, e.blankColor)
    ), f = _(() => ({
      "float-start": e.placement === "start",
      "float-end": e.placement === "end",
      "mx-auto": e.placement === "center"
    })), c = _(() => [
      s.value,
      f.value,
      {
        "img-thumbnail": e.thumbnail,
        "img-fluid": e.fluid || e.fluidGrow,
        "w-100": e.fluidGrow,
        "d-block": e.block || e.placement === "center"
      }
    ]), y = (p, b, h) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`<svg width="${p}" height="${b}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${p} ${b}" preserveAspectRatio="none">
    <rect width="100%" height="100%" style="fill:${h};"></rect>
    </svg>`)}`;
    return (p, b) => (m(), A("img", {
      class: R(c.value),
      src: n(e).blank ? d.value : n(e).src,
      width: i.value.width || void 0,
      height: i.value.height || void 0,
      srcset: n(e).blank ? void 0 : r.value,
      sizes: n(e).blank ? void 0 : u.value,
      loading: n(e).lazy ? "lazy" : "eager"
    }, null, 10, ki));
  }
}), rl = /* @__PURE__ */ L({
  __name: "BCardImg",
  props: {
    placement: { default: "top" },
    blank: { type: Boolean, default: void 0 },
    blankColor: { default: void 0 },
    block: { type: Boolean, default: void 0 },
    fluid: { type: Boolean, default: void 0 },
    fluidGrow: { type: Boolean, default: void 0 },
    height: { default: void 0 },
    lazy: { type: Boolean, default: void 0 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    thumbnail: { type: Boolean, default: void 0 },
    width: { default: void 0 },
    rounded: { type: [Boolean, String, Number], default: void 0 },
    roundedTop: { type: [Boolean, String, Number], default: void 0 },
    roundedBottom: { type: [Boolean, String, Number], default: void 0 },
    roundedStart: { type: [Boolean, String, Number], default: void 0 },
    roundedEnd: { type: [Boolean, String, Number], default: void 0 }
  },
  setup(a) {
    const e = M(a, "BCardImg"), l = _(() => ({
      "card-img-top": e.placement === "top",
      // TODO implement this class
      "card-img-end": e.placement === "end",
      "card-img-bottom": e.placement === "bottom",
      // TODO implement this class
      "card-img-start": e.placement === "start",
      "card-img": e.placement === "overlay"
    })), t = _(() => ha(e, ["placement"]));
    return (s, r) => (m(), P(sl, K(t.value, { class: l.value }), null, 16, ["class"]));
  }
}), Ti = ["innerHTML"], sn = /* @__PURE__ */ L({
  __name: "BCardHeadFoot",
  props: {
    borderVariant: { default: null },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(a) {
    const o = a, e = ot(o), l = _(() => [
      e.value,
      {
        [`border-${o.borderVariant}`]: o.borderVariant !== null
      }
    ]);
    return (t, s) => (m(), P(ce(t.tag), {
      class: R(l.value)
    }, {
      default: I(() => [
        t.html ? (m(), A("div", {
          key: 0,
          innerHTML: t.html
        }, null, 8, Ti)) : $(t.$slots, "default", { key: 1 }, () => [
          ue(J(t.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), rn = /* @__PURE__ */ L({
  __name: "BCardHeader",
  props: {
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BCardHeader");
    return (l, t) => (m(), P(sn, K({ class: "card-header" }, n(e)), {
      default: I(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), un = /* @__PURE__ */ L({
  __name: "BCardTitle",
  props: {
    tag: { default: "h4" },
    text: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BCardTitle");
    return (l, t) => (m(), P(ce(n(e).tag), { class: "card-title" }, {
      default: I(() => [
        $(l.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), dn = /* @__PURE__ */ L({
  __name: "BCardSubtitle",
  props: {
    text: { default: void 0 },
    tag: { default: "h6" },
    textVariant: { default: "body-secondary" }
  },
  setup(a) {
    const e = M(a, "BCardSubtitle"), l = _(() => ({
      [`text-${e.textVariant}`]: e.textVariant !== null
    }));
    return (t, s) => (m(), P(ce(n(e).tag), {
      class: R(["card-subtitle mb-2", l.value])
    }, {
      default: I(() => [
        $(t.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), cn = /* @__PURE__ */ L({
  __name: "BCardBody",
  props: {
    overlay: { type: Boolean, default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h4" },
    subtitleTextVariant: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(a) {
    const e = M(a, "BCardBody"), l = He(), t = ot(e), s = k(() => !Ae(l.title)), r = k(() => !Ae(l.subtitle)), u = _(() => [
      t.value,
      e.overlay ? "card-img-overlay" : "card-body"
    ]);
    return (i, d) => (m(), P(ce(n(e).tag), {
      class: R(u.value)
    }, {
      default: I(() => [
        n(e).title || s.value ? (m(), P(un, {
          key: 0,
          tag: n(e).titleTag
        }, {
          default: I(() => [
            $(i.$slots, "title", {}, () => [
              ue(J(n(e).title), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag"])) : ee("", !0),
        n(e).subtitle || r.value ? (m(), P(dn, {
          key: 1,
          tag: n(e).subtitleTag,
          "text-variant": n(e).subtitleTextVariant
        }, {
          default: I(() => [
            $(i.$slots, "subtitle", {}, () => [
              ue(J(n(e).subtitle), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag", "text-variant"])) : ee("", !0),
        $(i.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), fn = /* @__PURE__ */ L({
  __name: "BCardFooter",
  props: {
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BCardFooter");
    return (l, t) => (m(), P(sn, K({ class: "card-footer" }, n(e)), {
      default: I(() => [
        $(l.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), pn = /* @__PURE__ */ L({
  __name: "BCard",
  props: {
    align: { default: void 0 },
    bodyBgVariant: { default: void 0 },
    bodyClass: { default: void 0 },
    bodyTag: { default: "div" },
    bodyText: { default: "" },
    bodyTextVariant: { default: void 0 },
    borderVariant: { default: null },
    footer: { default: void 0 },
    footerBgVariant: { default: void 0 },
    footerBorderVariant: { default: void 0 },
    footerClass: { default: void 0 },
    footerHtml: { default: "" },
    footerTag: { default: "div" },
    footerTextVariant: { default: void 0 },
    footerVariant: { default: null },
    header: { default: void 0 },
    headerBgVariant: { default: void 0 },
    headerBorderVariant: { default: void 0 },
    headerClass: { default: void 0 },
    headerHtml: { default: "" },
    headerTag: { default: "div" },
    headerTextVariant: { default: void 0 },
    headerVariant: { default: null },
    imgAlt: { default: void 0 },
    imgPlacement: { default: "top" },
    imgHeight: { default: void 0 },
    imgSrc: { default: void 0 },
    imgWidth: { default: void 0 },
    noBody: { type: Boolean, default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h6" },
    subtitleTextVariant: { default: "body-secondary" },
    tag: { default: "div" },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(a) {
    const e = M(a, "BCard"), l = He(), t = k(() => !Ae(l.header)), s = k(() => !Ae(l.footer)), r = ot(e), u = _(() => [
      r.value,
      {
        [`text-${e.align}`]: e.align !== void 0,
        [`border-${e.borderVariant}`]: e.borderVariant !== null,
        "flex-row": e.imgPlacement === "start",
        "flex-row-reverse": e.imgPlacement === "end"
      }
    ]), i = _(() => ({
      src: e.imgSrc,
      alt: e.imgAlt,
      height: e.imgHeight,
      width: e.imgWidth,
      placement: e.imgPlacement
    })), d = ua();
    return (f, c) => (m(), P(ce(n(e).tag), {
      class: R(["card", u.value])
    }, {
      default: I(() => [
        ye(n(d).define, null, {
          default: I(() => [
            $(f.$slots, "img", {}, () => [
              n(e).imgSrc ? (m(), P(rl, Be(K({ key: 0 }, i.value)), null, 16)) : ee("", !0)
            ])
          ]),
          _: 3
        }),
        n(e).imgPlacement !== "bottom" ? (m(), P(n(d).reuse, { key: 0 })) : ee("", !0),
        n(e).header || t.value || n(e).headerHtml ? (m(), P(rn, {
          key: 1,
          "bg-variant": n(e).headerBgVariant,
          variant: n(e).headerVariant,
          "border-variant": n(e).headerBorderVariant,
          html: n(e).headerHtml,
          tag: n(e).headerTag,
          "text-variant": n(e).headerTextVariant,
          class: R(n(e).headerClass)
        }, {
          default: I(() => [
            $(f.$slots, "header", {}, () => [
              ue(J(n(e).header), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "variant", "border-variant", "html", "tag", "text-variant", "class"])) : ee("", !0),
        n(e).noBody ? $(f.$slots, "default", { key: 3 }, () => [
          ue(J(n(e).bodyText), 1)
        ]) : (m(), P(cn, {
          key: 2,
          overlay: n(e).imgPlacement === "overlay",
          "bg-variant": n(e).bodyBgVariant,
          tag: n(e).bodyTag,
          "text-variant": n(e).bodyTextVariant,
          subtitle: n(e).subtitle,
          "subtitle-tag": n(e).subtitleTag,
          "subtitle-text-variant": n(e).subtitleTextVariant,
          title: n(e).title,
          "title-tag": n(e).titleTag,
          class: R(n(e).bodyClass)
        }, {
          default: I(() => [
            $(f.$slots, "default", {}, () => [
              ue(J(n(e).bodyText), 1)
            ])
          ]),
          _: 3
        }, 8, ["overlay", "bg-variant", "tag", "text-variant", "subtitle", "subtitle-tag", "subtitle-text-variant", "title", "title-tag", "class"])),
        n(e).footer || s.value || n(e).footerHtml ? (m(), P(fn, {
          key: 4,
          "bg-variant": n(e).footerBgVariant,
          "border-variant": n(e).footerBorderVariant,
          variant: n(e).footerVariant,
          html: n(e).footerHtml,
          tag: n(e).footerTag,
          "text-variant": n(e).footerTextVariant,
          class: R(n(e).footerClass)
        }, {
          default: I(() => [
            $(f.$slots, "footer", {}, () => [
              ue(J(n(e).footer), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "border-variant", "variant", "html", "tag", "text-variant", "class"])) : ee("", !0),
        n(e).imgPlacement === "bottom" ? (m(), P(n(d).reuse, { key: 5 })) : ee("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), $i = /* @__PURE__ */ L({
  __name: "BCardGroup",
  props: {
    columns: { type: Boolean, default: !1 },
    deck: { type: Boolean, default: !1 },
    tag: { default: "div" }
  },
  setup(a) {
    const e = M(a, "BCardGroup"), l = k(
      () => e.deck ? "card-deck" : e.columns ? "card-columns" : "card-group"
    );
    return (t, s) => (m(), P(ce(n(e).tag), {
      class: R(l.value)
    }, {
      default: I(() => [
        $(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), xi = /* @__PURE__ */ L({
  __name: "BCardText",
  props: {
    tag: { default: "p" },
    text: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BCardText");
    return (l, t) => (m(), P(ce(n(e).tag), { class: "card-text" }, {
      default: I(() => [
        $(l.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), Si = ["id"], Vi = {
  key: 0,
  class: "carousel-indicators"
}, Ai = ["aria-current", "aria-label", "onClick"], Oi = /* @__PURE__ */ Q("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1), Ii = { class: "visually-hidden" }, Pi = /* @__PURE__ */ Q("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1), Ni = { class: "visually-hidden" }, Ei = /* @__PURE__ */ L({
  __name: "BCarousel",
  props: /* @__PURE__ */ ge({
    background: { default: void 0 },
    controls: { type: Boolean, default: !1 },
    controlsNextText: { default: "Next" },
    controlsPrevText: { default: "Previous" },
    fade: { type: Boolean, default: !1 },
    id: { default: void 0 },
    imgHeight: { default: void 0 },
    imgWidth: { default: void 0 },
    indicators: { type: Boolean, default: !1 },
    indicatorsButtonLabel: { default: "Slide" },
    interval: { default: 5e3 },
    keyboard: { type: Boolean, default: !0 },
    modelValue: {},
    noHoverPause: { type: Boolean, default: !1 },
    noTouch: { type: Boolean, default: !1 },
    noWrap: { type: Boolean, default: !1 },
    ride: { type: [Boolean, String], default: !1 },
    rideReverse: { type: Boolean, default: !1 },
    touchThreshold: { default: 50 }
  }, {
    modelValue: { default: 0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["slide", "slid"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BCarousel"), s = e, r = He(), u = we(() => t.id, "carousel"), i = _e(a, "modelValue"), d = z(null), f = he(() => t.touchThreshold), c = z(null);
    Ue(() => {
      var re, U;
      c.value = ((U = (re = d.value) == null ? void 0 : re.find((ne) => ne.$el.style.display !== "none")) == null ? void 0 : U.$props.interval) ?? null;
    });
    const y = he(() => c.value ?? t.interval), p = z(!1), b = z(!1), h = z(!0), w = z(null), v = z(null), B = z(i.value), g = Qa(v), S = k(
      () => `carousel-item carousel-item-${h.value ? "prev" : "next"} carousel-item-${h.value ? "end" : "start"}`
    ), C = k(
      () => `carousel-item active carousel-item-${h.value ? "start" : "end"}`
    ), { pause: x, resume: V } = bo(
      () => {
        t.rideReverse ? ie() : X();
      },
      y,
      { immediate: t.ride === "carousel" }
    ), q = k(
      () => t.ride === !0 && b.value === !0 || t.ride === "carousel"
    ), G = _(() => wr(r.default, "BCarouselSlide")), O = _(() => ({ "carousel-fade": t.fade })), Z = (re) => {
      var U;
      return new Wl(re, {
        componentId: u.value,
        cancelable: !1,
        target: v.value,
        direction: h.value ? "right" : "left",
        from: B.value,
        to: i.value,
        relatedTarget: ((U = w.value) == null ? void 0 : U.children[i.value]) ?? null
      });
    }, ae = (re) => {
      if (p.value !== !0) {
        if (t.ride === !0 && (b.value = !0), q.value === !0 && V(), h.value = !(re < i.value), re >= G.value.length) {
          if (t.noWrap)
            return;
          i.value = 0;
          return;
        }
        if (re < 0) {
          if (t.noWrap)
            return;
          i.value = G.value.length - 1;
          return;
        }
        B.value = i.value, i.value = re;
      }
    }, ie = () => {
      ae(i.value - 1);
    }, X = () => {
      ae(i.value + 1);
    }, j = (re) => {
      t.keyboard !== !1 && re();
    }, T = () => {
      t.noHoverPause || x();
    }, N = () => {
      q.value && V();
    }, { lengthX: F } = vr(v, {
      passive: !0,
      onSwipeStart() {
        t.noTouch !== !0 && x();
      },
      onSwipeEnd() {
        if (t.noTouch === !0)
          return;
        const re = () => {
          q.value !== !1 && V();
        };
        if (F.value >= f.value) {
          X(), re();
          return;
        }
        F.value <= -f.value && (ie(), re());
      }
    }), W = () => {
      s("slide", Z("slide")), p.value = !0;
    }, E = () => {
      s("slid", Z("slid")), p.value = !1;
    }, D = (re) => {
      i.value !== 0 && re.classList.add("carousel-item");
    }, te = (re) => {
      var U, ne;
      c.value = ((ne = (U = d.value) == null ? void 0 : U.find((pe) => pe.$el === re)) == null ? void 0 : ne.$props.interval) ?? null;
    };
    return De(
      "ArrowLeft",
      () => {
        j(ie);
      },
      { target: v }
    ), De(
      "ArrowRight",
      () => {
        j(X);
      },
      { target: v }
    ), fe(
      () => t.ride,
      () => {
        b.value = !1;
      }
    ), fe(g, (re) => {
      if (re) {
        T();
        return;
      }
      N();
    }), o({
      next: X,
      pause: x,
      prev: ie,
      resume: V
    }), Xe(wo, {
      background: k(() => t.background),
      width: k(() => t.imgWidth),
      height: k(() => t.imgHeight)
    }), (re, U) => (m(), A("div", {
      id: n(u),
      ref_key: "element",
      ref: v,
      class: R(["carousel slide pointer-event", O.value])
    }, [
      n(t).indicators ? (m(), A("div", Vi, [
        (m(!0), A(ve, null, ke(G.value.length, (ne, pe) => (m(), A("button", {
          key: pe,
          type: "button",
          "data-bs-target": "",
          class: R(pe === i.value ? "active" : ""),
          "aria-current": pe === i.value ? !0 : void 0,
          "aria-label": `${n(t).indicatorsButtonLabel} ${pe}`,
          onClick: (Y) => ae(pe)
        }, null, 10, Ai))), 128))
      ])) : ee("", !0),
      Q("div", {
        ref_key: "relatedTarget",
        ref: w,
        class: "carousel-inner"
      }, [
        ye(Gl, {
          "enter-from-class": S.value,
          "enter-active-class": S.value,
          "enter-to-class": S.value,
          "leave-from-class": C.value,
          "leave-active-class": C.value,
          "leave-to-class": C.value,
          onBeforeLeave: W,
          onAfterLeave: E,
          onAfterEnter: D,
          onEnter: te
        }, {
          default: I(() => [
            (m(!0), A(ve, null, ke(G.value, (ne, pe) => ct((m(), P(ce(ne), {
              key: pe,
              ref_for: !0,
              ref_key: "slideValues",
              ref: d,
              class: R({ active: pe === i.value && p.value === !1 })
            }, null, 8, ["class"])), [
              [jt, pe === i.value]
            ])), 128))
          ]),
          _: 1
        }, 8, ["enter-from-class", "enter-active-class", "enter-to-class", "leave-from-class", "leave-active-class", "leave-to-class"])
      ], 512),
      n(t).controls ? (m(), A(ve, { key: 1 }, [
        Q("button", {
          class: "carousel-control-prev",
          type: "button",
          onClick: ie
        }, [
          Oi,
          Q("span", Ii, J(n(t).controlsPrevText), 1)
        ]),
        Q("button", {
          class: "carousel-control-next",
          type: "button",
          onClick: X
        }, [
          Pi,
          Q("span", Ni, J(n(t).controlsNextText), 1)
        ])
      ], 64)) : ee("", !0)
    ], 10, Si));
  }
}), Fi = ["innerHTML"], Li = { key: 1 }, zi = ["innerHTML"], Hi = { key: 1 }, Mi = /* @__PURE__ */ L({
  __name: "BCarouselSlide",
  props: {
    background: { default: void 0 },
    caption: { default: void 0 },
    captionHtml: { default: void 0 },
    captionTag: { default: "h3" },
    contentTag: { default: "div" },
    contentVisibleUp: { default: void 0 },
    id: { default: void 0 },
    imgAlt: { default: void 0 },
    imgBlank: { type: Boolean, default: !1 },
    imgBlankColor: { default: "transparent" },
    imgHeight: { default: void 0 },
    imgSrc: { default: void 0 },
    imgSrcset: { default: void 0 },
    imgWidth: { default: void 0 },
    interval: { default: void 0 },
    text: { default: void 0 },
    textHtml: { default: void 0 },
    textTag: { default: "p" }
  },
  setup(a) {
    const e = M(a, "BCarouselSlide"), l = He(), t = Ve(wo, null), s = k(() => e.text || e.textHtml || !Ae(l.text)), r = k(() => e.caption || e.captionHtml || !Ae(l.caption)), u = k(() => s.value || r.value || !Ae(l.default)), i = _(() => ({
      background: `${e.background || (t == null ? void 0 : t.background.value) || "rgb(171, 171, 171)"} none repeat scroll 0% 0%`
    })), d = _(() => ({
      "d-none": e.contentVisibleUp !== void 0,
      [`d-${e.contentVisibleUp}-block`]: e.contentVisibleUp !== void 0
    }));
    return (f, c) => (m(), A("div", {
      class: "carousel-item",
      style: Le(i.value)
    }, [
      $(f.$slots, "img", {}, () => {
        var y, p;
        return [
          ye(sl, {
            class: "d-block w-100",
            alt: n(e).imgAlt,
            srcset: n(e).imgSrcset,
            src: n(e).imgSrc,
            width: n(e).imgWidth || ((y = n(t)) == null ? void 0 : y.width.value),
            height: n(e).imgHeight || ((p = n(t)) == null ? void 0 : p.height.value),
            blank: n(e).imgBlank,
            "blank-color": n(e).imgBlankColor
          }, null, 8, ["alt", "srcset", "src", "width", "height", "blank", "blank-color"])
        ];
      }),
      u.value ? (m(), P(ce(n(e).contentTag), {
        key: 0,
        class: R(["carousel-caption", d.value])
      }, {
        default: I(() => [
          r.value ? (m(), P(ce(n(e).captionTag), { key: 0 }, {
            default: I(() => [
              $(f.$slots, "caption", {}, () => [
                n(e).captionHtml ? (m(), A("span", {
                  key: 0,
                  innerHTML: n(e).captionHtml
                }, null, 8, Fi)) : (m(), A("span", Li, J(n(e).caption), 1))
              ])
            ]),
            _: 3
          })) : ee("", !0),
          s.value ? (m(), P(ce(n(e).textTag), { key: 1 }, {
            default: I(() => [
              $(f.$slots, "text", {}, () => [
                n(e).textHtml ? (m(), A("span", {
                  key: 0,
                  innerHTML: n(e).textHtml
                }, null, 8, zi)) : (m(), A("span", Hi, J(n(e).text), 1))
              ])
            ]),
            _: 3
          })) : ee("", !0),
          $(f.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"])) : ee("", !0)
    ], 4));
  }
}), zt = /* @__PURE__ */ L({
  __name: "BCol",
  props: {
    alignSelf: { default: void 0 },
    tag: { default: "div" },
    order: { default: void 0 },
    offset: { default: void 0 },
    cols: { default: void 0 },
    col: { type: Boolean, default: !1 },
    offsetSm: { default: void 0 },
    offsetMd: { default: void 0 },
    offsetLg: { default: void 0 },
    offsetXl: { default: void 0 },
    offsetXxl: { default: void 0 },
    orderSm: { default: void 0 },
    orderMd: { default: void 0 },
    orderLg: { default: void 0 },
    orderXl: { default: void 0 },
    orderXxl: { default: void 0 },
    sm: { type: [Boolean, Number, String], default: !1 },
    md: { type: [Boolean, Number, String], default: !1 },
    lg: { type: [Boolean, Number, String], default: !1 },
    xl: { type: [Boolean, Number, String], default: !1 },
    xxl: { type: [Boolean, Number, String], default: !1 }
  },
  setup(a) {
    const e = M(a, "BCol"), l = _(() => [
      ...Qt(
        {
          sm: e.sm,
          md: e.md,
          lg: e.lg,
          xl: e.xl,
          xxl: e.xxl
        },
        ["sm", "md", "lg", "xl", "xxl"],
        "col"
      ),
      ...Qt(
        {
          order: e.order,
          orderLg: e.orderLg,
          orderMd: e.orderMd,
          orderSm: e.orderSm,
          orderXl: e.orderXl,
          orderXxl: e.orderXxl
        },
        ["order", "orderLg", "orderMd", "orderSm", "orderXl", "orderXxl"],
        "order"
      ),
      ...Qt(
        {
          offset: e.offset,
          offsetLg: e.offsetLg,
          offsetMd: e.offsetMd,
          offsetSm: e.offsetSm,
          offsetXl: e.offsetXl,
          offsetXxl: e.offsetXxl
        },
        ["offset", "offsetLg", "offsetMd", "offsetSm", "offsetXl", "offsetXxl"],
        "offset"
      )
    ]), t = _(() => [
      l.value,
      {
        col: e.col || !l.value.some((s) => s.startsWith("col-")) && !e.cols,
        [`col-${e.cols}`]: e.cols !== void 0,
        [`offset-${e.offset}`]: e.offset !== void 0,
        [`order-${e.order}`]: e.order !== void 0,
        [`align-self-${e.alignSelf}`]: e.alignSelf !== void 0
      }
    ]);
    return (s, r) => (m(), P(ce(n(e).tag), {
      class: R(t.value)
    }, {
      default: I(() => [
        $(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ri = /* @__PURE__ */ L({
  __name: "BContainer",
  props: {
    fluid: { type: [Boolean, String], default: !1 },
    gutterX: { default: void 0 },
    gutterY: { default: void 0 },
    tag: { default: "div" }
  },
  setup(a) {
    const e = M(a, "BContainer"), l = _(() => ({
      container: e.fluid === !1,
      "container-fluid": e.fluid === !0,
      [`container-${e.fluid}`]: typeof e.fluid == "string",
      [`gx-${e.gutterX}`]: e.gutterX !== void 0,
      [`gy-${e.gutterY}`]: e.gutterY !== void 0
    }));
    return (t, s) => (m(), P(ce(n(e).tag), {
      class: R(l.value)
    }, {
      default: I(() => [
        $(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Di = { class: "visually-hidden" }, ji = ["aria-labelledby", "role"], vn = /* @__PURE__ */ L({
  __name: "BDropdown",
  props: /* @__PURE__ */ ge({
    ariaLabel: { default: void 0 },
    autoClose: { type: [Boolean, String], default: !0 },
    boundary: { default: "clippingAncestors" },
    boundaryPadding: { default: void 0 },
    center: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dropend: { type: Boolean, default: !1 },
    dropstart: { type: Boolean, default: !1 },
    dropup: { type: Boolean, default: !1 },
    end: { type: Boolean, default: !1 },
    floatingMiddleware: { default: void 0 },
    id: { default: void 0 },
    isNav: { type: Boolean, default: !1 },
    lazy: { type: Boolean, default: !1 },
    menuClass: { default: void 0 },
    modelValue: { type: Boolean },
    noCaret: { type: Boolean, default: !1 },
    noFlip: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 },
    noSize: { type: Boolean, default: !1 },
    offset: { default: 0 },
    role: { default: "menu" },
    size: { default: "md" },
    skipWrapper: { type: Boolean, default: !1 },
    split: { type: Boolean, default: !1 },
    splitButtonType: { default: "button" },
    splitClass: { default: void 0 },
    splitDisabled: { type: Boolean, default: void 0 },
    splitHref: { default: void 0 },
    splitTo: { default: void 0 },
    splitVariant: { default: void 0 },
    strategy: { default: "absolute" },
    text: { default: void 0 },
    toggleClass: { default: void 0 },
    toggleText: { default: "Toggle dropdown" },
    variant: { default: "secondary" },
    wrapperClass: { default: void 0 },
    teleportDisabled: { default: !1 },
    teleportTo: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["click", "hidden", "hide", "hide-prevented", "show", "show-prevented", "shown", "toggle"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BDropdown"), s = e, r = we(() => t.id, "dropdown"), u = _e(a, "modelValue"), i = Ve(Lo, !1), d = k(
      () => typeof t.offset == "string" || typeof t.offset == "number" ? t.offset : NaN
    ), f = he(d), c = z(null), y = z(null), p = z(null), b = z(null), h = _(
      () => t.boundary === "document" || t.boundary === "viewport" ? void 0 : t.boundary
    ), w = _(
      () => t.boundary === "document" || t.boundary === "viewport" ? t.boundary : void 0
    ), v = k(() => t.split ? y.value : p.value);
    De(
      "Escape",
      () => {
        u.value = !u.value;
      },
      { target: v }
    ), De(
      "Escape",
      () => {
        u.value = !u.value;
      },
      { target: c }
    );
    const B = (T, N) => {
      var W, E, D, te, re, U, ne;
      if ((E = c.value) != null && E.contains((W = T.target) == null ? void 0 : W.closest("form")) || /input|select|option|textarea|form/i.test((D = T.target) == null ? void 0 : D.tagName))
        return;
      if (T.preventDefault(), !u.value) {
        open(), Ne(() => B(T, N));
        return;
      }
      const F = (te = c.value) == null ? void 0 : te.querySelectorAll(".dropdown-item:not(.disabled):not(:disabled)");
      if (F)
        if ((re = c.value) != null && re.contains(document.activeElement)) {
          const pe = c.value.querySelector(".dropdown-item:focus"), Y = Array.prototype.indexOf.call(F, pe) + N;
          Y >= 0 && Y < (F == null ? void 0 : F.length) && ((U = F[Y]) == null || U.focus());
        } else
          (ne = F[N === -1 ? F.length - 1 : 0]) == null || ne.focus();
    };
    De("ArrowUp", (T) => B(T, -1), { target: v }), De("ArrowDown", (T) => B(T, 1), { target: v }), De("ArrowUp", (T) => B(T, -1), { target: c }), De("ArrowDown", (T) => B(T, 1), { target: c });
    const g = _(
      () => Br({
        top: t.dropup,
        start: t.dropstart,
        end: t.dropend,
        alignCenter: t.center,
        alignEnd: t.end
      })
    ), S = z({}), C = _(() => {
      if (t.floatingMiddleware !== void 0)
        return t.floatingMiddleware;
      const T = typeof t.offset == "string" || typeof t.offset == "number" ? f.value : t.offset, N = [Yl(T)];
      return t.noFlip === !1 && N.push(
        so({
          boundary: h.value,
          rootBoundary: w.value,
          padding: t.boundaryPadding
        })
      ), t.noShift === !1 && N.push(
        no({
          boundary: h.value,
          rootBoundary: w.value,
          padding: t.boundaryPadding
        })
      ), t.noSize === !1 && N.push(
        ro({
          boundary: h.value,
          rootBoundary: w.value,
          padding: t.boundaryPadding,
          apply({ availableWidth: F, availableHeight: W }) {
            S.value = {
              maxHeight: W && u.value ? `${W}px` : void 0,
              maxWidth: F && u.value ? `${F}px` : void 0
            };
          }
        })
      ), N;
    }), { update: x, floatingStyles: V } = uo(v, c, {
      placement: g,
      middleware: C,
      strategy: k(() => t.strategy),
      whileElementsMounted: oo
    }), q = _(() => [
      t.wrapperClass,
      {
        "btn-group": !t.wrapperClass && t.split,
        dropdown: !t.wrapperClass && !t.split,
        dropup: t.dropup,
        dropend: t.dropend,
        dropstart: t.dropstart,
        "position-static": t.boundary !== "clippingAncestors" && !t.isNav
      }
    ]), G = _(() => [
      t.split ? t.splitClass : t.toggleClass,
      {
        "nav-link": t.isNav,
        "dropdown-toggle": !t.split,
        "dropdown-toggle-no-caret": t.noCaret && !t.split,
        show: t.split ? void 0 : u.value
      }
    ]), O = () => {
      j();
    }, Z = (T) => {
      t.split ? s("click", T) : O();
    };
    yo(
      c,
      () => {
        u.value && (t.autoClose === !0 || t.autoClose === "outside") && j();
      },
      { ignore: [y, p] }
    );
    const ae = () => {
      u.value && (t.autoClose === !0 || t.autoClose === "inside") && j();
    }, ie = () => {
      u.value && j();
    }, X = () => {
      u.value || j();
    }, j = () => {
      var F, W;
      s("toggle");
      const T = u.value, N = new wt(T ? "hide" : "show");
      if (s(T ? "hide" : "show", N), N.defaultPrevented) {
        s(T ? "hide-prevented" : "show-prevented");
        return;
      }
      u.value = !T, s(T ? "hidden" : "shown"), (W = (F = b.value) == null ? void 0 : F.dispatchEvent) == null || W.call(F, new Event("forceHide"));
    };
    return fe(u, () => {
      x();
    }), o({
      hide: ie,
      show: X,
      toggle: j
    }), Xe(Ao, {
      id: r,
      show: X,
      hide: ie,
      toggle: j,
      visible: k(() => u.value),
      isNav: k(() => t.isNav)
    }), (T, N) => (m(), P(qt, {
      ref_key: "wrapper",
      ref: b,
      skip: n(i) || n(t).skipWrapper,
      class: R(q.value)
    }, {
      default: I(() => [
        ye(mt, {
          id: n(r),
          ref_key: "splitButton",
          ref: p,
          variant: n(t).splitVariant || n(t).variant,
          size: n(t).size,
          class: R(G.value),
          disabled: n(t).splitDisabled || n(t).disabled,
          type: n(t).splitButtonType,
          "aria-label": n(t).ariaLabel,
          "aria-expanded": n(t).split ? void 0 : u.value,
          "aria-haspopup": n(t).split ? void 0 : "menu",
          href: n(t).split ? n(t).splitHref : void 0,
          to: n(t).split && n(t).splitTo ? n(t).splitTo : void 0,
          onClick: Z
        }, {
          default: I(() => [
            $(T.$slots, "button-content", {}, () => [
              ue(J(n(t).text), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "variant", "size", "class", "disabled", "type", "aria-label", "aria-expanded", "aria-haspopup", "href", "to"]),
        n(t).split ? (m(), P(mt, {
          key: 0,
          ref_key: "button",
          ref: y,
          variant: n(t).variant,
          size: n(t).size,
          disabled: n(t).disabled,
          class: R([[n(t).toggleClass, { show: u.value }], "dropdown-toggle-split dropdown-toggle"]),
          "aria-expanded": u.value,
          "aria-haspopup": "menu",
          onClick: O
        }, {
          default: I(() => [
            Q("span", Di, [
              $(T.$slots, "toggle-text", {}, () => [
                ue(J(n(t).toggleText), 1)
              ])
            ])
          ]),
          _: 3
        }, 8, ["variant", "size", "disabled", "class", "aria-expanded"])) : ee("", !0),
        (m(), P(_t, {
          to: n(t).teleportTo,
          disabled: !n(t).teleportTo || n(t).teleportDisabled
        }, [
          !n(t).lazy || u.value ? ct((m(), A("ul", {
            key: 0,
            ref_key: "floating",
            ref: c,
            style: Le([n(V), S.value]),
            class: R(["dropdown-menu overflow-auto", [n(t).menuClass, { show: u.value }]]),
            "aria-labelledby": n(r),
            role: n(t).role,
            onClick: ae
          }, [
            $(T.$slots, "default", {
              hide: ie,
              show: X
            })
          ], 14, ji)), [
            [jt, n(t).lazy || u.value]
          ]) : ee("", !0)
        ], 8, ["to", "disabled"]))
      ]),
      _: 3
    }, 8, ["skip", "class"]));
  }
}), Gi = { role: "presentation" }, Wi = /* @__PURE__ */ L({
  __name: "BDropdownDivider",
  props: {
    tag: { default: "hr" }
  },
  setup(a) {
    const e = M(a, "BDropdownDivider");
    return (l, t) => (m(), A("li", Gi, [
      (m(), P(ce(n(e).tag), {
        class: "dropdown-divider",
        role: "separator",
        "aria-orientation": "horizontal"
      }))
    ]));
  }
}), qi = { role: "presentation" }, Ui = /* @__PURE__ */ L({
  __name: "BDropdownForm",
  setup(a) {
    return (o, e) => (m(), A("li", qi, [
      Q("form", K({ class: "dropdown-item-text" }, o.$attrs), [
        $(o.$slots, "default")
      ], 16)
    ]));
  }
}), Xi = { role: "presentation" }, Ki = ["id", "aria-describedby"], Yi = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BDropdownGroup",
  props: {
    ariaDescribedby: { default: void 0 },
    header: { default: void 0 },
    headerClass: { default: void 0 },
    headerTag: { default: "header" },
    headerVariant: { default: null },
    id: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BDropdownGroup"), l = k(() => e.id ? `${e.id}_group_dd_header` : void 0), t = k(() => e.headerTag === "header" ? void 0 : "heading"), s = _(() => [
      e.headerClass,
      {
        [`text-${e.headerVariant}`]: e.headerVariant !== null
      }
    ]);
    return (r, u) => (m(), A("li", Xi, [
      (m(), P(ce(n(e).headerTag), {
        id: l.value,
        class: R(["dropdown-header", s.value]),
        role: t.value
      }, {
        default: I(() => [
          $(r.$slots, "header", {}, () => [
            ue(J(n(e).header), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "class", "role"])),
      Q("ul", K({
        id: n(e).id,
        role: "group",
        class: "list-unstyled"
      }, r.$attrs, {
        "aria-describedby": n(e).ariaDescribedby || l.value
      }), [
        $(r.$slots, "default")
      ], 16, Ki)
    ]));
  }
}), Zi = { class: "dropdown-header" }, Ji = /* @__PURE__ */ L({
  __name: "BDropdownHeader",
  setup(a) {
    return (o, e) => (m(), A("li", null, [
      Q("h6", Zi, [
        $(o.$slots, "default")
      ])
    ]));
  }
}), Qi = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BDropdownItem",
  props: {
    linkClass: { default: void 0 },
    wrapperAttrs: { default: void 0 },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: null }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BDropdownItem"), t = o, { class: s, ...r } = Dt(), { computedLink: u, computedLinkProps: i } = Ct(l), d = _(() => [
      l.linkClass,
      {
        active: l.active,
        disabled: l.disabled,
        [`text-${l.variant}`]: l.variant !== null
      }
    ]), f = k(() => u.value ? st : l.href ? "a" : "button"), c = Ve(tl, null), y = Ve(Ao, null), p = Ve(al, null), b = (h) => {
      var w, v, B;
      t("click", h), p !== null && ((w = p == null ? void 0 : p.autoClose) == null ? void 0 : w.value) === !0 && ((v = c == null ? void 0 : c.hide) == null || v.call(c)), (B = y == null ? void 0 : y.hide) == null || B.call(y);
    };
    return (h, w) => (m(), A("li", K({
      role: "presentation",
      class: n(s)
    }, n(l).wrapperAttrs), [
      (m(), P(ce(f.value), K({
        class: ["dropdown-item", d.value],
        disabled: n(l).disabled,
        "aria-disabled": n(l).disabled ? !0 : null,
        "aria-current": n(l).active ? !0 : null,
        href: f.value === "a" ? n(l).href : null,
        rel: n(l).rel,
        role: "menuitem",
        type: f.value === "button" ? "button" : null,
        target: n(l).target
      }, { ...n(i), ...r }, { onClick: b }), {
        default: I(() => [
          $(h.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "disabled", "aria-disabled", "aria-current", "href", "rel", "type", "target"]))
    ], 16));
  }
}), eu = { role: "presentation" }, tu = ["disabled"], au = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BDropdownItemButton",
  props: {
    active: { type: Boolean, default: !1 },
    activeClass: { default: "active" },
    buttonClass: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    variant: { default: null }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BDropdownItemButton"), t = o, s = _(() => [
      l.buttonClass,
      {
        [l.activeClass]: l.active,
        disabled: l.disabled,
        [`text-${l.variant}`]: l.variant !== null
      }
    ]), r = (u) => {
      t("click", u);
    };
    return (u, i) => (m(), A("li", eu, [
      Q("button", {
        role: "menu",
        type: "button",
        class: R(["dropdown-item", s.value]),
        disabled: n(l).disabled,
        onClick: r
      }, [
        $(u.$slots, "default")
      ], 10, tu)
    ]));
  }
}), lu = { role: "presentation" }, ou = /* @__PURE__ */ L({
  __name: "BDropdownText",
  props: {
    text: { default: "" }
  },
  setup(a) {
    const e = M(a, "BDropdownText");
    return (l, t) => (m(), A("li", lu, [
      Q("span", K({ class: "dropdown-item-text" }, l.$attrs), [
        $(l.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ], 16)
    ]));
  }
}), nu = ["id", "novalidate"], mn = /* @__PURE__ */ L({
  __name: "BForm",
  props: {
    floating: { type: Boolean, default: !1 },
    id: { default: void 0 },
    novalidate: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 }
  },
  emits: ["submit"],
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BForm"), s = e, r = z(null), u = _(() => ({
      "form-floating": t.floating,
      "was-validated": t.validated
    })), i = (d) => {
      s("submit", d);
    };
    return o({
      element: r
    }), (d, f) => (m(), A("form", {
      id: n(t).id,
      ref_key: "element",
      ref: r,
      novalidate: n(t).novalidate,
      class: R(u.value),
      onSubmit: vt(i, ["prevent"])
    }, [
      $(d.$slots, "default")
    ], 42, nu));
  }
}), su = { class: "form-floating" }, ru = ["for"], iu = /* @__PURE__ */ L({
  __name: "BFormFloatingLabel",
  props: {
    label: { default: void 0 },
    labelFor: { default: void 0 },
    text: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BFormFloatingLabel");
    return (l, t) => (m(), A("div", su, [
      $(l.$slots, "default", {}, () => [
        ue(J(n(e).text), 1)
      ]),
      Q("label", {
        for: n(e).labelFor
      }, [
        $(l.$slots, "label", {}, () => [
          ue(J(n(e).label), 1)
        ])
      ], 8, ru)
    ]));
  }
}), Na = /* @__PURE__ */ L({
  __name: "BFormInvalidFeedback",
  props: {
    ariaLive: { default: void 0 },
    forceShow: { type: Boolean, default: !1 },
    id: { default: void 0 },
    role: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    tag: { default: "div" },
    text: { default: void 0 },
    tooltip: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BFormInvalidFeedback"), l = k(() => e.forceShow === !0 || e.state === !1), t = _(() => ({
      "d-block": l.value,
      "invalid-feedback": !e.tooltip,
      "invalid-tooltip": e.tooltip
    }));
    return (s, r) => (m(), P(ce(n(e).tag), {
      id: n(e).id,
      role: n(e).role,
      "aria-live": n(e).ariaLive,
      "aria-atomic": n(e).ariaLive ? !0 : void 0,
      class: R(t.value)
    }, {
      default: I(() => [
        $(s.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "aria-atomic", "class"]));
  }
}), la = /* @__PURE__ */ L({
  __name: "BFormRow",
  props: {
    tag: { default: "div" }
  },
  setup(a) {
    const e = M(a, "BFormRow");
    return (l, t) => (m(), P(ce(n(e).tag), { class: "row d-flex flex-wrap" }, {
      default: I(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Ea = /* @__PURE__ */ L({
  __name: "BFormText",
  props: {
    id: { default: void 0 },
    inline: { type: Boolean, default: !1 },
    tag: { default: "small" },
    text: { default: void 0 },
    textVariant: { default: "body-secondary" }
  },
  setup(a) {
    const e = M(a, "BFormText"), l = _(() => ({
      [`text-${e.textVariant}`]: e.textVariant !== null,
      "form-text": !e.inline
    }));
    return (t, s) => (m(), P(ce(n(e).tag), {
      id: n(e).id,
      class: R(l.value)
    }, {
      default: I(() => [
        $(t.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), Fa = /* @__PURE__ */ L({
  __name: "BFormValidFeedback",
  props: {
    ariaLive: { default: void 0 },
    forceShow: { type: Boolean, default: !1 },
    id: { default: void 0 },
    role: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    tag: { default: "div" },
    text: { default: void 0 },
    tooltip: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BFormInvalidFeedback"), l = k(() => e.forceShow === !0 || e.state === !0), t = _(() => ({
      "d-block": l.value,
      "valid-feedback": !e.tooltip,
      "valid-tooltip": e.tooltip
    }));
    return (s, r) => (m(), P(ce(n(e).tag), {
      id: n(e).id,
      role: n(e).role,
      "aria-live": n(e).ariaLive,
      "aria-atomic": n(e).ariaLive ? !0 : void 0,
      class: R(t.value)
    }, {
      default: I(() => [
        $(s.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "aria-atomic", "class"]));
  }
}), uu = ["id", "disabled", "required", "name", "form", "aria-label", "aria-labelledby", "aria-required", "value", "true-value", "false-value", "indeterminate"], du = ["for"], bn = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BFormCheckbox",
  props: /* @__PURE__ */ ge({
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    buttonGroup: { type: Boolean, default: !1 },
    buttonVariant: { default: null },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    id: { default: void 0 },
    indeterminate: { type: Boolean },
    inline: { type: Boolean, default: !1 },
    modelValue: { type: [Array, Set, String, Boolean, Object, Number, null] },
    name: { default: void 0 },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: void 0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    switch: { type: Boolean, default: !1 },
    uncheckedValue: { type: [Array, Set, String, Boolean, Object, Number, null], default: !1 },
    value: { type: [String, Boolean, Array, Set, Object, Number, null], default: !0 }
  }, {
    modelValue: { type: [Array, Set, String, Boolean, Object, Number, null], default: void 0 },
    modelModifiers: {},
    indeterminate: { type: Boolean, default: !1 },
    indeterminateModifiers: {}
  }),
  emits: ["update:modelValue", "update:indeterminate"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormCheckbox"), t = He(), s = _e(a, "modelValue"), r = _e(a, "indeterminate"), u = we(() => l.id, "form-check"), i = Ve(So, null), d = z(null), { focused: f } = Fe(d, {
      initialValue: l.autofocus
    }), c = k(() => !Ae(t.default)), y = _({
      get: () => (i == null ? void 0 : i.modelValue.value) ?? s.value,
      set: (g) => {
        if (g !== void 0) {
          if (r.value = !1, i !== null && Array.isArray(g)) {
            i.modelValue.value = g;
            return;
          }
          s.value = g;
        }
      }
    }), p = k(
      () => !!(l.name ?? (i == null ? void 0 : i.name.value)) && (l.required || (i == null ? void 0 : i.required.value))
    ), b = k(() => l.buttonGroup || ((i == null ? void 0 : i.buttons.value) ?? !1)), h = _(() => ({
      plain: l.plain || ((i == null ? void 0 : i.plain.value) ?? !1),
      button: l.button || ((i == null ? void 0 : i.buttons.value) ?? !1),
      inline: l.inline || ((i == null ? void 0 : i.inline.value) ?? !1),
      reverse: l.reverse || ((i == null ? void 0 : i.reverse.value) ?? !1),
      switch: l.switch || ((i == null ? void 0 : i.switch.value) ?? !1),
      state: l.state || (i == null ? void 0 : i.state.value),
      size: l.size ?? (i == null ? void 0 : i.size.value) ?? "md",
      // This is where the true default is made
      buttonVariant: l.buttonVariant ?? (i == null ? void 0 : i.buttonVariant.value) ?? "secondary",
      // This is where the true default is made
      hasDefaultSlot: c.value
    })), w = Do(h), v = jo(h), B = Go(h);
    return o({
      blur: () => {
        f.value = !1;
      },
      element: d,
      focus: () => {
        f.value = !0;
      }
    }), (g, S) => (m(), P(qt, {
      skip: b.value,
      class: R(n(w))
    }, {
      default: I(() => {
        var C, x, V;
        return [
          ct(Q("input", K({ id: n(u) }, g.$attrs, {
            ref_key: "input",
            ref: d,
            "onUpdate:modelValue": S[0] || (S[0] = (q) => y.value = q),
            class: n(v),
            type: "checkbox",
            disabled: n(l).disabled || ((C = n(i)) == null ? void 0 : C.disabled.value),
            required: p.value || void 0,
            name: n(l).name || ((x = n(i)) == null ? void 0 : x.name.value),
            form: n(l).form || ((V = n(i)) == null ? void 0 : V.form.value),
            "aria-label": n(l).ariaLabel,
            "aria-labelledby": n(l).ariaLabelledby,
            "aria-required": p.value || void 0,
            value: n(l).value,
            "true-value": n(l).value,
            "false-value": n(l).uncheckedValue,
            indeterminate: n(l).indeterminate
          }), null, 16, uu), [
            [En, y.value]
          ]),
          c.value || n(l).plain === !1 ? (m(), A("label", {
            key: 0,
            for: n(u),
            class: R(n(B))
          }, [
            $(g.$slots, "default")
          ], 10, du)) : ee("", !0)
        ];
      }),
      _: 3
    }, 8, ["skip", "class"]));
  }
}), cu = ["id"], fu = ["innerHTML"], pu = /* @__PURE__ */ L({
  __name: "BFormCheckboxGroup",
  props: /* @__PURE__ */ ge({
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    buttonVariant: { default: "secondary" },
    buttons: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledField: { default: "disabled" },
    form: { default: void 0 },
    htmlField: { default: "html" },
    id: { default: void 0 },
    modelValue: {},
    name: { default: void 0 },
    options: { default: () => [] },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "md" },
    stacked: { type: Boolean, default: !1 },
    state: { type: [Boolean, null], default: null },
    switches: { type: Boolean, default: !1 },
    textField: { default: "text" },
    validated: { type: Boolean, default: !1 },
    valueField: { default: "value" }
  }, {
    modelValue: {
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormCheckboxGroup"), t = _e(a, "modelValue"), s = we(() => l.id, "checkbox"), r = we(() => l.name, "checkbox"), u = z(null), { focused: i } = Fe(u, {
      initialValue: l.autofocus
    });
    Xe(So, {
      modelValue: t,
      switch: k(() => l.switches),
      buttonVariant: k(() => l.buttonVariant),
      form: k(() => l.form),
      name: r,
      state: k(() => l.state),
      plain: k(() => l.plain),
      size: k(() => l.size),
      inline: k(() => !l.stacked),
      reverse: k(() => l.reverse),
      required: k(() => l.required),
      buttons: k(() => l.buttons),
      disabled: k(() => l.disabled)
    });
    const d = _(
      () => l.options.map(
        (p, b) => typeof p == "string" || typeof p == "number" ? {
          props: {
            value: p,
            disabled: l.disabled
          },
          text: p.toString(),
          html: void 0,
          self: Symbol(`checkboxGroupOptionItem${b}`)
        } : {
          props: {
            value: p[l.valueField],
            disabled: p[l.disabledField],
            ...p.props ? p.props : {}
          },
          text: p[l.textField],
          html: p[l.htmlField],
          self: Symbol(`checkboxGroupOptionItem${b}`)
        }
      )
    ), f = _(() => ({
      required: l.required,
      ariaInvalid: l.ariaInvalid,
      state: l.state,
      validated: l.validated,
      buttons: l.buttons,
      stacked: l.stacked,
      size: l.size
    })), c = Wo(f), y = qo(f);
    return o({
      blur: () => {
        i.value = !1;
      },
      focus: () => {
        i.value = !0;
      }
    }), (p, b) => (m(), A("div", K(n(c), {
      id: n(s),
      ref_key: "element",
      ref: u,
      role: "group",
      class: [n(y), "bv-no-focus-ring"],
      tabindex: "-1"
    }), [
      $(p.$slots, "first"),
      (m(!0), A(ve, null, ke(d.value, (h) => (m(), P(bn, K({
        key: h.self,
        ref_for: !0
      }, h.props), {
        default: I(() => [
          h.html ? (m(), A("span", {
            key: 0,
            innerHTML: h.html
          }, null, 8, fu)) : (m(), A(ve, { key: 1 }, [
            ue(J(h.text), 1)
          ], 64))
        ]),
        _: 2
      }, 1040))), 128)),
      $(p.$slots, "default")
    ], 16, cu));
  }
}), vu = ["for"], mu = ["id", "form", "name", "multiple", "disabled", "capture", "accept", "required", "aria-label", "aria-labelledby", "aria-required", "directory", "webkitdirectory"], bu = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BFormFile",
  props: /* @__PURE__ */ ge({
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    accept: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    capture: { type: [Boolean, String], default: !1 },
    directory: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    id: { default: void 0 },
    label: { default: "" },
    labelClass: { default: void 0 },
    modelValue: {},
    multiple: { type: Boolean, default: !1 },
    name: { default: void 0 },
    noButton: { type: Boolean, default: !1 },
    noDrop: { type: Boolean, default: !1 },
    noTraverse: { type: Boolean, default: !1 },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null }
  }, {
    modelValue: {
      default: null
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const e = He(), t = M(a, "BFormFile"), s = _e(a, "modelValue"), r = we(() => t.id), u = kt(() => t.state), i = z(null), { focused: d } = Fe(i, { initialValue: t.autofocus }), f = k(() => !Ae(e.label)), c = k(
      () => typeof t.accept == "string" ? t.accept : t.accept.join(",")
    ), y = _(() => [
      u.value,
      {
        [`form-control-${t.size}`]: t.size !== void 0,
        "form-control": !t.plain,
        "form-control-input-file-hide-button": t.noButton
      }
    ]), p = () => {
      var v, B;
      const w = ((v = i.value) == null ? void 0 : v.files) === null || ((B = i.value) == null ? void 0 : B.files) === void 0 ? null : [...i.value.files];
      s.value = w === null ? null : t.multiple === !0 ? w : w[0];
    }, b = (w) => {
      t.noDrop === !0 && w.preventDefault();
    }, h = () => {
      s.value = null;
    };
    return fe(s, (w) => {
      w === null && i.value !== null && (i.value.value = "");
    }), o({
      blur: () => {
        d.value = !1;
      },
      element: i,
      focus: () => {
        d.value = !0;
      },
      reset: h
    }), (w, v) => (m(), A(ve, null, [
      f.value || n(t).label ? (m(), A("label", {
        key: 0,
        class: R(["form-label", n(t).labelClass]),
        for: n(r)
      }, [
        $(w.$slots, "label", {}, () => [
          ue(J(n(t).label), 1)
        ])
      ], 10, vu)) : ee("", !0),
      Q("input", K({ id: n(r) }, w.$attrs, {
        ref_key: "input",
        ref: i,
        type: "file",
        class: y.value,
        form: n(t).form,
        name: n(t).name,
        multiple: n(t).multiple,
        disabled: n(t).disabled,
        capture: n(t).capture,
        accept: c.value || void 0,
        required: n(t).required || void 0,
        "aria-label": n(t).ariaLabel,
        "aria-labelledby": n(t).ariaLabelledby,
        "aria-required": n(t).required || void 0,
        directory: n(t).directory,
        webkitdirectory: n(t).directory,
        onChange: p,
        onDrop: b
      }), null, 16, mu)
    ], 64));
  }
}), yn = ["input", "select", "textarea"], yu = yn.map((a) => `${a}:not([disabled])`).join(), gu = [...yn, "a", "button", "label"], hu = "label", Bu = "invalid-feedback", _u = "valid-feedback", wu = "description", Cu = "default", ku = L({
  components: { BCol: zt, BFormInvalidFeedback: Na, BFormRow: la, BFormText: Ea, BFormValidFeedback: Fa },
  props: {
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    contentCols: { type: [Boolean, String, Number], default: void 0 },
    contentColsLg: { type: [Boolean, String, Number], default: void 0 },
    contentColsMd: { type: [Boolean, String, Number], default: void 0 },
    contentColsSm: { type: [Boolean, String, Number], default: void 0 },
    contentColsXl: { type: [Boolean, String, Number], default: void 0 },
    description: { type: [String], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    feedbackAriaLive: { type: String, default: "assertive" },
    id: { type: String, default: void 0 },
    invalidFeedback: { type: String, default: void 0 },
    label: { type: String, default: void 0 },
    labelAlign: { type: [Boolean, String, Number], default: void 0 },
    labelAlignLg: { type: [Boolean, String, Number], default: void 0 },
    labelAlignMd: { type: [Boolean, String, Number], default: void 0 },
    labelAlignSm: { type: [Boolean, String, Number], default: void 0 },
    labelAlignXl: { type: [Boolean, String, Number], default: void 0 },
    labelClass: { type: [Array, Object, String], default: void 0 },
    labelCols: { type: [Boolean, String, Number], default: void 0 },
    labelColsLg: { type: [Boolean, String, Number], default: void 0 },
    labelColsMd: { type: [Boolean, String, Number], default: void 0 },
    labelColsSm: { type: [Boolean, String, Number], default: void 0 },
    labelColsXl: { type: [Boolean, String, Number], default: void 0 },
    labelFor: { type: String, default: void 0 },
    labelSize: { type: String, default: void 0 },
    labelSrOnly: { type: Boolean, default: !1 },
    state: { type: Boolean, default: null },
    tooltip: { type: Boolean, default: !1 },
    validFeedback: { type: String, default: void 0 },
    validated: { type: Boolean, default: !1 },
    floating: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = ["xs", "sm", "md", "lg", "xl"], l = (b, h) => e.reduce((w, v) => {
      const B = $l(v === "xs" ? "" : v, `${h}Align`), g = b[B] || null;
      return g && (v === "xs" ? w.push(`text-${g}`) : w.push(`text-${v}-${g}`)), w;
    }, []), t = (b, h) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      e.reduce((w, v) => {
        const B = $l(v === "xs" ? "" : v, `${h}Cols`);
        let g = b[B];
        if (g = g === "" ? !0 : g || !1, typeof g != "boolean" && g !== "auto") {
          const S = Number.parseInt(g);
          g = Number.isNaN(S) ? 0 : S, g = g > 0 ? g : !1;
        }
        return g && (v === "xs" ? w[typeof g == "boolean" ? "col" : "cols"] = g : w[v || (typeof g == "boolean" ? "col" : "cols")] = g), w;
      }, {})
    ), s = z(null), r = (b, h = null) => {
      if (ja && a.labelFor && s.value !== null) {
        const w = s.value.querySelector(`#${CSS.escape(a.labelFor)}`);
        if (w) {
          const v = "aria-describedby", B = (b || "").split(ea), g = (h || "").split(ea), S = (w.getAttribute(v) || "").split(ea).filter((C) => !g.includes(C)).concat(B).filter((C, x, V) => V.indexOf(C) === x).filter((C) => C).join(" ").trim();
          S ? w.setAttribute(v, S) : w.removeAttribute(v);
        }
      }
    }, u = _(() => t(a, "content")), i = _(() => l(a, "label")), d = _(() => t(a, "label")), f = _(
      () => (
        // Determine if the form group will be rendered horizontal
        // based on the existence of 'content-col' or 'label-col' props
        Object.keys(u.value).length > 0 || Object.keys(d.value).length > 0
      )
    ), c = kt(() => a.state), y = ba(
      () => a.ariaInvalid,
      () => a.state
    );
    return fe(
      () => null,
      (b, h) => {
        b !== h && r(b, h);
      }
    ), Ue(() => {
      Ne(() => {
        r(null);
      });
    }), {
      ariaDescribedby: null,
      computedAriaInvalid: y,
      contentColProps: u,
      isHorizontal: f,
      labelAlignClasses: i,
      labelColProps: d,
      onLegendClick: (b) => {
        if (a.labelFor || s.value === null)
          return;
        const { target: h } = b, w = h ? h.tagName : "";
        if (gu.indexOf(w) !== -1)
          return;
        const v = [...s.value.querySelectorAll(yu)].filter(Mn), [B] = v;
        v.length === 1 && B instanceof HTMLElement && Hn(B);
      },
      stateClass: c
    };
  },
  render() {
    const a = this.$props, o = this.$slots, e = we(), l = !a.labelFor;
    let t = null;
    const s = Lt(hu, {}, o) || a.label, r = s ? we(void 0, "_BV_label_").value : null;
    if (s || this.isHorizontal) {
      const S = l ? "legend" : "label";
      if (a.labelSrOnly)
        s && (t = Ie(
          S,
          {
            class: "visually-hidden",
            id: r,
            for: a.labelFor || null
          },
          s
        )), this.isHorizontal ? t = Ie(zt, this.labelColProps, { default: () => t }) : t = Ie("div", {}, [t]);
      else {
        const C = {
          onClick: l ? this.onLegendClick : null,
          ...this.isHorizontal ? this.labelColProps : {},
          tag: this.isHorizontal ? S : null,
          id: r,
          for: a.labelFor || null,
          tabIndex: l ? "-1" : null,
          class: [
            this.isHorizontal ? "col-form-label" : "form-label",
            {
              "bv-no-focus-ring": l,
              "col-form-label": this.isHorizontal || l,
              "pt-0": !this.isHorizontal && l,
              "d-block": !this.isHorizontal && !l,
              [`col-form-label-${a.labelSize}`]: !!a.labelSize
            },
            this.labelAlignClasses,
            a.labelClass
          ]
        };
        this.isHorizontal ? t = Ie(zt, C, { default: () => s }) : t = Ie(S, C, s);
      }
    }
    let u = null;
    const i = Lt(Bu, {}, o) || this.invalidFeedback, d = i ? we(void 0, "_BV_feedback_invalid_").value : void 0;
    i && (u = Ie(
      Na,
      {
        ariaLive: a.feedbackAriaLive,
        id: d,
        state: a.state,
        tooltip: a.tooltip
      },
      { default: () => i }
    ));
    let f = null;
    const c = Lt(_u, {}, o) || this.validFeedback, y = c ? we(void 0, "_BV_feedback_valid_").value : void 0;
    c && (f = Ie(
      Fa,
      {
        ariaLive: a.feedbackAriaLive,
        id: y,
        state: a.state,
        tooltip: a.tooltip
      },
      { default: () => c }
      // validFeedbackContent
    ));
    let p = null;
    const b = Lt(wu, {}, o) || this.description, h = b ? we(void 0, "_BV_description_").value : void 0;
    b && (p = Ie(
      Ea,
      {
        id: h
      },
      { default: () => b }
    ));
    const w = this.ariaDescribedby = [
      h,
      a.state === !1 ? d : null,
      a.state === !0 ? y : null
    ].filter((S) => S).join(" ") || null, v = [
      Lt(Cu, { ariaDescribedby: w, descriptionId: h, id: e, labelId: r }, o) || "",
      u,
      f,
      p
    ];
    !this.isHorizontal && a.floating && v.push(t);
    let B = Ie(
      "div",
      {
        ref: "content",
        class: [
          {
            "form-floating": !this.isHorizontal && a.floating
          }
        ]
      },
      v
    );
    this.isHorizontal && (B = Ie(zt, { ref: "content", ...this.contentColProps }, { default: () => v }));
    const g = {
      class: [
        this.stateClass,
        {
          "was-validated": a.validated
        }
      ],
      id: we(() => a.id).value,
      disabled: l ? a.disabled : null,
      role: l ? null : "group",
      "aria-invalid": this.computedAriaInvalid,
      // Only apply `aria-labelledby` if we are a horizontal fieldset
      // as the legend is no longer a direct child of fieldset
      "aria-labelledby": l && this.isHorizontal ? r : null
    };
    return this.isHorizontal && !l ? Ie(la, g, { default: () => [t, B] }) : Ie(
      l ? "fieldset" : "div",
      g,
      this.isHorizontal && l ? [Ie(la, null, { default: () => [t, B] })] : this.isHorizontal || !a.floating ? [t, B] : [B]
    );
  }
}), Tu = ["id", "value", "name", "form", "type", "disabled", "placeholder", "required", "autocomplete", "readonly", "min", "max", "step", "list", "aria-required", "aria-invalid"], Ol = /* @__PURE__ */ L({
  __name: "BFormInput",
  props: /* @__PURE__ */ ge({
    max: { default: void 0 },
    min: { default: void 0 },
    step: { default: void 0 },
    type: { default: "text" },
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    autocomplete: { default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    formatter: { type: Function, default: void 0 },
    id: { default: void 0 },
    lazyFormatter: { type: Boolean, default: !1 },
    list: { default: void 0 },
    modelValue: { default: "" },
    name: { default: void 0 },
    placeholder: { default: void 0 },
    plaintext: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    debounce: { default: 0 },
    debounceMaxWait: { default: NaN }
  }, {
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormInput"), [t, s] = _e(a, "modelValue", {
      set: (v) => {
        if (v === null)
          return;
        let B = v;
        if (s.trim && (B = B.toString().trim()), (s.number || l.type === "number") && typeof B == "string" && B !== "") {
          const g = Number.parseFloat(B);
          B = Number.isNaN(g) ? B : g;
        }
        return B;
      }
    }), { input: r, computedId: u, computedAriaInvalid: i, onInput: d, onChange: f, onBlur: c, focus: y, blur: p } = Uo(l, t, s), b = kt(() => l.state), h = z(!1), w = _(() => {
      const v = l.type === "range", B = l.type === "color";
      return [
        b.value,
        {
          "form-control-highlighted": h.value,
          "form-range": v,
          "form-control": B || !l.plaintext && !v,
          "form-control-color": B,
          "form-control-plaintext": l.plaintext && !v && !B,
          [`form-control-${l.size}`]: !!l.size
        }
      ];
    });
    return o({
      blur: p,
      element: r,
      focus: y
    }), (v, B) => (m(), A("input", {
      id: n(u),
      ref_key: "input",
      ref: r,
      value: n(t),
      class: R(w.value),
      name: n(l).name || void 0,
      form: n(l).form || void 0,
      type: n(l).type,
      disabled: n(l).disabled,
      placeholder: n(l).placeholder,
      required: n(l).required || void 0,
      autocomplete: n(l).autocomplete || void 0,
      readonly: n(l).readonly || n(l).plaintext,
      min: n(l).min,
      max: n(l).max,
      step: n(l).step,
      list: n(l).type !== "password" ? n(l).list : void 0,
      "aria-required": n(l).required || void 0,
      "aria-invalid": n(i),
      onInput: B[0] || (B[0] = (g) => n(d)(g)),
      onChange: B[1] || (B[1] = (g) => n(f)(g)),
      onBlur: B[2] || (B[2] = (g) => n(c)(g))
    }, null, 42, Tu));
  }
}), $u = ["id", "disabled", "required", "name", "form", "aria-label", "aria-labelledby", "value", "aria-required"], xu = ["for"], gn = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BFormRadio",
  props: /* @__PURE__ */ ge({
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    buttonGroup: { type: Boolean, default: !1 },
    buttonVariant: { default: null },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    id: { default: void 0 },
    inline: { type: Boolean, default: !1 },
    modelValue: { type: [Boolean, String, Array, Object, Number, null] },
    name: { default: void 0 },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    reverse: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    value: { type: [Boolean, String, Array, Object, Number, null], default: !0 }
  }, {
    modelValue: { type: [Boolean, String, Array, Object, Number, null], default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormRadio"), t = He(), s = _e(a, "modelValue"), r = we(() => l.id, "form-check"), u = Ve(Vo, null), i = z(null), { focused: d } = Fe(i, {
      initialValue: l.autofocus
    }), f = k(() => !Ae(t.default)), c = _({
      get: () => (u == null ? void 0 : u.modelValue.value) ?? s.value,
      set: (B) => {
        if (B !== void 0) {
          if (u !== null) {
            u.modelValue.value = B;
            return;
          }
          s.value = B;
        }
      }
    }), y = k(
      () => !!(l.name ?? (u == null ? void 0 : u.name.value)) && (l.required || (u == null ? void 0 : u.required.value))
    ), p = k(() => l.buttonGroup || ((u == null ? void 0 : u.buttons.value) ?? !1)), b = _(() => ({
      plain: l.plain || ((u == null ? void 0 : u.plain.value) ?? !1),
      button: l.button || ((u == null ? void 0 : u.buttons.value) ?? !1),
      inline: l.inline || ((u == null ? void 0 : u.inline.value) ?? !1),
      state: l.state || (u == null ? void 0 : u.state.value),
      reverse: l.reverse || ((u == null ? void 0 : u.reverse.value) ?? !1),
      size: l.size ?? (u == null ? void 0 : u.size.value) ?? "md",
      // This is where the true default is made
      buttonVariant: l.buttonVariant ?? (u == null ? void 0 : u.buttonVariant.value) ?? "secondary",
      // This is where the true default is made
      hasDefaultSlot: f.value
    })), h = Do(b), w = jo(b), v = Go(b);
    return o({
      blur: () => {
        d.value = !1;
      },
      element: i,
      focus: () => {
        d.value = !0;
      }
    }), (B, g) => (m(), P(qt, {
      skip: p.value,
      class: R(n(h))
    }, {
      default: I(() => {
        var S, C, x;
        return [
          ct(Q("input", K({ id: n(r) }, B.$attrs, {
            ref_key: "input",
            ref: i,
            "onUpdate:modelValue": g[0] || (g[0] = (V) => c.value = V),
            class: n(w),
            type: "radio",
            disabled: n(l).disabled || ((S = n(u)) == null ? void 0 : S.disabled.value),
            required: y.value || void 0,
            name: n(l).name || ((C = n(u)) == null ? void 0 : C.name.value),
            form: n(l).form || ((x = n(u)) == null ? void 0 : x.form.value),
            "aria-label": n(l).ariaLabel,
            "aria-labelledby": n(l).ariaLabelledby,
            value: n(l).value,
            "aria-required": y.value || void 0
          }), null, 16, $u), [
            [Fn, c.value]
          ]),
          f.value || n(l).plain === !1 ? (m(), A("label", {
            key: 0,
            for: n(r),
            class: R(n(v))
          }, [
            $(B.$slots, "default")
          ], 10, xu)) : ee("", !0)
        ];
      }),
      _: 3
    }, 8, ["skip", "class"]));
  }
}), Su = ["id"], Vu = ["innerHTML"], Au = /* @__PURE__ */ L({
  __name: "BFormRadioGroup",
  props: /* @__PURE__ */ ge({
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    buttonVariant: { default: "secondary" },
    buttons: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledField: { default: "disabled" },
    form: { default: void 0 },
    htmlField: { default: "html" },
    id: { default: void 0 },
    modelValue: { type: [Boolean, String, Array, Object, Number, null] },
    name: { default: void 0 },
    options: { default: () => [] },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "md" },
    stacked: { type: Boolean, default: !1 },
    state: { type: [Boolean, null], default: null },
    textField: { default: "text" },
    validated: { type: Boolean, default: !1 },
    valueField: { default: "value" }
  }, {
    modelValue: { type: [Boolean, String, Array, Object, Number, null], default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormRadioGroup"), t = _e(a, "modelValue"), s = we(() => l.id, "radio"), r = we(() => l.name, "checkbox"), u = z(null), { focused: i } = Fe(u, {
      initialValue: l.autofocus
    });
    Xe(Vo, {
      modelValue: t,
      buttonVariant: k(() => l.buttonVariant),
      form: k(() => l.form),
      name: r,
      buttons: k(() => l.buttons),
      state: k(() => l.state),
      plain: k(() => l.plain),
      size: k(() => l.size),
      inline: k(() => !l.stacked),
      reverse: k(() => l.reverse),
      required: k(() => l.required),
      disabled: k(() => l.disabled)
    });
    const d = _(
      () => l.options.map(
        (p, b) => typeof p == "string" || typeof p == "number" ? {
          value: p,
          disabled: l.disabled,
          text: p.toString(),
          html: void 0,
          self: Symbol(`radioGroupOptionItem${b}`)
        } : {
          value: p[l.valueField],
          disabled: p[l.disabledField],
          ...p.props ? p.props : {},
          text: p[l.textField],
          html: p[l.htmlField],
          self: Symbol(`radioGroupOptionItem${b}`)
        }
      )
    ), f = _(() => ({
      required: l.required,
      ariaInvalid: l.ariaInvalid,
      state: l.state,
      validated: l.validated,
      buttons: l.buttons,
      stacked: l.stacked,
      size: l.size
    })), c = Wo(f), y = qo(f);
    return o({
      blur: () => {
        i.value = !1;
      },
      focus: () => {
        i.value = !0;
      }
    }), (p, b) => (m(), A("div", K(n(c), {
      id: n(s),
      ref_key: "element",
      ref: u,
      role: "radiogroup",
      class: [n(y), "bv-no-focus-ring"],
      tabindex: "-1"
    }), [
      $(p.$slots, "first"),
      (m(!0), A(ve, null, ke(d.value, (h) => (m(), P(gn, {
        key: h.self,
        disabled: h.disabled,
        value: h.value
      }, {
        default: I(() => [
          h.html ? (m(), A("span", {
            key: 0,
            innerHTML: h.html
          }, null, 8, Vu)) : (m(), A(ve, { key: 1 }, [
            ue(J(h.text), 1)
          ], 64))
        ]),
        _: 2
      }, 1032, ["disabled", "value"]))), 128)),
      $(p.$slots, "default")
    ], 16, Su));
  }
}), Ou = ["value", "disabled"], il = /* @__PURE__ */ L({
  __name: "BFormSelectOption",
  props: {
    disabled: { type: Boolean, default: !1 },
    value: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BFormSelectOption");
    return (l, t) => (m(), A("option", {
      value: n(e).value,
      disabled: n(e).disabled
    }, [
      $(l.$slots, "default")
    ], 8, Ou));
  }
}), Iu = ["label"], Pu = ["innerHTML"], hn = /* @__PURE__ */ L({
  __name: "BFormSelectOptionGroup",
  props: {
    disabledField: { default: "disabled" },
    htmlField: { default: "html" },
    label: { default: void 0 },
    options: { default: () => [] },
    textField: { default: "text" },
    valueField: { default: "value" }
  },
  setup(a) {
    const e = M(a, "BFormSelectOptionGroup"), { normalizedOptions: l } = Xo(() => e.options, e), t = _(() => l.value);
    return (s, r) => (m(), A("optgroup", {
      label: n(e).label
    }, [
      $(s.$slots, "first"),
      (m(!0), A(ve, null, ke(t.value, (u, i) => (m(), P(il, K({
        key: i,
        disabled: u.disabled,
        value: u.value,
        ref_for: !0
      }, s.$attrs), {
        default: I(() => [
          u.html ? (m(), A("span", {
            key: 0,
            innerHTML: u.html
          }, null, 8, Pu)) : (m(), A(ve, { key: 1 }, [
            ue(J(u.text), 1)
          ], 64))
        ]),
        _: 2
      }, 1040, ["disabled", "value"]))), 128)),
      $(s.$slots, "default")
    ], 8, Iu));
  }
}), Nu = ["id", "name", "form", "multiple", "size", "disabled", "required", "aria-required", "aria-invalid"], Eu = ["innerHTML"], Fu = /* @__PURE__ */ L({
  __name: "BFormSelect",
  props: /* @__PURE__ */ ge({
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledField: { default: "disabled" },
    form: { default: void 0 },
    htmlField: { default: "html" },
    id: { default: void 0 },
    labelField: { default: "label" },
    modelValue: { type: [Boolean, String, Array, Object, Number, null] },
    multiple: { type: Boolean, default: !1 },
    name: { default: void 0 },
    options: { default: () => [] },
    optionsField: { default: "options" },
    plain: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    selectSize: { default: 0 },
    size: { default: "md" },
    state: { type: [Boolean, null], default: null },
    textField: { default: "text" },
    valueField: { default: "value" }
  }, {
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      default: ""
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormSelect"), t = _e(a, "modelValue"), s = we(() => l.id, "input"), r = he(() => l.selectSize), u = kt(() => l.state), i = z(null), { focused: d } = Fe(i, {
      initialValue: l.autofocus
    }), f = _(() => [
      u.value,
      {
        "form-control": l.plain,
        [`form-control-${l.size}`]: l.size !== "md" && l.plain,
        "form-select": !l.plain,
        [`form-select-${l.size}`]: l.size !== "md" && !l.plain
      }
    ]), c = k(
      () => r.value || l.plain ? r.value : void 0
    ), y = ba(
      () => l.ariaInvalid,
      () => l.state
    ), { normalizedOptions: p, isComplex: b } = Xo(() => l.options, l), h = _(
      () => p.value
    ), w = _({
      get: () => t.value,
      set: (v) => {
        t.value = v;
      }
    });
    return o({
      blur: () => {
        d.value = !1;
      },
      element: i,
      focus: () => {
        d.value = !0;
      }
    }), (v, B) => ct((m(), A("select", {
      id: n(s),
      ref_key: "input",
      ref: i,
      "onUpdate:modelValue": B[0] || (B[0] = (g) => w.value = g),
      class: R(f.value),
      name: n(l).name,
      form: n(l).form || void 0,
      multiple: n(l).multiple || void 0,
      size: c.value,
      disabled: n(l).disabled,
      required: n(l).required || void 0,
      "aria-required": n(l).required || void 0,
      "aria-invalid": n(y)
    }, [
      $(v.$slots, "first"),
      (m(!0), A(ve, null, ke(h.value, (g, S) => (m(), A(ve, { key: S }, [
        n(b)(g) ? (m(), P(hn, {
          key: 0,
          label: g.label,
          options: g.options,
          "value-field": n(l).valueField,
          "text-field": n(l).textField,
          "html-field": n(l).htmlField,
          "disabled-field": n(l).disabledField
        }, null, 8, ["label", "options", "value-field", "text-field", "html-field", "disabled-field"])) : (m(), P(il, {
          key: 1,
          value: g.value,
          disabled: g.disabled
        }, {
          default: I(() => [
            g.html ? (m(), A("span", {
              key: 0,
              innerHTML: g.html
            }, null, 8, Eu)) : (m(), A(ve, { key: 1 }, [
              ue(J(g.text), 1)
            ], 64))
          ]),
          _: 2
        }, 1032, ["value", "disabled"]))
      ], 64))), 128)),
      $(v.$slots, "default")
    ], 10, Nu)), [
      [Ln, w.value]
    ]);
  }
}), Ta = "ArrowDown", Il = "End", Pl = "Home", Nl = "PageDown", El = "PageUp", $a = "ArrowUp", Lu = ["lang", "tabindex", "title"], zu = ["name", "form", "value"], Hu = ["id", "dir", "tabindex", "aria-label", "aria-invalid", "aria-required", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext"], Re = {
  min: 1,
  max: 100,
  step: 1,
  repeatDelay: 500,
  repeatInterval: 100,
  repeatThreshold: 10,
  repeatMultiplier: 4
}, Mu = /* @__PURE__ */ L({
  __name: "BFormSpinbutton",
  props: /* @__PURE__ */ ge({
    ariaControls: { default: void 0 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    formatterFn: { type: Function, default: void 0 },
    id: { default: void 0 },
    inline: { type: Boolean, default: !1 },
    labelDecrement: { default: "Decrement" },
    labelIncrement: { default: "Increment" },
    locale: { default: void 0 },
    max: { default: Re.max },
    min: { default: Re.min },
    modelValue: {},
    name: { default: void 0 },
    placeholder: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    repeatDelay: { default: Re.repeatDelay },
    repeatInterval: { default: Re.repeatInterval },
    repeatStepMultiplier: { default: Re.repeatMultiplier },
    repeatThreshold: { default: Re.repeatThreshold },
    required: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    step: { default: Re.step },
    vertical: { type: Boolean, default: !1 },
    wrap: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      default: null
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["change"], ["update:modelValue"]),
  setup(a, { emit: o }) {
    const e = [$a, Ta, Pl, Il, El, Nl], t = M(a, "BFormSpinbutton"), s = o, r = _e(a, "modelValue"), u = z(null), { focused: i } = Fe(u), d = we(() => t.id, "spinbutton"), f = _(() => ({
      disabled: t.disabled,
      readonly: t.readonly,
      focus: i.value,
      "d-inline-flex": t.inline || t.vertical,
      "d-flex": !t.inline && !t.vertical,
      "align-items-stretch": !t.vertical,
      "flex-column": t.vertical,
      [`form-control-${t.size}`]: t.size !== void 0
    })), c = _(() => ({
      "d-flex": t.vertical,
      "align-self-center": !t.vertical,
      "align-items-center": t.vertical,
      "border-top": t.vertical,
      "border-bottom": t.vertical,
      "border-start": !t.vertical,
      "border-end": !t.vertical
    }));
    let y, p, b = !1;
    const h = he(() => t.step), w = k(
      () => Number.isNaN(h.value) ? Re.step : h.value
    ), v = he(() => t.min), B = k(
      () => Number.isNaN(v.value) ? Re.min : v.value
    ), g = he(() => t.max), S = k(() => {
      const H = w.value, se = B.value;
      return Math.floor((g.value - se) / H) * H + se;
    }), C = he(() => t.repeatDelay, {
      nanToZero: !0,
      method: "parseInt"
    }), x = k(
      () => C.value > 0 ? C.value : Re.repeatDelay
    ), V = he(() => t.repeatInterval, {
      nanToZero: !0,
      method: "parseInt"
    }), q = k(
      () => V.value > 0 ? V.value : Re.repeatInterval
    ), G = he(() => t.repeatThreshold, {
      nanToZero: !0,
      method: "parseInt"
    }), O = k(
      () => Math.max(
        Number.isNaN(G.value) ? Re.repeatThreshold : G.value,
        1
      )
    ), Z = he(() => t.repeatStepMultiplier, {
      nanToZero: !0,
      method: "parseInt"
    }), ae = k(
      () => Math.max(
        Number.isNaN(Z.value) ? Re.repeatMultiplier : Z.value,
        1
      )
    ), ie = k(() => {
      const H = w.value;
      return Math.floor(H) === H ? 0 : (H.toString().split(".")[1] || "").length;
    }), X = k(() => Math.pow(10, ie.value || 0)), j = k(
      () => r.value === null ? "" : r.value.toFixed(ie.value)
    ), { isRtl: T, locale: N } = Gr(), F = _(() => {
      const se = [(t.locale ?? (N == null ? void 0 : N.value)) || "locale"];
      return new Intl.NumberFormat(se).resolvedOptions().locale;
    }), W = () => new Intl.NumberFormat(F.value, {
      style: "decimal",
      useGrouping: !1,
      minimumIntegerDigits: 1,
      minimumFractionDigits: ie.value,
      maximumFractionDigits: ie.value,
      notation: "standard"
    }).format, E = k(() => t.formatterFn ?? W()), D = (H) => {
      let { value: se } = r;
      if (!t.disabled && se !== null) {
        const be = w.value * H, me = B.value, Oe = S.value, $e = X.value, { wrap: xe } = t;
        se = Math.round((se - me) / be) * be + me + be, se = Math.round(se * $e) / $e, r.value = se > Oe ? xe ? me : Oe : se < me ? xe ? Oe : me : se;
      }
    }, te = (H = 1) => {
      if (r.value === null) {
        r.value = B.value;
        return;
      }
      D(1 * H);
    }, re = (H = 1) => {
      if (r.value === null) {
        r.value = t.wrap ? S.value : B.value;
        return;
      }
      D(-1 * H);
    }, U = (H) => {
      H.preventDefault(), H.stopImmediatePropagation();
    };
    De(
      e,
      (H) => {
        const { code: se, altKey: be, ctrlKey: me, metaKey: Oe } = H;
        if (!(t.disabled || t.readonly || be || me || Oe) && (U(H), !b)) {
          if (oe(), [$a, Ta].includes(se)) {
            if (b = !0, se === $a) {
              ne(H, te);
              return;
            }
            se === Ta && ne(H, re);
            return;
          }
          if (se === El) {
            te(ae.value);
            return;
          }
          if (se === Nl) {
            re(ae.value);
            return;
          }
          if (se === Pl) {
            r.value = B.value;
            return;
          }
          se === Il && (r.value = S.value);
        }
      },
      { target: u, eventName: "keydown" }
    ), De(
      e,
      (H) => {
        const { altKey: se, ctrlKey: be, metaKey: me } = H;
        t.disabled || t.readonly || se || be || me || (U(H), oe(), b = !1, s("change", r.value));
      },
      { target: u, eventName: "keyup" }
    );
    const ne = (H, se) => {
      const { type: be } = H || {};
      if (!t.disabled && !t.readonly) {
        if (pe(H) && be === "mousedown" && H.button)
          return;
        oe(), se(1);
        const me = O.value, Oe = ae.value, $e = x.value, xe = q.value;
        y = setTimeout(() => {
          let et = 0;
          p = setInterval(() => {
            se(et < me ? 1 : Oe), et++;
          }, xe);
        }, $e);
      }
    }, pe = (H) => H.type === "mouseup" || H.type === "mousedown", Y = (H) => {
      pe(H) && H.type === "mouseup" && H.button || (U(H), oe(), de(!1), s("change", r.value));
    }, de = (H) => {
      try {
        fl(H, [document.body, "mouseup", Y, !1]), fl(H, [document.body, "touchend", Y, !1]);
      } catch {
      }
    }, oe = () => {
      clearTimeout(y), clearInterval(p), y = void 0, p = void 0;
    }, le = _(() => {
      const H = {
        svg: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          fill: "currentColor",
          class: "bi bi-plus",
          viewBox: "0 0 16 16"
        },
        path: {
          d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
        }
      }, se = {
        svg: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          fill: "currentColor",
          class: "bi bi-dash",
          viewBox: "0 0 16 16"
        },
        path: { d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" }
      }, be = {
        class: [{ "py-0": !t.vertical }, "btn", "btn-sm", "border-0", "rounded-0"],
        tabindex: "-1",
        type: "button",
        disabled: t.disabled || t.readonly,
        "aria-disabled": t.disabled || t.readonly ? !0 : void 0,
        "aria-controls": d.value
      }, me = {
        "aria-hidden": !0,
        scale: i.value ? 1.5 : 1.25
      }, Oe = (et, Sn) => {
        !t.disabled && !t.readonly && (U(et), de(!0), i.value = !0, ne(et, Sn));
      }, $e = {
        button: {
          ...be,
          "aria-label": t.labelIncrement || void 0,
          "aria-keyshortcuts": "ArrowUp"
        },
        svg: {
          ...me,
          ...H.svg
        },
        path: {
          ...H.path
        },
        slot: {
          name: "increment"
        },
        handler: (et) => Oe(et, te)
      }, xe = {
        button: {
          ...be,
          "aria-label": t.labelDecrement || void 0,
          "aria-keyshortcuts": "ArrowDown"
        },
        svg: {
          ...me,
          ...se.svg
        },
        path: {
          ...se.path
        },
        slot: {
          name: "decrement"
        },
        handler: (et) => Oe(et, re)
      };
      return {
        top: {
          ...t.vertical ? $e : xe
        },
        bottom: {
          ...t.vertical ? xe : $e
        }
      };
    });
    return (H, se) => (m(), A("div", {
      ref_key: "element",
      ref: u,
      class: R(["b-form-spinbutton form-control", f.value]),
      role: "group",
      lang: F.value,
      tabindex: n(t).disabled ? void 0 : "-1",
      title: n(t).ariaLabel,
      onClick: se[4] || (se[4] = (be) => i.value = !0)
    }, [
      $(H.$slots, le.value.top.slot.name, { hasFocus: n(i) }, () => [
        Q("button", K(le.value.top.button, {
          onMousedown: se[0] || (se[0] = //@ts-ignore
          (...be) => le.value.top.handler && le.value.top.handler(...be)),
          onTouchstart: se[1] || (se[1] = //@ts-ignore
          (...be) => le.value.top.handler && le.value.top.handler(...be))
        }), [
          (m(), A("svg", Be(Ce(le.value.top.svg)), [
            Q("path", Be(Ce(le.value.top.path)), null, 16)
          ], 16))
        ], 16)
      ]),
      n(t).name && !n(t).disabled ? (m(), A("input", {
        key: "hidden",
        type: "hidden",
        name: n(t).name,
        form: n(t).form,
        value: j.value
      }, null, 8, zu)) : ee("", !0),
      Q("output", {
        id: n(d),
        key: "output",
        class: R(["flex-grow-1", c.value]),
        dir: n(T) ?? !1 ? "rtl" : "ltr",
        tabindex: n(t).disabled ? void 0 : "0",
        role: "spinbutton",
        "aria-live": "off",
        "aria-label": n(t).ariaLabel || void 0,
        "aria-invalid": n(t).state === !1 || !r.value !== null && n(t).required ? !0 : void 0,
        "aria-required": n(t).required ? !0 : void 0,
        "aria-valuemin": B.value,
        "aria-valuemax": S.value,
        "aria-valuenow": r.value !== null ? r.value : void 0,
        "aria-valuetext": r.value !== null ? E.value(r.value) : void 0
      }, [
        Q("bdi", null, J((r.value !== null ? E.value(r.value) : n(t).placeholder) || ""), 1)
      ], 10, Hu),
      $(H.$slots, le.value.bottom.slot.name, { hasFocus: n(i) }, () => [
        Q("button", K(le.value.bottom.button, {
          onMousedown: se[2] || (se[2] = //@ts-ignore
          (...be) => le.value.bottom.handler && le.value.bottom.handler(...be)),
          onTouchstart: se[3] || (se[3] = //@ts-ignore
          (...be) => le.value.bottom.handler && le.value.bottom.handler(...be))
        }), [
          (m(), A("svg", Be(Ce(le.value.bottom.svg)), [
            Q("path", Be(Ce(le.value.bottom.path)), null, 16)
          ], 16))
        ], 16)
      ])
    ], 10, Lu));
  }
}), Ru = ["id"], Bn = /* @__PURE__ */ L({
  __name: "BFormTag",
  props: {
    disabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    noRemove: { type: Boolean, default: !1 },
    pill: { type: Boolean, default: !1 },
    removeLabel: { default: "Remove tag" },
    tag: { default: "span" },
    title: { default: void 0 },
    variant: { default: "secondary" }
  },
  emits: ["remove"],
  setup(a, { emit: o }) {
    const l = M(a, "BFormTag"), t = o, s = He(), r = we(() => l.id), u = _(
      () => {
        var f;
        return ((((f = s.default) == null ? void 0 : f.call(s, {})[0].children) ?? "").toString() || l.title) ?? "";
      }
    ), i = k(() => `${r.value}taglabel__`), d = _(() => ({
      [`text-bg-${l.variant}`]: l.variant !== null,
      "rounded-pill": l.pill,
      disabled: l.disabled
    }));
    return (f, c) => (m(), P(ce(n(l).tag), {
      id: n(r),
      title: u.value,
      class: R(["badge b-form-tag d-inline-flex align-items-center mw-100", d.value]),
      "aria-labelledby": i.value
    }, {
      default: I(() => [
        Q("span", {
          id: i.value,
          class: "b-form-tag-content flex-grow-1 text-truncate"
        }, [
          $(f.$slots, "default", {}, () => [
            ue(J(u.value), 1)
          ])
        ], 8, Ru),
        !n(l).disabled && !n(l).noRemove ? (m(), P(Ft, {
          key: 0,
          "aria-keyshortcuts": "Delete",
          "aria-label": n(l).removeLabel,
          class: "b-form-tag-remove",
          "aria-describedby": i.value,
          "aria-controls": n(l).id,
          onClick: c[0] || (c[0] = (y) => t("remove", u.value))
        }, null, 8, ["aria-label", "aria-describedby", "aria-controls"])) : ee("", !0)
      ]),
      _: 3
    }, 8, ["id", "title", "class", "aria-labelledby"]));
  }
}), Du = ["id"], ju = ["id", "for", "aria-live"], Gu = ["id", "aria-live"], Wu = ["id"], qu = ["aria-controls"], Uu = {
  role: "group",
  class: "d-flex"
}, Xu = ["id", "disabled", "value", "type", "placeholder", "form", "required", "aria-required"], Ku = ["disabled"], Yu = {
  "aria-live": "polite",
  "aria-atomic": "true"
}, Zu = {
  key: 0,
  class: "d-block invalid-feedback"
}, Ju = {
  key: 1,
  class: "form-text text-body-secondary"
}, Qu = {
  key: 2,
  class: "form-text text-body-secondary"
}, ed = ["name", "value"], td = /* @__PURE__ */ L({
  __name: "BFormTags",
  props: /* @__PURE__ */ ge({
    addButtonText: { default: "Add" },
    addButtonVariant: { default: "outline-secondary" },
    addOnChange: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    duplicateTagText: { default: "Duplicate tag(s)" },
    form: { default: void 0 },
    inputAttrs: { default: void 0 },
    inputClass: { default: void 0 },
    inputId: { default: void 0 },
    inputType: { default: "text" },
    invalidTagText: { default: "Invalid tag(s)" },
    limit: { default: void 0 },
    limitTagsText: { default: "Tag limit reached" },
    modelValue: {},
    name: { default: void 0 },
    noAddOnEnter: { type: Boolean, default: !1 },
    noOuterFocus: { type: Boolean, default: !1 },
    noTagRemove: { type: Boolean, default: !1 },
    placeholder: { default: "Add tag..." },
    removeOnDelete: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    separator: { default: void 0 },
    size: { default: "md" },
    state: { type: [Boolean, null], default: null },
    tagClass: { default: void 0 },
    tagPills: { type: Boolean, default: !1 },
    tagRemoveLabel: { default: void 0 },
    tagRemovedLabel: { default: "Tag removed" },
    tagValidator: { type: Function, default: () => !0 },
    tagVariant: { default: "secondary" }
  }, {
    modelValue: {
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["blur", "focus", "focusin", "focusout", "tag-state"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BFormTags"), s = e, r = _e(a, "modelValue"), u = we(), i = he(() => t.limit ?? NaN), d = kt(() => t.state), f = z(null), { focused: c } = Fe(f, {
      initialValue: t.autofocus
    }), y = k(() => t.inputId || `${u.value}input__`), p = z([...r.value]), b = z(""), h = z(r.value.length > 0), w = z(""), v = z([]), B = z([]), g = z([]);
    Ia(r, p, {
      direction: "ltr",
      transform: {
        ltr: (E) => [...E]
      }
    });
    const S = _(() => [
      d.value,
      {
        [`form-control-${t.size}`]: t.size !== "md",
        disabled: t.disabled,
        focus: c.value
      }
    ]), C = _(() => p.value.includes(b.value)), x = _(
      () => b.value === "" ? !1 : !t.tagValidator(b.value)
    ), V = k(() => p.value.length === i.value), q = k(() => !x.value && !C.value), G = _(() => ({
      addButtonText: t.addButtonText,
      addButtonVariant: t.addButtonVariant,
      addTag: F,
      disableAddButton: q.value,
      disabled: t.disabled,
      duplicateTagText: t.duplicateTagText,
      duplicateTags: g.value,
      form: t.form,
      inputAttrs: {
        ...t.inputAttrs,
        disabled: t.disabled,
        form: t.form,
        id: y,
        value: b
      },
      inputHandlers: {
        input: ie,
        keydown: j,
        change: X
      },
      inputId: y,
      inputType: t.inputType,
      invalidTagText: t.invalidTagText,
      invalidTags: B.value,
      isDuplicate: C.value,
      isInvalid: x.value,
      isLimitReached: V.value,
      limitTagsText: t.limitTagsText,
      limit: i.value,
      noTagRemove: t.noTagRemove,
      placeholder: t.placeholder,
      removeTag: W,
      required: t.required,
      separator: t.separator,
      size: t.size,
      state: t.state,
      tagClass: t.tagClass,
      tagPills: t.tagPills,
      tagRemoveLabel: t.tagRemoveLabel,
      tagVariant: t.tagVariant,
      tags: p.value
    })), O = (E) => {
      if (t.disabled) {
        E.target.blur();
        return;
      }
      s("focusin", E);
    }, Z = (E) => {
      t.disabled || t.noOuterFocus || (c.value = !0, s("focus", E));
    }, ae = (E) => {
      c.value = !1, s("blur", E);
    }, ie = (E) => {
      var te, re;
      const D = typeof E == "string" ? E : E.target.value;
      if (h.value = !1, (te = t.separator) != null && te.includes(D.charAt(0)) && D.length > 0) {
        f.value && (f.value.value = "");
        return;
      }
      if (b.value = D, (re = t.separator) != null && re.includes(D.charAt(D.length - 1))) {
        F(D.slice(0, D.length - 1));
        return;
      }
      v.value = t.tagValidator(D) && !C.value ? [D] : [], B.value = t.tagValidator(D) ? [] : [D], g.value = C.value ? [D] : [], s("tag-state", v.value, B.value, g.value);
    }, X = (E) => {
      t.addOnChange && (ie(E), C.value || F(b.value));
    }, j = (E) => {
      if (E.key === "Enter" && !t.noAddOnEnter) {
        F(b.value);
        return;
      }
      (E.key === "Backspace" || E.key === "Delete") && t.removeOnDelete && b.value === "" && h.value && p.value.length > 0 ? W(p.value[p.value.length - 1]) : h.value = !0;
    };
    De(j, { target: f });
    const T = _(() => {
      if (t.separator)
        return typeof t.separator == "string" ? t.separator : t.separator.join("");
    }), N = _(() => {
      if (T.value)
        return new RegExp(`[${Ir(T.value)}]+`);
    }), F = (E) => {
      E = (E ?? b.value).trim();
      const D = N.value ? E.split(N.value).map((U) => U.trim()) : [E], te = [];
      for (const U of D)
        if (!(U === "" || C.value || !t.tagValidator(U))) {
          if (i.value && V.value)
            break;
          te.push(U);
        }
      const re = [...r.value, ...te];
      b.value = "", h.value = !0, r.value = re, c.value = !0;
    }, W = (E) => {
      const D = p.value.indexOf((E == null ? void 0 : E.toString()) ?? "");
      D !== -1 && (w.value = p.value.splice(D, 1).toString(), r.value = p.value);
    };
    return o({
      blur: () => {
        c.value = !1;
      },
      element: f,
      focus: () => {
        c.value = !0;
      }
    }), (E, D) => (m(), A("div", {
      id: n(u),
      class: R(["b-form-tags form-control h-auto", S.value]),
      role: "group",
      tabindex: "-1",
      onFocusin: O,
      onFocusout: D[1] || (D[1] = (te) => s("focusout", te))
    }, [
      Q("output", {
        id: `${n(u)}selected_tags__`,
        class: "visually-hidden",
        for: y.value,
        "aria-live": n(c) ? "polite" : "off",
        "aria-atomic": "true",
        "aria-relevant": "additions text"
      }, J(p.value.join(", ")), 9, ju),
      Q("div", {
        id: `${n(u)}removed_tags__`,
        role: "status",
        "aria-live": n(c) ? "assertive" : "off",
        "aria-atomic": "true",
        class: "visually-hidden"
      }, " (" + J(n(t).tagRemovedLabel) + ") " + J(w.value), 9, Gu),
      $(E.$slots, "default", Be(Ce(G.value)), () => [
        Q("ul", {
          id: `${n(u)}tag_list__`,
          class: "b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center"
        }, [
          (m(!0), A(ve, null, ke(p.value, (te, re) => $(E.$slots, "tag", {
            key: re,
            tag: te,
            tagClass: n(t).tagClass,
            tagVariant: n(t).tagVariant,
            tagPills: n(t).tagPills,
            removeTag: W
          }, () => [
            (m(), P(Bn, {
              key: te,
              class: R(n(t).tagClass),
              tag: "li",
              variant: n(t).tagVariant,
              pill: n(t).tagPills,
              onRemove: W
            }, {
              default: I(() => [
                ue(J(te), 1)
              ]),
              _: 2
            }, 1032, ["class", "variant", "pill"]))
          ])), 128)),
          Q("li", {
            role: "none",
            "aria-live": "off",
            class: "b-from-tags-field flex-grow-1",
            "aria-controls": `${n(u)}tag_list__`
          }, [
            Q("div", Uu, [
              Q("input", K({
                id: y.value,
                ref_key: "input",
                ref: f,
                disabled: n(t).disabled,
                value: b.value,
                type: n(t).inputType,
                placeholder: n(t).placeholder,
                class: "b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0",
                style: { outline: "currentcolor none 0px", "min-width": "5rem" }
              }, n(t).inputAttrs, {
                form: n(t).form,
                required: n(t).required || void 0,
                "aria-required": n(t).required || void 0,
                onInput: ie,
                onChange: X,
                onFocus: Z,
                onBlur: ae
              }), null, 16, Xu),
              q.value ? (m(), A("button", {
                key: 0,
                type: "button",
                class: R(["btn b-form-tags-button py-0", [
                  E.inputClass,
                  {
                    [`btn-${n(t).addButtonVariant}`]: n(t).addButtonVariant !== null,
                    "disabled invisible": b.value.length === 0
                  }
                ]]),
                style: { "font-size": "90%" },
                disabled: n(t).disabled || b.value.length === 0 || V.value,
                onClick: D[0] || (D[0] = (te) => F(b.value))
              }, [
                $(E.$slots, "add-button-text", {}, () => [
                  ue(J(n(t).addButtonText), 1)
                ])
              ], 10, Ku)) : ee("", !0)
            ])
          ], 8, qu)
        ], 8, Wu),
        Q("div", Yu, [
          x.value ? (m(), A("div", Zu, J(n(t).invalidTagText) + ": " + J(b.value), 1)) : ee("", !0),
          C.value ? (m(), A("small", Ju, J(n(t).duplicateTagText) + ": " + J(b.value), 1)) : ee("", !0),
          p.value.length === n(t).limit ? (m(), A("small", Qu, J(n(t).limitTagsText), 1)) : ee("", !0)
        ])
      ]),
      n(t).name ? (m(!0), A(ve, { key: 0 }, ke(p.value, (te, re) => (m(), A("input", {
        key: re,
        type: "hidden",
        name: n(t).name,
        value: te
      }, null, 8, ed))), 128)) : ee("", !0)
    ], 42, Du));
  }
}), ad = ["id", "name", "form", "value", "disabled", "placeholder", "required", "autocomplete", "readonly", "aria-required", "aria-invalid", "rows", "wrap"], ld = /* @__PURE__ */ L({
  __name: "BFormTextarea",
  props: /* @__PURE__ */ ge({
    noResize: { type: Boolean, default: !1 },
    rows: { default: 2 },
    wrap: { default: "soft" },
    ariaInvalid: { type: [Boolean, String], default: void 0 },
    autocomplete: { default: void 0 },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    form: { default: void 0 },
    formatter: { type: Function, default: void 0 },
    id: { default: void 0 },
    lazyFormatter: { type: Boolean, default: !1 },
    list: { default: void 0 },
    modelValue: { default: "" },
    name: { default: void 0 },
    placeholder: { default: void 0 },
    plaintext: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: void 0 },
    state: { type: [Boolean, null], default: null },
    debounce: { default: 0 },
    debounceMaxWait: { default: NaN }
  }, {
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    const l = M(a, "BFormTextarea"), [t, s] = _e(a, "modelValue", {
      set: (v) => {
        if (v === null)
          return;
        let B = v;
        if (s.trim && (B = B.toString().trim()), s.number && typeof B == "string" && B !== "") {
          const g = Number.parseFloat(B);
          B = Number.isNaN(g) ? B : g;
        }
        return B;
      }
    }), { input: r, computedId: u, computedAriaInvalid: i, onInput: d, onChange: f, onBlur: c, focus: y, blur: p } = Uo(l, t, s), b = kt(() => l.state), h = _(() => [
      b.value,
      l.plaintext ? "form-control-plaintext" : "form-control",
      {
        [`form-control-${l.size}`]: !!l.size
      }
    ]), w = _(() => ({
      resize: l.noResize ? "none" : void 0
    }));
    return o({
      blur: p,
      element: r,
      focus: y
    }), (v, B) => (m(), A("textarea", {
      id: n(u),
      ref_key: "input",
      ref: r,
      class: R(h.value),
      name: n(l).name || void 0,
      form: n(l).form || void 0,
      value: n(t) ?? void 0,
      disabled: n(l).disabled,
      placeholder: n(l).placeholder,
      required: n(l).required || void 0,
      autocomplete: n(l).autocomplete || void 0,
      readonly: n(l).readonly || n(l).plaintext,
      "aria-required": n(l).required || void 0,
      "aria-invalid": n(i),
      rows: n(l).rows,
      style: Le(w.value),
      wrap: n(l).wrap || void 0,
      onInput: B[0] || (B[0] = (g) => n(d)(g)),
      onChange: B[1] || (B[1] = (g) => n(f)(g)),
      onBlur: B[2] || (B[2] = (g) => n(c)(g))
    }, null, 46, ad));
  }
}), od = {
  key: 0,
  class: "input-group-text"
}, nd = ["innerHTML"], sd = { key: 1 }, rd = {
  key: 0,
  class: "input-group-text"
}, id = ["innerHTML"], ud = { key: 1 }, dd = /* @__PURE__ */ L({
  __name: "BInputGroup",
  props: {
    append: { default: void 0 },
    appendHtml: { default: void 0 },
    id: { default: void 0 },
    prepend: { default: void 0 },
    prependHtml: { default: void 0 },
    size: { default: "md" },
    tag: { default: "div" }
  },
  setup(a) {
    Xe(Lo, !0);
    const e = M(a, "BInputGroup"), l = _(() => ({
      [`input-group-${e.size}`]: e.size !== "md"
    })), t = k(() => !!e.append || !!e.appendHtml), s = k(() => !!e.prepend || !!e.prependHtml);
    return (r, u) => (m(), P(ce(n(e).tag), {
      id: n(e).id,
      class: R(["input-group", l.value]),
      role: "group"
    }, {
      default: I(() => [
        $(r.$slots, "prepend", {}, () => [
          s.value ? (m(), A("span", od, [
            n(e).prependHtml ? (m(), A("span", {
              key: 0,
              innerHTML: n(e).prependHtml
            }, null, 8, nd)) : (m(), A("span", sd, J(n(e).prepend), 1))
          ])) : ee("", !0)
        ]),
        $(r.$slots, "default"),
        $(r.$slots, "append", {}, () => [
          t.value ? (m(), A("span", rd, [
            n(e).appendHtml ? (m(), A("span", {
              key: 0,
              innerHTML: n(e).appendHtml
            }, null, 8, id)) : (m(), A("span", ud, J(n(e).append), 1))
          ])) : ee("", !0)
        ])
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), _n = /* @__PURE__ */ L({
  __name: "BInputGroupText",
  props: {
    tag: { default: "div" },
    text: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BInputGroupText");
    return (l, t) => (m(), P(ce(n(e).tag), { class: "input-group-text" }, {
      default: I(() => [
        $(l.$slots, "default", {}, () => [
          ue(J(n(e).text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), ul = /* @__PURE__ */ L({
  __name: "BInputGroupAddon",
  props: {
    isText: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BInputGroupAddon");
    return (l, t) => n(e).isText ? (m(), P(_n, { key: 0 }, {
      default: I(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    })) : $(l.$slots, "default", { key: 1 });
  }
}), cd = /* @__PURE__ */ L({
  __name: "BInputGroupAppend",
  props: {
    isText: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BInputGroupAppend");
    return (l, t) => (m(), P(ul, Be(Ce(n(e))), {
      default: I(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), fd = /* @__PURE__ */ L({
  __name: "BInputGroupPrepend",
  props: {
    isText: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BInputGroupPrepend");
    return (l, t) => (m(), P(ul, Be(Ce(n(e))), {
      default: I(() => [
        $(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), pd = /* @__PURE__ */ L({
  __name: "BListGroup",
  props: {
    flush: { type: Boolean, default: !1 },
    horizontal: { type: [Boolean, String], default: !1 },
    numbered: { type: Boolean, default: !1 },
    tag: { default: "div" }
  },
  setup(a) {
    const e = M(a, "BListGroup"), l = _(() => {
      const s = e.flush ? !1 : e.horizontal;
      return {
        "list-group-flush": e.flush,
        "list-group-horizontal": s === !0,
        [`list-group-horizontal-${s}`]: typeof s == "string",
        "list-group-numbered": e.numbered
      };
    }), t = k(() => e.numbered === !0 ? "ol" : e.tag);
    return Xe(To, {
      numbered: k(() => e.numbered)
    }), (s, r) => (m(), P(ce(t.value), {
      class: R(["list-group", l.value])
    }, {
      default: I(() => [
        $(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), vd = /* @__PURE__ */ L({
  __name: "BListGroupItem",
  props: {
    action: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    tag: { default: "div" },
    active: { type: Boolean, default: !1 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BListGroupItem"), l = Dt(), t = Ve(To, null), { computedLink: s } = Ct(e), r = k(() => !e.button && s.value), u = k(
      () => t != null && t.numbered.value ? "li" : e.button ? "button" : r.value ? st : e.tag
    ), i = _(
      () => e.action || r.value || e.button || ["a", "router-link", "button", "b-link"].includes(e.tag)
    ), d = _(() => ({
      [`list-group-item-${e.variant}`]: e.variant !== null && e.variant !== void 0,
      "list-group-item-action": i.value,
      active: e.active,
      disabled: e.disabled
    })), f = _(() => {
      const c = {};
      return e.button && ((!l || !l.type) && (c.type = "button"), e.disabled && (c.disabled = !0)), c;
    });
    return (c, y) => (m(), P(ce(u.value), K({
      class: ["list-group-item", d.value],
      "aria-current": n(e).active ? !0 : void 0,
      "aria-disabled": n(e).disabled ? !0 : void 0,
      target: r.value ? n(e).target : void 0,
      href: n(e).button ? void 0 : n(e).href,
      to: n(e).button ? void 0 : n(e).to
    }, f.value), {
      default: I(() => [
        $(c.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "aria-current", "aria-disabled", "target", "href", "to"]));
  }
}), md = { id: "__BVID__modal-container" }, bd = /* @__PURE__ */ L({
  __name: "BModalOrchestrator",
  props: {
    teleportDisabled: { default: !1 },
    teleportTo: { default: "body" }
  },
  setup(a, { expose: o }) {
    const l = M(a, "BModalOrchestrator"), { modals: t, remove: s, show: r, confirm: u } = Ko(), i = (d) => ha(d, ["_promise", "_self", "_isConfirm", "_modelValue"]);
    return o({
      modals: t,
      show: r,
      confirm: u
    }), (d, f) => (m(), P(_t, {
      to: n(l).teleportTo,
      disabled: n(l).teleportDisabled
    }, [
      Q("div", md, [
        (m(!0), A(ve, null, ke(n(t), (c, y) => (m(), P(ce(c.value.component), K({
          key: y,
          modelValue: c.value.props._modelValue,
          "onUpdate:modelValue": (p) => c.value.props._modelValue = p,
          ref_for: !0
        }, i(c.value.props), {
          "teleport-disabled": !0,
          onHide: (p) => {
            if (c.value.props._isConfirm === !0) {
              if (p.trigger === "ok") {
                c.value.props._promise.resolve(!0);
                return;
              }
              if (p.trigger === "cancel") {
                c.value.props._promise.resolve(!1);
                return;
              }
              c.value.props._promise.resolve(null);
            }
            c.value.props._promise.resolve(!0);
          },
          onHidden: (p) => {
            var b;
            return (b = n(s)) == null ? void 0 : b(c.value.props._self);
          }
        }), null, 16, ["modelValue", "onUpdate:modelValue", "onHide", "onHidden"]))), 128))
      ])
    ], 8, ["to", "disabled"]));
  }
}), yd = /* @__PURE__ */ L({
  __name: "BNav",
  props: {
    align: { default: void 0 },
    cardHeader: { type: Boolean, default: !1 },
    fill: { type: Boolean, default: !1 },
    justified: { type: Boolean, default: !1 },
    pills: { type: Boolean, default: !1 },
    small: { type: Boolean, default: !1 },
    tabs: { type: Boolean, default: !1 },
    tag: { default: "ul" },
    underline: { type: Boolean, default: !1 },
    vertical: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BNav"), l = Gt(() => e.align), t = _(() => ({
      "nav-tabs": e.tabs,
      "nav-pills": e.pills && !e.tabs,
      "card-header-tabs": !e.vertical && e.cardHeader && e.tabs,
      "card-header-pills": !e.vertical && e.cardHeader && e.pills && !e.tabs,
      "flex-column": e.vertical,
      "nav-fill": !e.vertical && e.fill,
      "nav-justified": !e.vertical && e.justified,
      [l.value]: !e.vertical && e.align !== void 0,
      small: e.small,
      "nav-underline": e.underline
    }));
    return (s, r) => (m(), P(ce(n(e).tag), {
      class: R(["nav", t.value])
    }, {
      default: I(() => [
        $(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), gd = { class: "d-flex flex-row align-items-center flex-wrap" }, hd = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BNavForm",
  props: {
    role: { default: void 0 },
    floating: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    novalidate: { type: Boolean, default: void 0 },
    validated: { type: Boolean, default: void 0 }
  },
  emits: ["submit"],
  setup(a, { emit: o }) {
    const l = M(a, "BNavForm"), t = o, s = (r) => {
      t("submit", r);
    };
    return (r, u) => (m(), A("li", gd, [
      ye(mn, K(r.$attrs, {
        id: n(l).id,
        floating: n(l).floating,
        role: n(l).role,
        novalidate: n(l).novalidate,
        validated: n(l).validated,
        class: "d-flex",
        onSubmit: vt(s, ["prevent"])
      }), {
        default: I(() => [
          $(r.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "floating", "role", "novalidate", "validated"])
    ]));
  }
}), Bd = { class: "nav-item" }, _d = /* @__PURE__ */ L({
  __name: "BNavItem",
  props: {
    linkAttrs: { default: void 0 },
    linkClass: { default: void 0 },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: void 0 }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BNavItem"), t = o, s = _(
      () => ll(l, [
        "active",
        "activeClass",
        "append",
        "disabled",
        "href",
        "icon",
        "opacity",
        "opacityHover",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover",
        "underlineVariant",
        "variant"
      ])
    );
    return s.value.activeClass, (r, u) => (m(), A("li", Bd, [
      ye(st, K({
        class: ["nav-link", r.linkClass],
        tabindex: n(l).disabled ? -1 : void 0,
        "aria-disabled": n(l).disabled ? !0 : void 0
      }, { ...s.value, ...r.linkAttrs }, {
        onClick: u[0] || (u[0] = (i) => t("click", i))
      }), {
        default: I(() => [
          $(r.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "tabindex", "aria-disabled"])
    ]));
  }
}), wd = { class: "nav-item dropdown" }, Cd = /* @__PURE__ */ L({
  __name: "BNavItemDropdown",
  props: /* @__PURE__ */ ge({
    ariaLabel: { default: void 0 },
    autoClose: { type: [Boolean, String], default: !0 },
    boundary: { default: "clippingAncestors" },
    boundaryPadding: { default: void 0 },
    center: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dropend: { type: Boolean, default: !1 },
    dropstart: { type: Boolean, default: !1 },
    dropup: { type: Boolean, default: !1 },
    end: { type: Boolean, default: !1 },
    floatingMiddleware: { default: void 0 },
    id: { default: void 0 },
    isNav: { type: Boolean, default: !0 },
    lazy: { type: Boolean, default: !1 },
    menuClass: { default: void 0 },
    modelValue: { type: Boolean },
    noCaret: { type: Boolean, default: !1 },
    noFlip: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 },
    noSize: { type: Boolean, default: !1 },
    offset: { default: 0 },
    role: { default: "menu" },
    size: { default: "md" },
    skipWrapper: { type: Boolean },
    split: { type: Boolean, default: !1 },
    splitButtonType: { default: "button" },
    splitClass: { default: void 0 },
    splitDisabled: { type: Boolean, default: void 0 },
    splitHref: { default: void 0 },
    splitTo: { default: void 0 },
    splitVariant: { default: void 0 },
    strategy: { default: "absolute" },
    text: { default: void 0 },
    toggleClass: { default: void 0 },
    toggleText: { default: "Toggle dropdown" },
    variant: { default: "link" },
    wrapperClass: {},
    teleportDisabled: { default: !1 },
    teleportTo: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["click", "hidden", "hide", "hide-prevented", "show", "show-prevented", "shown", "toggle"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BNavItemDropdown"), s = e, r = _e(a, "modelValue"), u = z(null), i = () => {
      var c;
      (c = u.value) == null || c.hide();
    }, d = () => {
      var c;
      (c = u.value) == null || c.show();
    };
    return o({
      hide: i,
      show: d,
      toggle: () => {
        var c;
        (c = u.value) == null || c.toggle();
      }
    }), (c, y) => (m(), A("li", wd, [
      ye(vn, K({
        ref_key: "dropdown",
        ref: u
      }, n(t), {
        modelValue: r.value,
        "onUpdate:modelValue": y[0] || (y[0] = (p) => r.value = p),
        "is-nav": "",
        onShow: y[1] || (y[1] = (p) => s("show", p)),
        onShown: y[2] || (y[2] = (p) => s("shown")),
        onHide: y[3] || (y[3] = (p) => s("hide", p)),
        onHidden: y[4] || (y[4] = (p) => s("hidden")),
        onHidePrevented: y[5] || (y[5] = (p) => s("hide-prevented")),
        onShowPrevented: y[6] || (y[6] = (p) => s("show-prevented")),
        onClick: y[7] || (y[7] = (p) => s("click", p)),
        onToggle: y[8] || (y[8] = (p) => s("toggle"))
      }), {
        "button-content": I(() => [
          $(c.$slots, "button-content")
        ]),
        "toggle-text": I(() => [
          $(c.$slots, "toggle-text")
        ]),
        default: I(() => [
          $(c.$slots, "default", {
            hide: i,
            show: d
          })
        ]),
        _: 3
      }, 16, ["modelValue"])
    ]));
  }
}), kd = { class: "navbar-text" }, Td = /* @__PURE__ */ L({
  __name: "BNavText",
  props: {
    text: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BNavText");
    return (l, t) => (m(), A("li", kd, [
      $(l.$slots, "default", {}, () => [
        ue(J(n(e).text), 1)
      ])
    ]));
  }
}), $d = /* @__PURE__ */ L({
  __name: "BNavbar",
  props: {
    autoClose: { type: Boolean, default: !0 },
    container: { type: [Boolean, String], default: "fluid" },
    fixed: { default: void 0 },
    print: { type: Boolean, default: !1 },
    sticky: { default: void 0 },
    tag: { default: "nav" },
    toggleable: { type: [Boolean, String], default: !1 },
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BNavbar"), l = k(() => e.tag === "nav" ? void 0 : "navigation"), t = Fr(() => e.container), s = _(() => ({
      "d-print": e.print,
      [`sticky-${e.sticky}`]: e.sticky !== void 0,
      [`bg-${e.variant}`]: e.variant !== null,
      [`fixed-${e.fixed}`]: e.fixed !== void 0,
      "navbar-expand": e.toggleable === !1,
      [`navbar-expand-${e.toggleable}`]: typeof e.toggleable == "string"
    }));
    return Xe(al, {
      tag: k(() => e.tag),
      autoClose: k(() => e.autoClose)
    }), (r, u) => (m(), P(ce(n(e).tag), {
      class: R(["navbar", s.value]),
      role: l.value
    }, {
      default: I(() => [
        n(e).container !== !1 ? (m(), A("div", {
          key: 0,
          class: R(n(t))
        }, [
          $(r.$slots, "default")
        ], 2)) : $(r.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["class", "role"]));
  }
}), xd = /* @__PURE__ */ L({
  __name: "BNavbarBrand",
  props: {
    tag: { default: "div" },
    active: { type: Boolean, default: void 0 },
    activeClass: { default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    exactActiveClass: { default: void 0 },
    href: { default: void 0 },
    icon: { type: Boolean, default: void 0 },
    stretched: { type: Boolean, default: !1 },
    opacity: { default: void 0 },
    opacityHover: { default: void 0 },
    rel: { default: void 0 },
    replace: { type: Boolean, default: void 0 },
    routerComponentName: { default: void 0 },
    target: { default: void 0 },
    to: { default: void 0 },
    underlineOffset: { default: void 0 },
    underlineOffsetHover: { default: void 0 },
    underlineOpacity: { default: void 0 },
    underlineOpacityHover: { default: void 0 },
    underlineVariant: { default: void 0 },
    variant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BNavbarBrand"), { computedLink: l, computedLinkProps: t } = Ct(e, [
      "active",
      "activeClass",
      "append",
      "disabled",
      "href",
      "rel",
      "replace",
      "routerComponentName",
      "target",
      "to",
      "variant",
      "opacity",
      "opacityHover",
      "underlineVariant",
      "underlineOffset",
      "underlineOffsetHover",
      "underlineOpacity",
      "underlineOpacityHover",
      "icon"
    ]), s = k(() => l.value ? st : e.tag);
    return (r, u) => (m(), P(ce(s.value), K({ class: "navbar-brand" }, n(t)), {
      default: I(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Sd = /* @__PURE__ */ L({
  __name: "BNavbarNav",
  props: {
    align: { default: void 0 },
    fill: { type: Boolean, default: !1 },
    justified: { type: Boolean, default: !1 },
    small: { type: Boolean, default: !1 },
    tag: { default: "ul" }
  },
  setup(a) {
    const e = M(a, "BNavbarNav"), l = Gt(() => e.align), t = _(() => ({
      "nav-fill": e.fill,
      "nav-justified": e.justified,
      [l.value]: e.align !== void 0,
      small: e.small
    }));
    return (s, r) => (m(), A("ul", {
      class: R(["navbar-nav", t.value])
    }, [
      $(s.$slots, "default")
    ], 2));
  }
}), Fl = (a, o) => a.setAttribute("data-bs-theme", o), Vd = {
  mounted(a, o) {
    Fl(a, o.value);
  },
  updated(a, o) {
    Fl(a, o.value);
  }
}, Ad = (a, o) => {
  const { modifiers: e, arg: l, value: t } = a, s = Object.keys(e || {}), r = typeof t == "string" ? t.split(ea) : t;
  if (o.tagName.toLowerCase() === "a") {
    const u = o.getAttribute("href") || "";
    xr.test(u) && s.push(u.replace($r, ""));
  }
  return Array.prototype.concat.apply([], [l, r]).forEach((u) => typeof u == "string" && s.push(u)), s.filter((u, i, d) => u && d.indexOf(u) === i);
}, Od = (a, o) => {
  a.forEach((e) => {
    const l = document.getElementById(e);
    l !== null && l.dispatchEvent(new Event("bv-toggle"));
  }), setTimeout(() => wn(a, o), 50);
}, wn = (a, o) => {
  let e = !1;
  a.forEach((l) => {
    const t = document.getElementById(l);
    t != null && t.classList.contains("show") && (e = !0), t != null && t.classList.contains("closing") && (e = !1);
  }), o.setAttribute("aria-expanded", e ? "true" : "false"), o.classList.remove(e ? "collapsed" : "not-collapsed"), o.classList.add(e ? "not-collapsed" : "collapsed");
}, Ll = (a, o) => {
  const e = Ad(o, a);
  e.length !== 0 && (a.__toggle && a.removeEventListener("click", a.__toggle), a.__toggle = () => Od(e, a), a.addEventListener("click", a.__toggle), a.setAttribute("aria-controls", e.join(" ")), wn(e, a));
}, La = {
  mounted: Ll,
  updated: Ll,
  unmounted(a) {
    a.removeEventListener("click", a.__toggle), a.removeAttribute("aria-controls"), a.removeAttribute("aria-expanded");
  }
}, Id = {
  mounted(a, o) {
    if (!Rt(o.value))
      return;
    const l = da(o.value, a);
    !l.content && !l.title || fa(a, o, {
      ...ca(o, a),
      ...l
    });
  },
  updated(a, o) {
    if (!Rt(o.value))
      return;
    const l = da(o.value, a);
    !l.content && !l.title || (pa(a), fa(a, o, {
      ...ca(o, a),
      ...l
    }));
  },
  beforeUnmount(a) {
    pa(a);
  }
}, zl = (a, o) => {
  a.$__scrollspy && a.$__scrollspy.cleanup();
  const { arg: e, value: l } = o, t = typeof l == "object" && l !== null, s = e || (typeof l == "string" ? l : t ? l.content || l.element : null);
  a.$__scrollspy = Zo(s, a, t ? ha(l, ["content", "element"]) : {});
}, Pd = {
  mounted: zl,
  updated: zl,
  beforeUnmount(a) {
    a.$__scrollspy && a.$__scrollspy.cleanup();
  }
}, Nd = {
  mounted(a, o) {
    const e = Rt(o.value);
    if (!e)
      return;
    const l = da(o.value, a);
    !l.content && !l.title || fa(a, o, {
      noninteractive: !0,
      ...ca(o, a),
      title: l.title ?? l.content ?? "",
      tooltip: e
    });
  },
  updated(a, o) {
    const e = Rt(o.value);
    if (!e)
      return;
    const l = da(o.value, a);
    !l.content && !l.title || (pa(a), fa(a, o, {
      noninteractive: !0,
      ...ca(o, a),
      title: l.title ?? l.content ?? "",
      tooltip: e
    }));
  },
  beforeUnmount(a) {
    pa(a);
  }
}, za = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vBColorMode: Vd,
  vBModal: La,
  vBPopover: Id,
  vBScrollspy: Pd,
  vBToggle: La,
  vBTooltip: Nd
}, Symbol.toStringTag, { value: "Module" })), Ed = ["disabled", "aria-label"], Fd = /* @__PURE__ */ Q("span", { class: "navbar-toggler-icon" }, null, -1), Ld = /* @__PURE__ */ L({
  __name: "BNavbarToggle",
  props: {
    disabled: { type: Boolean, default: !1 },
    label: { default: "Toggle navigation" },
    target: { default: void 0 }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const l = M(a, "BNavbarToggle"), t = o, s = _(() => ({
      disabled: l.disabled
    })), r = (u) => {
      l.disabled || t("click", u);
    };
    return (u, i) => ct((m(), A("button", {
      class: R(["navbar-toggler", s.value]),
      type: "button",
      disabled: n(l).disabled,
      "aria-label": n(l).label,
      onClick: r
    }, [
      $(u.$slots, "default", {}, () => [
        Fd
      ])
    ], 10, Ed)), [
      [n(La), n(l).disabled ? void 0 : n(l).target]
    ]);
  }
}), zd = ["id", "aria-labelledby"], Hd = ["id"], Md = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BOffcanvas",
  props: /* @__PURE__ */ ge({
    backdrop: { type: Boolean, default: !0 },
    backdropBlur: { default: void 0 },
    backdropVariant: { default: "dark" },
    bodyAttrs: { default: void 0 },
    bodyClass: { default: void 0 },
    bodyScrolling: { type: Boolean, default: !1 },
    footerClass: { default: void 0 },
    headerClass: { default: void 0 },
    headerCloseClass: { default: void 0 },
    headerCloseLabel: { default: "Close" },
    headerCloseVariant: { default: "secondary" },
    id: { default: void 0 },
    lazy: { type: Boolean, default: !1 },
    modelValue: { type: Boolean },
    noCloseOnBackdrop: { type: Boolean, default: !1 },
    noCloseOnEsc: { type: Boolean, default: !1 },
    noFocus: { type: Boolean, default: !1 },
    noHeader: { type: Boolean, default: !1 },
    noHeaderClose: { type: Boolean, default: !1 },
    placement: { default: "start" },
    shadow: { type: [String, Boolean], default: !1 },
    title: { default: void 0 },
    width: { default: void 0 },
    teleportDisabled: { default: !1 },
    teleportTo: { default: "body" }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["close", "esc", "hidden", "hide", "hide-prevented", "show", "show-prevented", "shown"], ["update:modelValue"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BOffcanvas"), s = e, r = He(), u = _e(a, "modelValue"), i = we(() => t.id, "offcanvas");
    Yo(u, () => t.bodyScrolling);
    const d = z(null);
    De(
      "Escape",
      () => {
        V("esc");
      },
      { target: d }
    );
    const { focused: f } = Fe(d, {
      initialValue: u.value && t.noFocus === !1
    }), c = z(u.value), y = z(!1), p = k(() => t.backdrop === !0 && u.value === !0), b = k(
      () => t.lazy === !1 || t.lazy === !0 && y.value === !0 || t.lazy === !0 && u.value === !0
    ), h = k(() => !Ae(r["header-close"])), w = _(() => [
      { "text-reset": !h.value },
      t.headerCloseClass
    ]), v = _(() => ({
      variant: h.value ? t.headerCloseVariant : void 0,
      class: w.value
    })), B = k(() => !Ae(r.footer)), g = _(() => [
      // props.responsive === undefined ? 'offcanvas' : `offcanvas-${props.responsive}`,
      "offcanvas",
      // Remove when above check is fixed
      `offcanvas-${t.placement}`,
      {
        show: u.value && c.value === !0,
        [`shadow-${t.shadow}`]: !!t.shadow
      }
    ]), S = _(() => ({
      width: t.width
    })), C = _(() => ({
      visible: u.value,
      placement: t.placement,
      hide: V
    })), x = (X, j = {}) => new wt(X, {
      cancelable: !1,
      target: d.value || null,
      relatedTarget: null,
      trigger: null,
      ...j,
      componentId: i.value
    }), V = (X = "") => {
      if (X === "backdrop" && t.noCloseOnBackdrop || X === "esc" && t.noCloseOnEsc) {
        s("hide-prevented");
        return;
      }
      const j = x("hide", { cancelable: X !== "", trigger: X });
      if (X === "close" && s(X, j), X === "esc" && s(X, j), s("hide", j), j.defaultPrevented) {
        s("hide-prevented");
        return;
      }
      u.value = !1;
    }, q = () => {
      const X = x("show", { cancelable: !0 });
      if (s("show", X), X.defaultPrevented) {
        u.value = !1, s("show-prevented");
        return;
      }
      u.value = !0;
    }, G = () => {
      Ne(() => {
        t.noFocus === !1 && (f.value = !0);
      });
    }, O = () => q(), Z = () => {
      c.value = !0, G(), s("shown", x("shown")), t.lazy === !0 && (y.value = !0);
    }, ae = () => {
      c.value = !1;
    }, ie = () => {
      s("hidden", x("hidden")), t.lazy === !0 && (y.value = !1);
    };
    return Te(d, "bv-toggle", () => {
      u.value ? V() : q();
    }), o({
      hide: V,
      show: q
    }), (X, j) => (m(), P(_t, {
      to: n(t).teleportTo,
      disabled: n(t).teleportDisabled
    }, [
      ye(Et, {
        "no-fade": !0,
        "trans-props": {
          enterToClass: "showing",
          enterFromClass: "",
          leaveToClass: "hiding show",
          leaveFromClass: "show"
        },
        onBeforeEnter: O,
        onAfterEnter: Z,
        onLeave: ae,
        onAfterLeave: ie
      }, {
        default: I(() => [
          ct(Q("div", K({
            id: n(i),
            ref_key: "element",
            ref: d,
            "aria-modal": "true",
            role: "dialog",
            class: g.value,
            style: S.value,
            tabindex: "-1",
            "aria-labelledby": `${n(i)}-offcanvas-label`,
            "data-bs-backdrop": "false"
          }, X.$attrs), [
            b.value ? (m(), A(ve, { key: 0 }, [
              n(t).noHeader ? ee("", !0) : (m(), A("div", {
                key: 0,
                class: R(["offcanvas-header", n(t).headerClass])
              }, [
                $(X.$slots, "header", Be(Ce(C.value)), () => [
                  Q("h5", {
                    id: `${n(i)}-offcanvas-label`,
                    class: "offcanvas-title"
                  }, [
                    $(X.$slots, "title", Be(Ce(C.value)), () => [
                      ue(J(n(t).title), 1)
                    ])
                  ], 8, Hd),
                  n(t).noHeaderClose ? ee("", !0) : (m(), A(ve, { key: 0 }, [
                    h.value ? (m(), P(mt, K({ key: 0 }, v.value, {
                      onClick: j[0] || (j[0] = (T) => V("close"))
                    }), {
                      default: I(() => [
                        $(X.$slots, "header-close")
                      ]),
                      _: 3
                    }, 16)) : (m(), P(Ft, K({
                      key: 1,
                      "aria-label": n(t).headerCloseLabel
                    }, v.value, {
                      onClick: j[1] || (j[1] = (T) => V("close"))
                    }), null, 16, ["aria-label"]))
                  ], 64))
                ])
              ], 2)),
              Q("div", K({
                class: ["offcanvas-body", n(t).bodyClass]
              }, n(t).bodyAttrs), [
                $(X.$slots, "default", Be(Ce(C.value)))
              ], 16),
              B.value ? (m(), A("div", {
                key: 1,
                class: R(n(t).footerClass)
              }, [
                $(X.$slots, "footer", Be(Ce(C.value)))
              ], 2)) : ee("", !0)
            ], 64)) : ee("", !0)
          ], 16, zd), [
            [jt, u.value]
          ])
        ]),
        _: 3
      }),
      $(X.$slots, "backdrop", {}, () => [
        ye(_a, {
          blur: n(t).backdropBlur,
          variant: n(t).backdropVariant,
          show: p.value,
          fixed: "",
          "no-wrap": "",
          "no-spinner": "",
          onClick: j[2] || (j[2] = (T) => V("backdrop"))
        }, null, 8, ["blur", "variant", "show"])
      ])
    ], 8, ["to", "disabled"]));
  }
}), Rd = ["aria-disabled", "aria-label"], Hl = 20, Ml = 0, Dd = /* @__PURE__ */ L({
  __name: "BPagination",
  props: /* @__PURE__ */ ge({
    align: { default: "start" },
    ariaControls: { default: void 0 },
    ariaLabel: { default: "Pagination" },
    disabled: { type: Boolean, default: !1 },
    ellipsisClass: { default: void 0 },
    ellipsisText: { default: "…" },
    firstClass: { default: void 0 },
    firstNumber: { type: Boolean, default: !1 },
    firstText: { default: "«" },
    hideEllipsis: { type: Boolean, default: !1 },
    hideGotoEndButtons: { type: Boolean, default: !1 },
    labelFirstPage: { default: "Go to first page" },
    labelLastPage: { default: "Go to last page" },
    labelNextPage: { default: "Go to next page" },
    labelPage: { default: "Go to page" },
    labelPrevPage: { default: "Go to previous page" },
    lastClass: { default: void 0 },
    lastNumber: { type: Boolean, default: !1 },
    lastText: { default: "»" },
    limit: { default: 5 },
    modelValue: {},
    nextClass: { default: void 0 },
    nextText: { default: "›" },
    pageClass: { default: void 0 },
    perPage: { default: Hl },
    pills: { type: Boolean, default: !1 },
    prevClass: { default: void 0 },
    prevText: { default: "‹" },
    size: { default: void 0 },
    totalRows: { default: Ml }
  }, {
    modelValue: { default: 1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["page-click"], ["update:modelValue"]),
  setup(a, { emit: o }) {
    const d = M(a, "BPagination"), f = o, c = _e(a, "modelValue"), y = he(() => d.limit, { nanToZero: !0, method: "parseInt" }), p = he(() => d.perPage, { nanToZero: !0, method: "parseInt" }), b = he(() => d.totalRows, { nanToZero: !0, method: "parseInt" }), h = he(c, { nanToZero: !0, method: "parseInt" }), w = k(() => Math.max(p.value || Hl, 1)), v = k(() => Math.max(b.value || Ml, 0)), B = k(() => Math.ceil(v.value / w.value)), g = k(() => d.align === "fill"), S = k(() => d.align === "fill" ? "start" : d.align), C = Gt(S), x = (Y) => Y === h.value, V = (Y) => d.disabled ? null : x(Y) ? "0" : "-1", q = (Y) => d.disabled || x(Y) || h.value < 1 || // Check if the number is out of bounds
    Y < 1 || Y > B.value, G = _(() => q(1)), O = _(() => q(h.value - 1)), Z = _(() => q(B.value)), ae = _(() => q(h.value + 1)), ie = ({
      page: Y,
      classVal: de,
      dis: oe,
      slotName: le,
      textValue: H,
      tabIndex: se,
      label: be,
      position: me,
      isActive: Oe,
      role: $e,
      hidden: xe
    }) => ({
      li: {
        class: [
          "page-item",
          {
            active: Oe,
            disabled: oe,
            "flex-fill": g.value,
            "d-flex": g.value && !oe
          },
          de
        ],
        role: $e,
        "aria-hidden": xe
      },
      button: {
        is: oe ? "span" : "button",
        class: ["page-link", { "flex-grow-1": !oe && g.value }],
        "aria-label": be,
        "aria-controls": d.ariaControls || void 0,
        "aria-disabled": oe ? !0 : void 0,
        "aria-posinset": me,
        "aria-setsize": me ? B.value : void 0,
        role: "menuitem",
        type: oe ? void 0 : "button",
        tabindex: oe ? void 0 : se
      },
      text: {
        name: le,
        active: Oe,
        value: H ?? Y,
        page: Y,
        disabled: oe,
        index: Y - 1,
        content: H ? void 0 : Y
      },
      clickHandler: (et) => ne(et, Y)
    }), X = ({
      page: Y,
      classVal: de,
      dis: oe,
      slotName: le,
      textValue: H,
      label: se
    }) => ie({ page: Y, classVal: de, dis: oe, slotName: le, textValue: H, label: se, tabIndex: "-1" }), j = (Y) => ie({
      page: Y,
      dis: d.disabled,
      classVal: d.pageClass,
      slotName: "page",
      label: d.labelPage ? `${d.labelPage} ${Y}` : void 0,
      tabIndex: V(Y) ?? void 0,
      position: Y,
      isActive: x(Y)
    }), T = _(
      () => X({
        page: 1,
        dis: G.value,
        classVal: d.firstClass,
        slotName: "first-text",
        textValue: d.firstText,
        label: d.labelFirstPage
      })
    ), N = _(
      () => X({
        page: Math.max(h.value - 1, 1),
        dis: O.value,
        classVal: d.prevClass,
        slotName: "prev-text",
        textValue: d.prevText,
        label: d.labelPrevPage
      })
    ), F = _(
      () => X({
        page: Math.min(h.value + 1, B.value),
        dis: ae.value,
        classVal: d.nextClass,
        slotName: "next-text",
        textValue: d.nextText,
        label: d.labelNextPage
      })
    ), W = _(
      () => X({
        page: B.value,
        dis: Z.value,
        classVal: d.lastClass,
        slotName: "last-text",
        textValue: d.lastText,
        label: d.labelLastPage
      })
    ), E = ua(), D = ua(), te = _(() => ({
      li: {
        class: [
          "page-item",
          "disabled",
          "bv-d-xs-down-none",
          g.value ? "flex-fill" : "",
          d.ellipsisClass
        ],
        role: "separator"
      },
      span: {
        class: ["page-link"]
      }
    })), re = _(() => [
      C.value,
      {
        [`pagination-${d.size}`]: d.size !== void 0,
        "b-pagination-pills": d.pills
      }
    ]), U = _(() => ({
      pageSize: w.value,
      totalRows: b.value,
      numberOfPages: B.value
    })), ne = (Y, de) => {
      if (de === h.value)
        return;
      const oe = new rt("page-click", {
        cancelable: !0,
        target: Y.target
      });
      f("page-click", oe, de), !oe.defaultPrevented && (c.value = de);
    };
    fe(h, (Y) => {
      const oe = ((le, H) => {
        const se = le || 1;
        return se > H ? H : se < 1 ? 1 : se;
      })(Y, B.value);
      oe !== c.value && (c.value = oe);
    }), fe(U, (Y, de) => {
      (de.pageSize !== Y.pageSize && de.totalRows === Y.totalRows || de.numberOfPages !== Y.numberOfPages && h.value > de.numberOfPages) && (c.value = 1);
    });
    const pe = _(() => {
      const Y = B.value, { value: de } = h, oe = y.value, le = d.firstNumber ? 1 : 0, H = d.lastNumber ? 1 : 0, se = d.hideEllipsis || oe <= 3, be = d.hideGotoEndButtons ? 1 : 0;
      if (Y < oe + le + H)
        return [
          !le && !be ? -1 : null,
          -2,
          ...Array.from({ length: Y }, ($e, xe) => xe + 1),
          -3,
          !H && !be ? -4 : null
        ].filter(($e) => $e !== null);
      const me = Array.from({ length: oe + 4 - be * 2 });
      be ? (me[0] = -2, me[me.length - 1] = -3) : (le ? (me[0] = -2, me[1] = 1) : (me[0] = -1, me[1] = -2), H ? (me[me.length - 1] = -3, me[me.length - 2] = Y) : (me[me.length - 1] = -4, me[me.length - 2] = -3));
      const Oe = Math.floor(oe / 2);
      if (de <= Oe + le) {
        for (let $e = 1; $e <= oe; $e++)
          me[$e + 1 - be] = $e + le;
        se || (me[me.length - 3] = -5);
      }
      if (de > Y - Oe - H) {
        const $e = Y - (oe - 1) - H;
        for (let xe = 0; xe < oe; xe++)
          me[xe + 2 - be] = $e + xe;
        se || (me[2] = -5);
      }
      if (!me[2]) {
        const $e = de - Math.floor(oe / 2);
        for (let xe = 0; xe < oe; xe++)
          me[xe + 2 - be] = $e + xe;
        se || (me[2] = -5, me[me.length - 3] = -5);
      }
      return me;
    });
    return (Y, de) => (m(), A("ul", {
      class: R(["pagination", re.value]),
      role: "menubar",
      "aria-disabled": n(d).disabled,
      "aria-label": n(d).ariaLabel || void 0
    }, [
      ye(n(E).define, null, {
        default: I(({ button: oe, li: le, text: H, clickHandler: se }) => [
          Q("li", Be(Ce(le)), [
            (m(), P(ce(oe.is), K(oe, { onClick: se }), {
              default: I(() => [
                $(Y.$slots, H.name, {
                  disabled: H.disabled,
                  page: H.page,
                  index: H.index,
                  active: H.active,
                  content: H.value
                }, () => [
                  ue(J(H.value), 1)
                ])
              ]),
              _: 2
            }, 1040, ["onClick"]))
          ], 16)
        ]),
        _: 3
      }),
      ye(n(D).define, null, {
        default: I(() => [
          Q("li", Be(Ce(te.value.li)), [
            Q("span", Be(Ce(te.value.span)), [
              $(Y.$slots, "ellipsis-text", {}, () => [
                ue(J(n(d).ellipsisText || "..."), 1)
              ])
            ], 16)
          ], 16)
        ]),
        _: 3
      }),
      (m(!0), A(ve, null, ke(pe.value, (oe) => (m(), A(ve, {
        key: `page-${oe}`
      }, [
        oe === -1 ? (m(), P(n(E).reuse, K({
          key: 0,
          ref_for: !0
        }, T.value), null, 16)) : oe === -2 ? (m(), P(n(E).reuse, K({
          key: 1,
          ref_for: !0
        }, N.value), null, 16)) : oe === -3 ? (m(), P(n(E).reuse, K({
          key: 2,
          ref_for: !0
        }, F.value), null, 16)) : oe === -4 ? (m(), P(n(E).reuse, K({
          key: 3,
          ref_for: !0
        }, W.value), null, 16)) : oe === -5 ? (m(), P(n(D).reuse, { key: 4 })) : oe !== null ? (m(), P(n(E).reuse, K({
          key: 5,
          ref_for: !0
        }, j(oe)), null, 16)) : ee("", !0)
      ], 64))), 128))
    ], 10, Rd));
  }
}), Ke = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BPlaceholder",
  props: {
    animation: { default: void 0 },
    cols: { default: 12 },
    size: { default: "md" },
    tag: { default: "span" },
    variant: { default: null },
    width: { default: void 0 },
    wrapperTag: { default: "span" }
  },
  setup(a) {
    const e = M(a, "BPlaceholder"), l = k(
      () => e.width === void 0 ? void 0 : typeof e.width == "number" ? e.width.toString() : e.width.replace("%", "")
    ), t = k(
      () => e.cols === void 0 ? void 0 : typeof e.cols == "number" ? e.cols.toString() : e.cols
    ), s = _(() => ({
      [`col-${t.value}`]: t.value !== void 0 && l.value === void 0,
      [`bg-${e.variant}`]: e.variant !== null,
      [`placeholder-${e.size}`]: e.size !== "md"
    })), r = _(() => ({
      [`placeholder-${e.animation}`]: e.animation !== void 0
    })), u = _(() => ({
      width: l.value === void 0 ? void 0 : `${l.value}%`
    }));
    return (i, d) => (m(), P(ce(n(e).wrapperTag), {
      class: R(r.value)
    }, {
      default: I(() => [
        (m(), P(ce(i.tag), K(i.$attrs, {
          class: ["placeholder", s.value],
          style: u.value
        }), null, 16, ["class", "style"]))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Cn = /* @__PURE__ */ L({
  __name: "BPlaceholderButton",
  props: {
    animation: { default: void 0 },
    cols: { default: void 0 },
    tag: { default: "div" },
    variant: { default: "primary" },
    width: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BPlaceholderButton"), l = _(() => ({
      [`btn-${e.variant}`]: e.variant !== null
    }));
    return (t, s) => (m(), P(Ke, {
      class: R(["btn disabled", l.value]),
      animation: n(e).animation,
      width: n(e).width,
      cols: n(e).cols,
      tag: n(e).tag,
      style: { cursor: "wait", "pointer-events": "auto" }
    }, null, 8, ["class", "animation", "width", "cols", "tag"]));
  }
}), jd = /* @__PURE__ */ L({
  __name: "BPlaceholderCard",
  props: {
    animation: { default: void 0 },
    footerAnimation: { default: void 0 },
    footerSize: { default: "md" },
    footerVariant: { default: void 0 },
    footerWidth: { default: 100 },
    headerAnimation: { default: void 0 },
    headerSize: { default: "md" },
    headerVariant: { default: void 0 },
    headerWidth: { default: 100 },
    imgBlankColor: { default: "#868e96" },
    imgPlacement: { default: "top" },
    imgHeight: { default: 100 },
    imgSrc: { default: void 0 },
    noButton: { type: Boolean, default: !1 },
    noFooter: { type: Boolean, default: !1 },
    noHeader: { type: Boolean, default: !1 },
    noImg: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BPlaceholderCard"), l = _(() => ({
      animation: e.animation,
      size: e.size,
      variant: e.variant
    })), t = k(() => e.noButton ? Ke : Cn);
    return (s, r) => (m(), P(pn, {
      "img-placement": n(e).imgPlacement
    }, Da({
      default: I(() => [
        $(s.$slots, "default", {}, () => [
          ye(Ke, K({ cols: "7" }, l.value), null, 16),
          ye(Ke, K({ cols: "4" }, l.value), null, 16),
          ye(Ke, K({ cols: "4" }, l.value), null, 16),
          ye(Ke, K({ cols: "6" }, l.value), null, 16),
          ye(Ke, K({ cols: "8" }, l.value), null, 16)
        ])
      ]),
      _: 2
    }, [
      n(e).noImg ? void 0 : {
        name: "img",
        fn: I(() => [
          $(s.$slots, "img", {}, () => [
            ye(rl, {
              blank: !n(e).imgSrc,
              "blank-color": n(e).imgBlankColor,
              height: n(e).imgSrc ? void 0 : n(e).imgHeight,
              src: n(e).imgSrc,
              "img-placement": n(e).imgPlacement,
              style: { cursor: "wait" }
            }, null, 8, ["blank", "blank-color", "height", "src", "img-placement"])
          ])
        ]),
        key: "0"
      },
      n(e).noHeader ? void 0 : {
        name: "header",
        fn: I(() => [
          $(s.$slots, "header", {}, () => [
            ye(Ke, {
              width: n(e).headerWidth,
              variant: n(e).headerVariant,
              animation: n(e).headerAnimation,
              size: n(e).headerSize
            }, null, 8, ["width", "variant", "animation", "size"])
          ])
        ]),
        key: "1"
      },
      n(e).noFooter ? void 0 : {
        name: "footer",
        fn: I(() => [
          $(s.$slots, "footer", {}, () => [
            (m(), P(ce(t.value), {
              width: n(e).footerWidth,
              animation: n(e).footerAnimation,
              size: n(e).noButton ? n(e).footerSize : void 0,
              variant: n(e).footerVariant
            }, null, 8, ["width", "animation", "size", "variant"]))
          ])
        ]),
        key: "2"
      }
    ]), 1032, ["img-placement"]));
  }
}), Gd = "300px", dl = /* @__PURE__ */ L({
  __name: "BTableSimple",
  props: {
    bordered: { type: Boolean, default: !1 },
    borderless: { type: Boolean, default: !1 },
    borderVariant: { default: null },
    captionTop: { type: Boolean, default: !1 },
    dark: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    hover: { type: Boolean, default: !1 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: !1 },
    outlined: { type: Boolean, default: !1 },
    responsive: { type: [Boolean, String], default: !1 },
    small: { type: Boolean, default: !1 },
    stacked: { type: [Boolean, String], default: !1 },
    stickyHeader: { type: [Boolean, String, Number], default: !1 },
    striped: { type: Boolean, default: !1 },
    stripedColumns: { type: Boolean, default: !1 },
    variant: { default: null },
    tableAttrs: { default: void 0 },
    tableClass: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BTableSimple"), l = _(() => [
      e.tableClass,
      "table",
      "b-table",
      {
        "table-bordered": e.bordered,
        "table-borderless": e.borderless,
        [`border-${e.borderVariant}`]: e.borderVariant !== null,
        "caption-top": e.captionTop,
        "table-dark": e.dark,
        "table-hover": e.hover,
        "b-table-stacked": e.stacked === !0,
        [`b-table-stacked-${e.stacked}`]: typeof e.stacked == "string",
        "table-striped": e.striped,
        "table-sm": e.small,
        [`table-${e.variant}`]: e.variant !== null,
        "table-striped-columns": e.stripedColumns
      }
    ]), t = _(() => ({
      id: e.id,
      class: l.value,
      ...e.tableAttrs
    })), s = ma(
      _(
        () => (e.stickyHeader === !0 ? Gd : e.stickyHeader) || NaN
      )
    ), r = _(() => e.stickyHeader !== !1), u = _(() => e.responsive !== !1 || r.value), i = _(
      () => r.value ? { maxHeight: s.value } : void 0
    ), d = _(() => ({
      "table-responsive": e.responsive === !0,
      [`table-responsive-${e.responsive}`]: typeof e.responsive == "string",
      "b-table-sticky-header": r.value
    }));
    return (f, c) => u.value ? (m(), A("div", {
      key: 0,
      class: R(d.value),
      style: Le(i.value)
    }, [
      Q("table", Be(Ce(t.value)), [
        $(f.$slots, "default")
      ], 16)
    ], 6)) : (m(), A("table", Be(K({ key: 1 }, t.value)), [
      $(f.$slots, "default")
    ], 16));
  }
}), Wd = /* @__PURE__ */ L({
  __name: "BPlaceholderTable",
  props: {
    animation: { default: void 0 },
    cellWidth: { default: 100 },
    columns: { default: 5 },
    footerAnimation: { default: void 0 },
    footerCellWidth: { default: 100 },
    footerColumns: { default: void 0 },
    footerSize: { default: "md" },
    footerVariant: { default: void 0 },
    headerAnimation: { default: void 0 },
    headerCellWidth: { default: 100 },
    headerColumns: { default: void 0 },
    headerSize: { default: "md" },
    headerVariant: { default: void 0 },
    hideHeader: { type: Boolean, default: !1 },
    rows: { default: 3 },
    showFooter: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BPlaceholderTable"), l = he(() => e.columns), t = he(() => e.rows), s = k(() => e.headerColumns ?? NaN), r = k(() => e.footerColumns ?? NaN), u = he(s), i = he(r), d = k(() => l.value || 5), f = k(() => t.value || 3), c = k(
      () => e.headerColumns === void 0 ? d.value : u.value
    ), y = k(
      () => e.footerColumns === void 0 ? d.value : i.value
    );
    return (p, b) => (m(), P(dl, null, {
      default: I(() => [
        n(e).hideHeader ? ee("", !0) : $(p.$slots, "thead", { key: 0 }, () => [
          Q("thead", null, [
            Q("tr", null, [
              (m(!0), A(ve, null, ke(c.value, (h, w) => (m(), A("th", { key: w }, [
                ye(Ke, {
                  size: n(e).headerSize,
                  variant: n(e).headerVariant,
                  animation: n(e).headerAnimation,
                  width: n(e).headerCellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ])
          ])
        ]),
        $(p.$slots, "default", {}, () => [
          Q("tbody", null, [
            (m(!0), A(ve, null, ke(f.value, (h, w) => (m(), A("tr", { key: w }, [
              (m(!0), A(ve, null, ke(d.value, (v, B) => (m(), A("td", { key: B }, [
                ye(Ke, {
                  size: n(e).size,
                  variant: n(e).variant,
                  animation: n(e).animation,
                  width: n(e).cellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ]))), 128))
          ])
        ]),
        n(e).showFooter ? $(p.$slots, "tfoot", { key: 1 }, () => [
          Q("tfoot", null, [
            Q("tr", null, [
              (m(!0), A(ve, null, ke(y.value, (h, w) => (m(), A("th", { key: w }, [
                ye(Ke, {
                  size: n(e).footerSize,
                  variant: n(e).footerVariant,
                  animation: n(e).footerAnimation,
                  width: n(e).footerCellWidth
                }, null, 8, ["size", "variant", "animation", "width"])
              ]))), 128))
            ])
          ])
        ]) : ee("", !0)
      ]),
      _: 3
    }));
  }
}), qd = /* @__PURE__ */ L({
  __name: "BPlaceholderWrapper",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = M(a, "BPlaceholderWrapper");
    return (l, t) => n(e).loading ? $(l.$slots, "loading", { key: 0 }) : $(l.$slots, "default", { key: 1 });
  }
}), Ud = /* @__PURE__ */ L({
  __name: "BRow",
  props: {
    tag: { default: "div" },
    gutterX: { default: void 0 },
    gutterY: { default: void 0 },
    noGutters: { type: Boolean, default: !1 },
    alignV: { default: void 0 },
    alignH: { default: void 0 },
    alignContent: { default: void 0 },
    cols: { default: void 0 },
    colsSm: { default: void 0 },
    colsMd: { default: void 0 },
    colsLg: { default: void 0 },
    colsXl: { default: void 0 },
    colsXxl: { default: void 0 }
  },
  setup(a) {
    const e = M(a, "BRow"), l = Gt(() => e.alignH), t = _(
      () => Qt(
        {
          cols: e.cols,
          colsLg: e.colsLg,
          colsMd: e.colsMd,
          colsSm: e.colsSm,
          colsXl: e.colsXl,
          colsXxl: e.colsXxl
        },
        ["cols", "colsLg", "colsMd", "colsSm", "colsXl", "colsXxl"],
        "cols",
        "row-cols"
      )
    ), s = _(() => [
      t.value,
      {
        [`gx-${e.gutterX}`]: e.gutterX !== void 0,
        [`gy-${e.gutterY}`]: e.gutterY !== void 0,
        "g-0": e.noGutters,
        [`align-items-${e.alignV}`]: e.alignV !== void 0,
        [l.value]: e.alignH !== void 0,
        [`align-content-${e.alignContent}`]: e.alignContent !== void 0
      }
    ]);
    return (r, u) => (m(), P(ce(n(e).tag), {
      class: R(["row", s.value])
    }, {
      default: I(() => [
        $(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), tt = (a) => typeof a == "object" && a !== null, Ht = (a) => typeof a == "object" && a !== null && "key" in a, kn = /* @__PURE__ */ L({
  __name: "BTbody",
  props: {
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BTbody"), l = _(() => ({
      [`thead-${e.variant}`]: e.variant !== null
    }));
    return (t, s) => (m(), A("tbody", {
      class: R(l.value)
    }, [
      $(t.$slots, "default")
    ], 2));
  }
}), Xd = ["scope", "colspan", "rowspan", "data-label"], Kd = { key: 0 }, St = /* @__PURE__ */ L({
  __name: "BTd",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: Boolean, default: !1 },
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BTd"), l = _(() => ({
      [`table-${e.variant}`]: e.variant !== null,
      "b-table-sticky-column": e.stickyColumn,
      "table-b-table-default": e.stickyColumn && e.variant === null
    })), t = k(() => e.colspan ? "colspan" : e.rowspan ? "rowspan" : "col");
    return (s, r) => (m(), A("td", {
      scope: t.value,
      class: R(l.value),
      colspan: n(e).colspan,
      rowspan: n(e).rowspan,
      "data-label": n(e).stackedHeading
    }, [
      n(e).stackedHeading ? (m(), A("div", Kd, [
        $(s.$slots, "default")
      ])) : $(s.$slots, "default", { key: 1 })
    ], 10, Xd));
  }
}), Ha = /* @__PURE__ */ L({
  __name: "BTfoot",
  props: {
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BTfoot"), l = _(() => ({
      [`table-${e.variant}`]: e.variant !== null
    }));
    return (t, s) => (m(), A("tfoot", {
      class: R(l.value)
    }, [
      $(t.$slots, "default")
    ], 2));
  }
}), Yd = ["scope", "colspan", "rowspan", "data-label"], Zd = { key: 0 }, Ma = /* @__PURE__ */ L({
  __name: "BTh",
  props: {
    colspan: { default: void 0 },
    rowspan: { default: void 0 },
    stackedHeading: { default: void 0 },
    stickyColumn: { type: Boolean, default: !1 },
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BTh"), l = _(() => ({
      [`table-${e.variant}`]: e.variant !== null,
      "b-table-sticky-column": e.stickyColumn,
      "table-b-table-default": e.stickyColumn && e.variant === null
    })), t = k(() => e.colspan ? "colspan" : e.rowspan ? "rowspan" : "col");
    return (s, r) => (m(), A("th", {
      scope: t.value,
      class: R(l.value),
      colspan: n(e).colspan,
      rowspan: n(e).rowspan,
      "data-label": n(e).stackedHeading
    }, [
      n(e).stackedHeading !== void 0 ? (m(), A("div", Zd, [
        $(s.$slots, "default")
      ])) : $(s.$slots, "default", { key: 1 })
    ], 10, Yd));
  }
}), Tn = /* @__PURE__ */ L({
  __name: "BThead",
  props: {
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BThead"), l = _(() => ({
      [`table-${e.variant}`]: e.variant !== null
    }));
    return (t, s) => (m(), A("thead", {
      class: R(l.value)
    }, [
      $(t.$slots, "default")
    ], 2));
  }
}), at = /* @__PURE__ */ L({
  __name: "BTr",
  props: {
    variant: { default: null }
  },
  setup(a) {
    const e = M(a, "BTr"), l = _(() => ({
      [`table-${e.variant}`]: e.variant !== null
    }));
    return (t, s) => (m(), A("tr", {
      class: R(l.value)
    }, [
      $(t.$slots, "default")
    ], 2));
  }
}), Jd = {
  key: 0,
  class: "b-table-stacked-label"
}, Qd = { class: "d-inline-flex flex-nowrap align-items-center gap-1" }, ec = { key: 2 }, $n = /* @__PURE__ */ L({
  __name: "BTableLite",
  props: {
    align: { default: void 0 },
    caption: { default: void 0 },
    captionHtml: { default: void 0 },
    detailsTdClass: { default: void 0 },
    emptyFilteredText: { default: "There are no records matching your request" },
    emptyText: { default: "There are no records to show" },
    fieldColumnClass: { type: [Function, String, Object, Array], default: void 0 },
    fields: { default: () => [] },
    footClone: { type: Boolean, default: !1 },
    footRowVariant: { default: void 0 },
    footVariant: { default: void 0 },
    headRowVariant: { default: void 0 },
    headVariant: { default: void 0 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    primaryKey: { default: void 0 },
    showEmpty: { type: Boolean, default: !1 },
    tbodyClass: { default: void 0 },
    tbodyTrAttrs: {},
    tbodyTrClass: { type: [Function, String, Object, Array], default: void 0 },
    tfootClass: { default: void 0 },
    tfootTrClass: { default: void 0 },
    theadClass: { default: void 0 },
    theadTrClass: { default: void 0 },
    bordered: { type: Boolean, default: void 0 },
    borderless: { type: Boolean, default: void 0 },
    borderVariant: { default: void 0 },
    captionTop: { type: Boolean, default: void 0 },
    dark: { type: Boolean, default: void 0 },
    fixed: { type: Boolean, default: void 0 },
    hover: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: void 0 },
    outlined: { type: Boolean, default: void 0 },
    responsive: { type: [Boolean, String], default: void 0 },
    small: { type: Boolean, default: void 0 },
    stacked: { type: [Boolean, String], default: void 0 },
    stickyHeader: { type: [Boolean, String, Number], default: void 0 },
    striped: { type: Boolean, default: void 0 },
    stripedColumns: { type: Boolean, default: void 0 },
    variant: { default: void 0 },
    tableAttrs: {},
    tableClass: { default: void 0 }
  },
  emits: ["head-clicked", "row-clicked", "row-dbl-clicked", "row-hovered", "row-unhovered"],
  setup(a, { emit: o }) {
    const l = M(a, "BTableLite"), t = o, s = (v) => [
      v,
      v._showDetails
    ], r = z(
      new WeakMap(
        l.items.reduce(
          (v, B) => (tt(B) && v.push(s(B)), v),
          []
        )
      )
    );
    fe(
      () => l.items,
      (v) => {
        v.forEach((B) => {
          if (!tt(B))
            return;
          const g = s(B);
          r.value.set(g[0], g[1]);
        });
      },
      { deep: !0 }
    );
    const u = _(() => [
      l.tableClass,
      {
        [`align-${l.align}`]: l.align !== void 0
      }
    ]), i = _(() => {
      if (!l.fields.length && l.items.length) {
        const [v] = l.items;
        return tt(v) || Array.isArray(v) ? Object.keys(v).map((B) => {
          const g = Ca(B);
          return {
            key: B,
            label: g,
            tdAttr: l.stacked === !0 ? { "data-label": g } : void 0
          };
        }) : [{ key: "", _noHeader: !0 }];
      }
      return l.fields.map((v) => {
        if (Ht(v))
          return {
            ...v,
            tdAttr: l.stacked === !0 ? { "data-label": Ca(v.key), ...v.tdAttr } : v.tdAttr
          };
        const B = Ca(v);
        return {
          key: v,
          label: B,
          tdAttr: l.stacked === !0 ? { "data-label": B } : void 0
        };
      });
    }), d = k(() => i.value.length), f = _(() => !(i.value.length > 0 && i.value.every((v) => v._noHeader === !0))), c = (v, B, g) => {
      const S = Ee(v, B);
      return g && typeof g == "function" ? g(S, B, v) : g;
    }, y = (v, B, g = !1) => {
      t("head-clicked", v.key, v, B, g);
    }, p = (v) => {
      if (tt(v)) {
        const B = r.value.get(v);
        r.value.set(v, !B), v._showDetails = !B;
      }
    }, b = (v) => [
      v.class,
      v.thClass,
      {
        "b-table-sticky-column": v.stickyColumn
      },
      l.fieldColumnClass ? typeof l.fieldColumnClass == "function" ? l.fieldColumnClass(v) : l.fieldColumnClass : null
    ], h = (v, B) => {
      var g, S;
      return [
        v.class,
        v.tdClass,
        tt(B) && (g = B._cellVariants) != null && g[v.key] ? `table-${(S = B._cellVariants) == null ? void 0 : S[v.key]}` : null,
        {
          "b-table-sticky-column": v.stickyColumn
        }
      ];
    }, w = (v, B) => l.tbodyTrClass ? typeof l.tbodyTrClass == "function" ? l.tbodyTrClass(v, B) : l.tbodyTrClass : null;
    return (v, B) => (m(), P(dl, {
      id: n(l).id,
      bordered: n(l).bordered,
      borderless: n(l).borderless,
      "border-variant": n(l).borderVariant,
      "caption-top": n(l).captionTop,
      dark: n(l).dark,
      fixed: n(l).fixed,
      hover: n(l).hover,
      "no-border-collapse": n(l).noBorderCollapse,
      outlined: n(l).outlined,
      responsive: n(l).responsive,
      small: n(l).small,
      stacked: n(l).stacked,
      "sticky-header": n(l).stickyHeader,
      striped: n(l).striped,
      "table-class": u.value,
      variant: n(l).variant,
      "striped-columns": n(l).stripedColumns
    }, {
      default: I(() => [
        ct(ye(Tn, {
          variant: n(l).headVariant,
          class: R(n(l).theadClass)
        }, {
          default: I(() => [
            v.$slots["thead-top"] ? $(v.$slots, "thead-top", { key: 0 }) : ee("", !0),
            ye(at, {
              variant: n(l).headRowVariant,
              class: R(n(l).theadTrClass)
            }, {
              default: I(() => [
                (m(!0), A(ve, null, ke(i.value, (g) => (m(), P(Ma, K({
                  key: g.key,
                  scope: "col",
                  class: b(g),
                  title: g.headerTitle,
                  variant: g.variant,
                  abbr: g.headerAbbr,
                  style: g.thStyle,
                  ref_for: !0
                }, g.thAttr, {
                  onClick: (S) => y(g, S)
                }), {
                  default: I(() => [
                    $(v.$slots, v.$slots[`head(${String(g.key)})`] ? `head(${String(g.key)})` : "head()", {
                      label: g.label,
                      column: g.key,
                      field: g,
                      isFoot: !1
                    }, () => [
                      ue(J(n(ta)(g)), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["class", "title", "variant", "abbr", "style", "onClick"]))), 128))
              ]),
              _: 3
            }, 8, ["variant", "class"]),
            v.$slots["thead-sub"] ? (m(), P(at, { key: 1 }, {
              default: I(() => [
                (m(!0), A(ve, null, ke(i.value, (g) => (m(), P(St, {
                  key: g.key,
                  scope: "col",
                  variant: g.variant,
                  class: R([g.class, g.thClass])
                }, {
                  default: I(() => [
                    $(v.$slots, "thead-sub", K({
                      items: i.value,
                      ref_for: !0
                    }, g), () => [
                      ue(J(g.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["variant", "class"]))), 128))
              ]),
              _: 3
            })) : ee("", !0)
          ]),
          _: 3
        }, 8, ["variant", "class"]), [
          [jt, f.value]
        ]),
        ye(kn, {
          class: R(n(l).tbodyClass)
        }, {
          default: I(() => [
            $(v.$slots, "custom-body", {
              fields: i.value,
              items: n(l).items,
              columns: i.value.length
            }, () => [
              !n(l).stacked && v.$slots["top-row"] ? (m(), P(at, { key: 0 }, {
                default: I(() => [
                  $(v.$slots, "top-row")
                ]),
                _: 3
              })) : ee("", !0),
              (m(!0), A(ve, null, ke(n(l).items, (g, S) => (m(), A(ve, { key: S }, [
                ye(at, {
                  class: R(w(g, "row")),
                  variant: n(tt)(g) ? g._rowVariant : void 0,
                  onClick: (C) => !n(Xt)(C) && t("row-clicked", g, S, C),
                  onDblclick: (C) => !n(Xt)(C) && t("row-dbl-clicked", g, S, C),
                  onMouseenter: (C) => !n(Xt)(C) && t("row-hovered", g, S, C),
                  onMouseleave: (C) => !n(Xt)(C) && t("row-unhovered", g, S, C)
                }, {
                  default: I(() => [
                    (m(!0), A(ve, null, ke(i.value, (C) => {
                      var x;
                      return m(), P(St, K({
                        key: C.key,
                        variant: n(tt)(g) && (x = g._cellVariants) != null && x[C.key] ? null : C.variant,
                        class: h(C, g),
                        ref_for: !0
                      }, c(g, String(C.key), C.tdAttr)), {
                        default: I(() => [
                          n(l).stacked && n(l).labelStacked ? (m(), A("label", Jd, J(n(ta)(C)), 1)) : ee("", !0),
                          $(
                            v.$slots,
                            v.$slots[`cell(${String(C.key)})`] ? `cell(${String(C.key)})` : "cell()",
                            {
                              value: n(Ee)(g, String(C.key)),
                              index: S,
                              item: g,
                              field: C,
                              items: v.items,
                              toggleDetails: () => {
                                p(g);
                              },
                              detailsShowing: n(tt)(g) ? r.value.get(g) ?? !1 : !1
                            },
                            () => [
                              !v.$slots[`cell(${String(C.key)})`] && !v.$slots["cell()"] ? (m(), A(ve, { key: 0 }, [
                                ue(J(n(ho)(g, String(C.key), C.formatter)), 1)
                              ], 64)) : ee("", !0)
                            ]
                          )
                        ]),
                        _: 2
                      }, 1040, ["variant", "class"]);
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["class", "variant", "onClick", "onDblclick", "onMouseenter", "onMouseleave"]),
                n(tt)(g) && r.value.get(g) === !0 && v.$slots["row-details"] ? (m(), A(ve, { key: 0 }, [
                  ye(at, {
                    "aria-hidden": "true",
                    role: "presentation",
                    class: "d-none"
                  }),
                  ye(at, {
                    class: R(w(g, "row-details")),
                    variant: g._rowVariant
                  }, {
                    default: I(() => [
                      ye(St, { colspan: d.value }, {
                        default: I(() => [
                          $(v.$slots, "row-details", {
                            item: g,
                            toggleDetails: () => {
                              p(g);
                            },
                            fields: n(l).fields,
                            index: S
                          })
                        ]),
                        _: 2
                      }, 1032, ["colspan"])
                    ]),
                    _: 2
                  }, 1032, ["class", "variant"])
                ], 64)) : ee("", !0)
              ], 64))), 128)),
              n(l).showEmpty && n(l).items.length === 0 ? (m(), P(at, {
                key: 1,
                class: "b-table-empty-slot"
              }, {
                default: I(() => [
                  ye(St, { colspan: d.value }, {
                    default: I(() => [
                      $(v.$slots, "empty", {
                        items: n(l).items
                      }, () => [
                        ue(J(n(l).emptyText), 1)
                      ])
                    ]),
                    _: 3
                  }, 8, ["colspan"])
                ]),
                _: 3
              })) : ee("", !0),
              !n(l).stacked && v.$slots["bottom-row"] ? (m(), P(at, { key: 2 }, {
                default: I(() => [
                  $(v.$slots, "bottom-row")
                ]),
                _: 3
              })) : ee("", !0)
            ])
          ]),
          _: 3
        }, 8, ["class"]),
        n(l).footClone ? (m(), P(Ha, {
          key: 0,
          variant: n(l).footVariant,
          class: R(n(l).tfootClass)
        }, {
          default: I(() => [
            ye(at, {
              variant: n(l).footRowVariant,
              class: R(n(l).tfootTrClass)
            }, {
              default: I(() => [
                (m(!0), A(ve, null, ke(i.value, (g) => (m(), P(Ma, K({
                  key: g.key,
                  scope: "col",
                  class: b(g),
                  title: g.headerTitle,
                  abbr: g.headerAbbr,
                  style: g.thStyle,
                  variant: g.variant,
                  ref_for: !0
                }, g.thAttr, {
                  onClick: (S) => y(g, S, !0)
                }), {
                  default: I(() => [
                    Q("div", Qd, [
                      Q("div", null, [
                        $(
                          v.$slots,
                          v.$slots[`foot(${String(g.key)})`] ? `foot(${String(g.key)})` : "foot()",
                          {
                            label: g.label,
                            column: g.key,
                            field: g,
                            isFoot: !0
                          },
                          () => [
                            ue(J(n(ta)(g)), 1)
                          ]
                        )
                      ])
                    ])
                  ]),
                  _: 2
                }, 1040, ["class", "title", "abbr", "style", "variant", "onClick"]))), 128))
              ]),
              _: 3
            }, 8, ["variant", "class"])
          ]),
          _: 3
        }, 8, ["variant", "class"])) : v.$slots["custom-foot"] ? (m(), P(Ha, { key: 1 }, {
          default: I(() => [
            $(v.$slots, "custom-foot", {
              fields: i.value,
              items: n(l).items,
              columns: i.value.length
            })
          ]),
          _: 3
        })) : ee("", !0),
        v.$slots["table-caption"] || n(l).caption ? (m(), A("caption", ec, [
          $(v.$slots, "table-caption", {}, () => [
            ue(J(n(l).caption), 1)
          ])
        ])) : ee("", !0)
      ]),
      _: 3
    }, 8, ["id", "bordered", "borderless", "border-variant", "caption-top", "dark", "fixed", "hover", "no-border-collapse", "outlined", "responsive", "small", "stacked", "sticky-header", "striped", "table-class", "variant", "striped-columns"]));
  }
}), tc = /* @__PURE__ */ Q("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrow-up-short",
  viewBox: "0 0 16 16",
  "aria-hidden": ""
}, [
  /* @__PURE__ */ Q("path", {
    "fill-rule": "evenodd",
    d: "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
  })
], -1), ac = /* @__PURE__ */ Q("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrow-down-short",
  viewBox: "0 0 16 16",
  "aria-hidden": ""
}, [
  /* @__PURE__ */ Q("path", {
    "fill-rule": "evenodd",
    d: "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
  })
], -1), lc = {
  style: { opacity: 0.4 },
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-arrow-up-short",
  viewBox: "0 0 16 16",
  "aria-hidden": ""
}, oc = /* @__PURE__ */ Q("path", {
  "fill-rule": "evenodd",
  d: "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
}, null, -1), nc = [
  oc
], sc = { class: "d-flex align-items-center gap-2 mt-5" }, rc = /* @__PURE__ */ L({
  __name: "BTable",
  props: /* @__PURE__ */ ge({
    provider: { default: void 0 },
    noProvider: { default: void 0 },
    noProviderPaging: { type: Boolean, default: !1 },
    noProviderSorting: { type: Boolean, default: !1 },
    noProviderFiltering: { type: Boolean, default: !1 },
    sortBy: {},
    mustSort: { type: [Boolean, Array], default: !1 },
    selectable: { type: Boolean, default: !1 },
    multisort: { type: Boolean, default: !1 },
    stickySelect: { type: Boolean, default: !1 },
    selectHead: { type: [Boolean, String], default: !0 },
    selectMode: { default: "multi" },
    selectionVariant: { default: "primary" },
    busy: { type: Boolean },
    busyLoadingText: { default: "Loading..." },
    perPage: { default: Number.POSITIVE_INFINITY },
    currentPage: { default: 1 },
    filter: { default: void 0 },
    filterable: { default: void 0 },
    noLocalSorting: { type: Boolean, default: !1 },
    noSelectOnClick: { type: Boolean, default: !1 },
    selectedItems: {},
    noSortableIcon: { type: Boolean, default: !1 },
    align: { default: void 0 },
    caption: { default: void 0 },
    captionHtml: { default: void 0 },
    detailsTdClass: { default: void 0 },
    emptyFilteredText: { default: void 0 },
    emptyText: { default: void 0 },
    fieldColumnClass: { type: [Function, String, Object, Array], default: void 0 },
    fields: { default: () => [] },
    footClone: { type: Boolean, default: void 0 },
    footRowVariant: { default: void 0 },
    footVariant: { default: void 0 },
    headRowVariant: { default: void 0 },
    headVariant: { default: void 0 },
    items: { default: () => [] },
    labelStacked: { type: Boolean, default: void 0 },
    modelValue: { default: void 0 },
    primaryKey: { default: void 0 },
    showEmpty: { type: Boolean, default: void 0 },
    tbodyClass: { default: void 0 },
    tbodyTrAttrs: {},
    tbodyTrClass: { type: [Function, String, Object, Array], default: void 0 },
    tfootClass: { default: void 0 },
    tfootTrClass: { default: void 0 },
    theadClass: { default: void 0 },
    theadTrClass: { default: void 0 },
    bordered: { type: Boolean, default: void 0 },
    borderless: { type: Boolean, default: void 0 },
    borderVariant: { default: void 0 },
    captionTop: { type: Boolean, default: void 0 },
    dark: { type: Boolean, default: void 0 },
    fixed: { type: Boolean, default: void 0 },
    hover: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    noBorderCollapse: { type: Boolean, default: void 0 },
    outlined: { type: Boolean, default: void 0 },
    responsive: { type: [Boolean, String], default: void 0 },
    small: { type: Boolean, default: void 0 },
    stacked: { type: [Boolean, String], default: void 0 },
    stickyHeader: { type: [Boolean, String, Number], default: void 0 },
    striped: { type: Boolean, default: void 0 },
    stripedColumns: { type: Boolean, default: void 0 },
    variant: { default: void 0 },
    tableAttrs: {}
  }, {
    sortBy: {
      default: void 0
    },
    sortByModifiers: {},
    busy: { type: Boolean, default: !1 },
    busyModifiers: {},
    selectedItems: {
      default: () => []
    },
    selectedItemsModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["filtered", "head-clicked", "row-clicked", "row-dbl-clicked", "row-hovered", "row-unhovered", "row-selected", "row-unselected", "selection", "sorted", "change"], ["update:sortBy", "update:busy", "update:selectedItems"]),
  setup(a, { expose: o, emit: e }) {
    const t = M(a, "BTable"), s = e, r = _e(a, "sortBy"), u = _e(a, "busy"), i = _e(a, "selectedItems"), d = _({
      get: () => /* @__PURE__ */ new Set([...i.value]),
      set: (T) => {
        i.value = [...T];
      }
    }), f = {
      add: (T) => {
        const N = new Set(d.value);
        N.add(T), d.value = N, s("row-selected", T);
      },
      clear: () => {
        d.value.forEach((T) => {
          f.delete(T);
        });
      },
      delete: (T) => {
        const N = new Set(d.value);
        if (t.primaryKey) {
          const F = t.primaryKey;
          i.value.forEach((W, E) => {
            const D = Ee(W, F), te = Ee(T, F);
            D && te && D === te && N.delete(i.value[E]);
          });
        } else
          N.delete(T);
        d.value = N, s("row-unselected", T);
      },
      set: (T) => {
        d.value = new Set(T), d.value.forEach((N) => {
          s("row-unselected", N);
        });
      },
      has: (T) => {
        if (!t.primaryKey)
          return d.value.has(T);
        const N = t.primaryKey;
        for (const F of d.value) {
          const W = Ee(F, N), E = Ee(T, N);
          if (W && E && W === E)
            return !0;
        }
        return !1;
      }
    }, c = z([]), y = he(() => t.perPage, { method: "parseInt" }), p = he(() => t.currentPage, { method: "parseInt" }), b = k(() => !!t.filter), h = k(() => t.provider !== void 0), w = k(() => d.value.size > 0), v = _(
      () => r.value !== void 0 || t.fields.some(
        (T) => typeof T == "object" && T !== null && T.sortable === !0
      )
    ), B = _(
      () => t.fields.map((T) => {
        var W;
        if (!(typeof T == "object" && T !== null))
          return T;
        const N = (W = r.value) == null ? void 0 : W.find((E) => T.key === E.key), F = v.value === !1 ? void 0 : N === void 0 ? "none" : N.order === "desc" ? "descending" : N.order === "asc" ? "ascending" : "none";
        return {
          ...T,
          thAttr: {
            "aria-sort": F,
            ...T.thAttr
          }
        };
      })
    ), g = _(() => ({
      "b-table-busy": u.value,
      "b-table-selectable": t.selectable,
      "user-select-none": t.selectable && w.value
    })), S = _(() => [
      t.tbodyTrClass ? typeof t.tbodyTrClass == "function" ? t.tbodyTrClass(null, "table-busy") : t.tbodyTrClass : null
    ]), C = (T) => [
      {
        "b-table-sortable-column": v.value && T.sortable
      }
    ], x = (T, N) => [
      {
        [`selected table-${t.selectionVariant}`]: t.selectable && T && f.has(T)
      },
      t.tbodyTrClass ? typeof t.tbodyTrClass == "function" ? t.tbodyTrClass(T, N) : t.tbodyTrClass : null
    ], V = _(() => {
      const T = (W) => {
        var D;
        const E = (D = r.value) == null ? void 0 : D.filter((te) => !!te.order);
        return !E || E.length === 0 ? W : [...W].sort((te, re) => {
          for (let U = 0; U < (E.length ?? 0); U++) {
            const ne = E[U], pe = (le) => {
              if (!tt(le))
                return String(le);
              const H = B.value.find((be) => Ht(be) ? be.key === ne.key : !1), se = Ee(le, ne.key);
              if (Ht(H) && H.sortByFormatted) {
                const be = typeof H.sortByFormatted == "function" ? H.sortByFormatted : H.formatter;
                if (be)
                  return ho(le, String(H.key), be);
              }
              return typeof se == "object" && se !== null ? JSON.stringify(se) : (se == null ? void 0 : se.toString()) ?? "";
            }, Y = pe(te), de = pe(re), oe = ne.comparer ? ne.comparer(Y, de) : Y.localeCompare(de, void 0, { numeric: !0 });
            if (oe !== 0)
              return ne.order === "asc" ? oe : -oe;
          }
          return 0;
        });
      }, N = (W) => W.filter(
        (E) => tt(E) ? Object.entries(E).some(([D, te]) => {
          var ne, pe, Y;
          return te == null || D[0] === "_" || !((ne = t.filterable) != null && ne.includes(D)) && ((pe = t.filterable) != null && pe.length) ? !1 : (() => {
            const de = B.value.find((oe) => Ht(oe) ? oe.key === D : !1);
            if (Ht(de) && de.filterByFormatted) {
              const oe = typeof de.filterByFormatted == "function" ? de.filterByFormatted : de.formatter;
              if (oe)
                return oe(te, String(de.key), E);
            }
            return typeof te == "object" ? JSON.stringify(Object.values(te)) : te.toString();
          })().toLowerCase().includes(((Y = t.filter) == null ? void 0 : Y.toLowerCase()) ?? "");
        }) : !0
      );
      let F = h.value ? c.value : t.items;
      return F = F.map((W) => {
        if (typeof W == "object" && W !== null && Object.keys(W).some((E) => E.includes("."))) {
          let E = {};
          for (const D in W)
            D.includes(".") ? E = Nr(E, D, W[D]) : E[D] = W[D];
          return E;
        }
        return W;
      }), (b.value === !0 && !h.value || b.value === !0 && h.value && t.noProviderFiltering) && (F = N(F)), (v.value === !0 && !h.value && !t.noLocalSorting || v.value === !0 && h.value && t.noProviderSorting) && (F = T(F)), F;
    }), q = _(() => Number.isNaN(y.value) || h.value && !t.noProviderPaging ? V.value : V.value.slice(
      (p.value - 1) * (y.value || Number.POSITIVE_INFINITY),
      p.value * (y.value || Number.POSITIVE_INFINITY)
    ));
    fe(q, (T) => {
      s("change", T);
    });
    const G = (T, N, F = !1, W = !1, E = !1) => {
      if (t.selectable) {
        if (t.selectMode === "single" || t.selectMode === "multi") {
          if (F || W)
            return;
          f.has(T) ? f.delete(T) : t.selectMode === "single" ? f.set([T]) : f.add(T);
        } else if (W || E)
          f.has(T) ? f.delete(T) : f.add(T);
        else if (F) {
          const D = [...d.value].pop(), te = t.items.findIndex((pe) => pe === D), re = Math.min(te, N), U = Math.max(te, N), ne = t.items.slice(re, U + 1);
          f.set(ne);
        } else
          f.set([T]);
        X();
      }
    }, O = (T, N, F) => {
      t.noSelectOnClick === !1 && G(T, N, F.shiftKey, F.ctrlKey, F.metaKey), s("row-clicked", T, N, F);
    }, Z = (T) => {
      var ne, pe;
      if (!v.value)
        return;
      const N = typeof T == "object" && T !== null ? T.key : T, F = typeof T == "object" && T !== null ? T.sortable : !1;
      if (!(v.value === !0 && F === !0))
        return;
      const W = (Y) => {
        if (Y === "asc")
          return "desc";
        if (Y === void 0 || t.mustSort === !0 || Array.isArray(t.mustSort) && t.mustSort.includes(N))
          return "asc";
      }, E = ((ne = r.value) == null ? void 0 : ne.findIndex((Y) => Y.key === N)) ?? -1, D = (pe = r.value) == null ? void 0 : pe[E], te = (
        // If value is new, we default to ascending
        // Otherwise we make a temp copy of the value
        E === -1 || !D ? { key: N, order: "asc" } : { ...D }
      ), re = () => {
        var de, oe;
        let Y = te;
        if (E === -1)
          r.value = [...r.value ?? [], te];
        else {
          const le = W(te.order);
          Y = { ...te, order: le }, r.value = le ? (de = r.value) == null ? void 0 : de.map((H) => H.key === Y.key ? Y : H) : (oe = r.value) == null ? void 0 : oe.filter((H) => H.key !== Y.key);
        }
        return Y;
      }, U = () => {
        const Y = {
          ...te,
          order: E === -1 ? te.order : W(te.order)
        };
        return r.value = [Y], Y;
      };
      s("sorted", t.multisort === !0 ? re() : U());
    }, ae = (T, N, F, W = !1) => {
      s("head-clicked", T, N, F, W), Z(N);
    }, ie = async () => {
      if (!h.value || t.provider === void 0 || u.value)
        return;
      u.value = !0;
      const T = t.provider({
        currentPage: p.value,
        filter: t.filter,
        sortBy: r.value,
        perPage: y.value
      });
      try {
        const N = T instanceof Promise ? await T : T;
        if (N === void 0)
          return;
        c.value = N;
      } finally {
        u.value = !1;
      }
    }, X = () => {
      t.selectable && s("selection", [...d.value]);
    }, j = async (T, N, F) => {
      if (N === F)
        return;
      const W = (re) => {
        var U;
        return ((U = t.noProvider) == null ? void 0 : U.includes(re)) === !0;
      }, E = (T === "currentPage" || T === "perPage") && (W("paging") || t.noProviderPaging === !0), D = T === "filter" && (W("filtering") || t.noProviderFiltering === !0), te = (T === "sortBy" || T === "sortDesc") && (W("sorting") || t.noProviderSorting === !0);
      E || D || te || (h.value === !0 && await ie(), T === "currentPage" || T === "perPage" || s("filtered", [...V.value]));
    };
    return fe(
      () => t.filter,
      (T, N) => {
        j("filter", T, N), !(T === N || h.value) && (T || s("filtered", [...V.value]));
      }
    ), fe(p, (T, N) => {
      j("currentPage", T, N);
    }), fe(y, (T, N) => {
      j("perPage", T, N);
    }), fe(
      r,
      (T, N) => {
        j("sortBy", T, N);
      },
      { deep: !0 }
    ), fe(
      () => t.provider,
      (T) => {
        if (T === void 0) {
          c.value = [];
          return;
        }
        ie();
      }
    ), Ue(ie), o({
      // The row selection methods are really for compat. Users should probably use the v-model though
      clearSelected: () => {
        t.selectable && (f.clear(), X());
      },
      refresh: ie,
      selectAllRows: () => {
        if (!t.selectable)
          return;
        const T = d.value.size > 0 ? [...d.value] : [];
        d.value = /* @__PURE__ */ new Set([...V.value]), d.value.forEach((N) => {
          T.includes(N) || s("row-selected", N);
        }), X();
      },
      selectRow: (T) => {
        if (!t.selectable)
          return;
        const N = V.value[T];
        !N || f.has(N) || (f.add(N), X());
      },
      unselectRow: (T) => {
        if (!t.selectable)
          return;
        const N = V.value[T];
        !N || !f.has(N) || (f.delete(N), X());
      }
    }), (T, N) => (m(), P($n, K(n(t), {
      "aria-busy": u.value,
      items: q.value,
      fields: B.value,
      "table-class": g.value,
      "tbody-tr-class": x,
      "field-column-class": C,
      onHeadClicked: ae,
      onRowDblClicked: N[0] || (N[0] = (F, W, E) => {
        s("row-dbl-clicked", F, W, E);
      }),
      onRowClicked: O,
      onRowHovered: N[1] || (N[1] = (F, W, E) => {
        s("row-hovered", F, W, E);
      }),
      onRowUnhovered: N[2] || (N[2] = (F, W, E) => {
        s("row-unhovered", F, W, E);
      })
    }), Da({
      "head()": I((F) => {
        var W, E, D, te;
        return [
          ue(J(n(ta)(F.field)) + " ", 1),
          v.value && F.field.sortable && n(t).noSortableIcon === !1 ? (m(), A(ve, { key: 0 }, [
            ((E = (W = r.value) == null ? void 0 : W.find((re) => re.key === F.field.key)) == null ? void 0 : E.order) === "asc" ? $(
              T.$slots,
              T.$slots[`sortAsc(${String(F.field.key)})`] ? `sortAsc(${String(F.field.key)})` : "sortAsc()",
              Be(K({ key: 0 }, { ...F })),
              () => [
                tc
              ]
            ) : ((te = (D = r.value) == null ? void 0 : D.find((re) => re.key === F.field.key)) == null ? void 0 : te.order) === "desc" ? $(
              T.$slots,
              T.$slots[`sortDesc(${String(F.field.key)})`] ? `sortDesc(${String(F.field.key)})` : "sortDesc()",
              Be(K({ key: 1 }, { ...F })),
              () => [
                ac
              ]
            ) : $(
              T.$slots,
              T.$slots[`sortDefault(${String(F.field.key)})`] ? `sortDefault(${String(F.field.key)})` : "sortDefault()",
              Be(K({ key: 2 }, { ...F })),
              () => [
                (m(), A("svg", lc, nc))
              ]
            )
          ], 64)) : ee("", !0)
        ];
      }),
      "custom-body": I((F) => [
        u.value ? (m(), P(at, {
          key: 0,
          class: R(["b-table-busy-slot", S.value])
        }, {
          default: I(() => [
            ye(St, {
              colspan: F.fields.length
            }, {
              default: I(() => [
                $(T.$slots, "table-busy", {}, () => [
                  ye(_a, { show: "" }, {
                    overlay: I(() => [
                      Q("div", sc, [
                        ye(Ba),
                        Q("strong", null, J(n(t).busyLoadingText), 1)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 2
            }, 1032, ["colspan"])
          ]),
          _: 2
        }, 1032, ["class"])) : ee("", !0)
      ]),
      _: 2
    }, [
      ke(T.$slots, (F, W) => ({
        name: W,
        fn: I((E) => [
          $(T.$slots, W, Be(Ce(E)))
        ])
      }))
    ]), 1040, ["aria-busy", "items", "fields", "table-class"]));
  }
}), ic = /* @__PURE__ */ L({
  inheritAttrs: !1,
  __name: "BTab",
  props: /* @__PURE__ */ ge({
    active: { type: Boolean },
    buttonId: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    lazy: { type: Boolean, default: void 0 },
    lazyOnce: { type: Boolean, default: void 0 },
    noBody: { type: Boolean, default: !1 },
    tag: { default: "div" },
    title: { default: void 0 },
    titleItemClass: { default: void 0 },
    titleLinkAttrs: { default: void 0 },
    titleLinkClass: { default: void 0 }
  }, {
    active: { type: Boolean, default: !1 },
    activeModifiers: {}
  }),
  emits: ["update:active"],
  setup(a) {
    const e = M(a, "BTab"), l = He(), t = _e(a, "active"), s = Ve(Co, null), r = we(() => e.id, "tabpane"), u = we(() => e.buttonId, "tab"), i = z(!1), d = z(null), { onClick: f, ...c } = Dt(), y = _(
      () => ({
        id: r.value,
        buttonId: u.value,
        disabled: e.disabled,
        title: e.title,
        titleComponent: l.title,
        titleItemClass: e.titleItemClass,
        titleLinkAttrs: e.titleLinkAttrs,
        titleLinkClass: e.titleLinkClass,
        onClick: f,
        el: d.value
      })
    );
    Ue(() => {
      s && (s.registerTab(y), e.active && s.activateTab(r.value));
    }), zn(() => {
      s && s.unregisterTab(r.value);
    });
    const p = k(() => (s == null ? void 0 : s.activeId.value) === r.value), b = z(p.value), h = k(() => !!(s != null && s.lazy.value || (e.lazyOnce ?? e.lazy))), w = k(() => e.lazyOnce !== void 0), v = k(() => p.value && !e.disabled), B = k(
      () => v.value || !h.value || h.value && w.value && i.value
    );
    fe(p, (S) => {
      if (S) {
        t.value = !0, setTimeout(() => {
          b.value = !0;
        }, 0);
        return;
      }
      b.value = !1, t.value = !1;
    }), fe(
      () => e.active,
      (S) => {
        if (s) {
          if (!S) {
            p.value && s.activateTab(void 0);
            return;
          }
          s.activateTab(r.value);
        }
      }
    );
    const g = _(() => [
      {
        active: p.value,
        show: b.value,
        "card-body": (s == null ? void 0 : s.card.value) && e.noBody === !1,
        fade: !(s != null && s.noFade.value)
      },
      b.value ? s == null ? void 0 : s.activeTabClass : s == null ? void 0 : s.inactiveTabClass,
      s == null ? void 0 : s.tabClass
    ]);
    return fe(B, (S) => {
      S && !i.value && (i.value = !0);
    }), (S, C) => (m(), P(ce(n(e).tag), K({
      id: n(r),
      ref_key: "el",
      ref: d,
      class: ["tab-pane", g.value],
      role: "tabpanel",
      "aria-labelledby": n(u)
    }, c), {
      default: I(() => [
        B.value ? $(S.$slots, "default", { key: 0 }) : ee("", !0)
      ]),
      _: 3
    }, 16, ["id", "class", "aria-labelledby"]));
  }
}), uc = ["aria-orientation"], dc = ["id", "aria-controls", "aria-selected", "onClick"], cc = /* @__PURE__ */ L({
  __name: "BTabs",
  props: /* @__PURE__ */ ge({
    activeId: {},
    activeNavItemClass: { default: void 0 },
    activeTabClass: { default: void 0 },
    align: { default: void 0 },
    card: { type: Boolean, default: !1 },
    contentClass: { default: void 0 },
    end: { type: Boolean, default: !1 },
    fill: { type: Boolean, default: !1 },
    id: { default: void 0 },
    inactiveNavItemClass: { default: void 0 },
    inactiveTabClass: { default: void 0 },
    justified: { type: Boolean, default: !1 },
    lazy: { type: Boolean, default: !1 },
    modelValue: {},
    navClass: { default: void 0 },
    navItemClass: { default: void 0 },
    navWrapperClass: { default: void 0 },
    noFade: { type: Boolean, default: !1 },
    noNavStyle: { type: Boolean, default: !1 },
    pills: { type: Boolean, default: !1 },
    small: { type: Boolean, default: !1 },
    tag: { default: "div" },
    tabClass: { default: void 0 },
    vertical: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      default: -1
    },
    modelModifiers: {},
    activeId: {
      default: void 0
    },
    activeIdModifiers: {}
  }),
  emits: /* @__PURE__ */ ge(["activate-tab", "click"], ["update:modelValue", "update:activeId"]),
  setup(a, { emit: o }) {
    const l = M(a, "BTabs"), t = o, s = _e(a, "modelValue"), r = _e(a, "activeId"), u = ua(), i = z([]), d = _(
      () => i.value.map((C) => {
        const x = n(C), V = x.id === r.value;
        return {
          ...x,
          active: V,
          navItemClasses: [
            {
              active: V,
              disabled: x.disabled
            },
            V ? l.activeNavItemClass : l.inactiveNavItemClass,
            l.navItemClass,
            x.titleLinkClass
          ]
        };
      })
    ), f = k(() => !(d != null && d.value && d.value.length > 0)), c = _(() => ({
      "d-flex": l.vertical,
      "align-items-start": l.vertical
    })), y = Gt(() => l.align), p = _(() => ({
      "nav-pills": l.pills,
      "flex-column me-3": l.vertical,
      [y.value]: l.align !== void 0,
      "nav-fill": l.fill,
      "card-header-tabs": l.card,
      "nav-justified": l.justified,
      "nav-tabs": !l.noNavStyle && !l.pills,
      small: l.small
    })), b = (C) => {
      var x;
      if (C !== void 0) {
        const V = (x = d.value[C]) == null ? void 0 : x.id;
        if (C > -1 && C < d.value.length && !d.value[C].disabled && (s.value < 0 || r.value !== V || s.value !== C)) {
          const q = new rt("activate-tab", { cancelable: !0 });
          t("activate-tab", C, s.value, q), q.defaultPrevented || (r.value !== V && (r.value = V), s.value !== C && (s.value = C));
        }
      }
    }, h = (C, x) => {
      var V, q, G;
      b(x), x >= 0 && !d.value[x].disabled && ((V = d.value[x]) != null && V.onClick) && typeof d.value[x].onClick == "function" && ((G = (q = d.value[x]).onClick) == null || G.call(q, C));
    }, w = (C) => {
      var x, V;
      d.value.length <= 0 || (s.value = v(s.value + C, C), (V = document.getElementById((x = d.value[s.value]) == null ? void 0 : x.buttonId)) == null || V.focus());
    }, v = (C, x) => {
      let V = C, q = -1, G = -1;
      for (let O = 0; O < d.value.length; O++)
        d.value[O].disabled || (q === -1 && (q = O), G = O);
      for (; V >= q && V <= G && d.value[V].disabled; )
        V += x;
      return V < q && (V = q), V > G && (V = G), V;
    };
    fe(s, (C, x) => {
      if (C === x || d.value.length <= 0)
        return;
      const V = v(C, C > x ? 1 : -1);
      Ne(() => {
        b(V);
      });
    }), fe(r, (C, x) => {
      const V = d.value.findIndex((q) => q.id === C);
      if (C !== x && !(d.value.length <= 0)) {
        if (V === -1) {
          b(v(0, 1));
          return;
        }
        b(V);
      }
    });
    const B = (C) => {
      i.value.find((x) => x.value.id === C.value.id) ? i.value[i.value.findIndex((x) => x.value.id === C.value.id)] = C : i.value.push(C), i.value.sort((x, V) => {
        if (!Node || !x.value.el || !V.value.el)
          return 0;
        const q = x.value.el.compareDocumentPosition(V.value.el);
        return q & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : q & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
      });
    }, g = (C) => {
      i.value = i.value.filter((x) => x.value.id !== C);
    };
    fe(
      i,
      () => {
        S();
      },
      { deep: !0 }
    );
    const S = () => {
      var C;
      if (d.value.length === 0) {
        s.value = -1, r.value = void 0;
        return;
      }
      if (s.value >= 0 && !r.value && (r.value = (C = d.value[s.value]) == null ? void 0 : C.id), d.value.find((x) => x.id === r.value)) {
        b(d.value.findIndex((x) => x.id === r.value));
        return;
      }
      b(d.value.map((x) => !x.disabled).indexOf(!0));
    };
    return Xe(Co, {
      lazy: k(() => l.lazy),
      card: k(() => l.card),
      noFade: k(() => l.noFade),
      activeTabClass: k(() => l.activeTabClass),
      inactiveTabClass: k(() => l.inactiveTabClass),
      tabClass: k(() => l.tabClass),
      registerTab: B,
      unregisterTab: g,
      activeId: r,
      activateTab: (C) => {
        const x = d.value.findIndex((V) => V.id === C);
        if (C === void 0 || x === -1) {
          b(v(0, 1));
          return;
        }
        b(x);
      }
    }), (C, x) => (m(), P(ce(n(l).tag), {
      id: n(l).id,
      class: R(["tabs", c.value])
    }, {
      default: I(() => [
        ye(n(u).define, null, {
          default: I(() => [
            Q("div", {
              class: R(["tab-content", n(l).contentClass])
            }, [
              $(C.$slots, "default"),
              f.value ? (m(), A("div", {
                key: "bv-empty-tab",
                class: R(["tab-pane active", { "card-body": n(l).card }])
              }, [
                $(C.$slots, "empty")
              ], 2)) : ee("", !0)
            ], 2)
          ]),
          _: 3
        }),
        n(l).end ? (m(), P(n(u).reuse, { key: 0 })) : ee("", !0),
        Q("div", {
          class: R([
            n(l).navWrapperClass,
            { "card-header": n(l).card, "ms-auto": C.vertical && n(l).end }
          ])
        }, [
          Q("ul", {
            class: R(["nav", [p.value, n(l).navClass]]),
            role: "tablist",
            "aria-orientation": n(l).vertical ? "vertical" : "horizontal"
          }, [
            $(C.$slots, "tabs-start"),
            (m(!0), A(ve, null, ke(d.value, (V, q) => (m(), A("li", {
              key: V.id,
              class: R(["nav-item", V.titleItemClass]),
              role: "presentation"
            }, [
              Q("button", K({
                id: V.buttonId,
                class: ["nav-link", V.navItemClasses],
                role: "tab",
                "aria-controls": V.id,
                "aria-selected": V.active,
                ref_for: !0
              }, V.titleLinkAttrs, {
                onKeydown: [
                  x[0] || (x[0] = Ut(vt((G) => w(-1), ["stop", "prevent"]), ["left"])),
                  x[1] || (x[1] = Ut(vt((G) => w(1), ["stop", "prevent"]), ["right"])),
                  x[2] || (x[2] = Ut(vt((G) => w(-999), ["stop", "prevent"]), ["page-up"])),
                  x[3] || (x[3] = Ut(vt((G) => w(999), ["stop", "prevent"]), ["page-down"]))
                ],
                onClick: vt((G) => h(G, q), ["stop", "prevent"])
              }), [
                V.titleComponent ? (m(), P(ce(V.titleComponent), { key: 0 })) : (m(), A(ve, { key: 1 }, [
                  ue(J(V.title), 1)
                ], 64))
              ], 16, dc)
            ], 2))), 128)),
            $(C.$slots, "tabs-end")
          ], 10, uc)
        ], 2),
        n(l).end ? ee("", !0) : (m(), P(n(u).reuse, { key: 1 }))
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), fc = { id: "__BVID__toaster-container" }, pc = /* @__PURE__ */ L({
  __name: "BToastOrchestrator",
  props: {
    appendToast: { type: Boolean, default: !1 },
    teleportDisabled: { default: !1 },
    teleportTo: { default: "body" }
  },
  setup(a, { expose: o }) {
    const l = M(a, "BToastOrchestrator"), t = {
      "top-left": "top-0 start-0",
      "top-center": "top-0 start-50 translate-middle-x",
      "top-right": "top-0 end-0",
      "middle-left": "top-50 start-0 translate-middle-y",
      "middle-center": "top-50 start-50 translate-middle",
      "middle-right": "top-50 end-0 translate-middle-y",
      "bottom-left": "bottom-0 start-0",
      "bottom-center": "bottom-0 start-50 translate-middle-x",
      "bottom-right": "bottom-0 end-0"
    }, { remove: s, toasts: r, show: u, _setIsAppend: i } = Jo();
    fe(
      () => l.appendToast,
      (f) => {
        i == null || i(f);
      },
      { immediate: !0 }
    );
    const d = (f) => ha(f, ["_modelValue", "_self", "pos"]);
    return o({
      remove: s,
      show: u,
      toasts: r
    }), (f, c) => (m(), P(_t, {
      to: n(l).teleportTo,
      disabled: n(l).teleportDisabled
    }, [
      Q("div", fc, [
        (m(), A(ve, null, ke(t, (y, p) => Q("div", {
          key: p,
          class: R([y, "toast-container position-fixed p-3"])
        }, [
          ye(Gl, { name: "b-list" }, {
            default: I(() => {
              var b;
              return [
                (m(!0), A(ve, null, ke((b = n(r)) == null ? void 0 : b.filter((h) => h.value.props.pos === p), (h) => (m(), P(ce(h.value.component), K({
                  key: h.value.props._self,
                  ref_for: !0
                }, d(h.value.props), {
                  modelValue: h.value.props._modelValue,
                  "onUpdate:modelValue": (w) => h.value.props._modelValue = w,
                  "trans-props": { ...h.value.props.transProps, appear: !0 },
                  onHide: vt((w) => {
                    var v;
                    return (v = n(s)) == null ? void 0 : v(h.value.props._self);
                  }, ["prevent"])
                }), null, 16, ["modelValue", "onUpdate:modelValue", "trans-props", "onHide"]))), 128))
              ];
            }),
            _: 2
          }, 1024)
        ], 2)), 64))
      ])
    ], 8, ["to", "disabled"]));
  }
}), vc = /* @__PURE__ */ L({
  __name: "BTooltip",
  props: /* @__PURE__ */ ge({
    interactive: { type: Boolean, default: void 0 },
    boundary: {},
    boundaryPadding: {},
    click: { type: Boolean, default: void 0 },
    content: { default: void 0 },
    customClass: { default: void 0 },
    delay: { default: void 0 },
    floatingMiddleware: { default: void 0 },
    html: { type: Boolean, default: void 0 },
    id: { default: void 0 },
    inline: { type: Boolean, default: void 0 },
    manual: { type: Boolean, default: void 0 },
    modelValue: { type: Boolean },
    noAutoClose: { type: Boolean, default: void 0 },
    noFade: { type: Boolean, default: void 0 },
    noFlip: { type: Boolean, default: void 0 },
    noHide: { type: Boolean, default: void 0 },
    noShift: { type: Boolean, default: void 0 },
    noSize: { type: Boolean },
    noninteractive: { type: Boolean, default: void 0 },
    offset: { default: void 0 },
    placement: { default: void 0 },
    persistent: { type: Boolean },
    realtime: { type: Boolean, default: void 0 },
    reference: { default: void 0 },
    strategy: { default: void 0 },
    target: { default: void 0 },
    title: { default: void 0 },
    variant: { default: void 0 },
    teleportDisabled: { default: void 0 },
    teleportTo: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a, { expose: o }) {
    var u, i, d;
    const l = M(a, "BTooltip"), t = _e(a, "modelValue"), s = _(() => {
      const { interactive: f, noninteractive: c, ...y } = l;
      return { noninteractive: c !== void 0 ? c : !f, ...y };
    }), r = z(null);
    return o({
      hide: (u = r.value) == null ? void 0 : u.hide,
      show: (i = r.value) == null ? void 0 : i.show,
      toggle: (d = r.value) == null ? void 0 : d.toggle
    }), (f, c) => (m(), P(el, K({
      ref_key: "popover",
      ref: r
    }, s.value, {
      modelValue: t.value,
      "onUpdate:modelValue": c[0] || (c[0] = (y) => t.value = y),
      tooltip: ""
    }), Da({ _: 2 }, [
      ke(f.$slots, (y, p) => ({
        name: p,
        fn: I((b) => [
          $(f.$slots, p, Be(Ce(b)))
        ])
      }))
    ]), 1040, ["modelValue"]));
  }
}), oa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAccordion: ii,
  BAccordionItem: di,
  BAlert: fi,
  BAvatar: bi,
  BAvatarGroup: yi,
  BBadge: on,
  BBreadcrumb: Bi,
  BBreadcrumbItem: nn,
  BButton: mt,
  BButtonGroup: _i,
  BButtonToolbar: Ci,
  BCard: pn,
  BCardBody: cn,
  BCardFooter: fn,
  BCardGroup: $i,
  BCardHeader: rn,
  BCardImg: rl,
  BCardSubtitle: dn,
  BCardText: xi,
  BCardTitle: un,
  BCarousel: Ei,
  BCarouselSlide: Mi,
  BCloseButton: Ft,
  BCol: zt,
  BCollapse: ln,
  BContainer: Ri,
  BDropdown: vn,
  BDropdownDivider: Wi,
  BDropdownForm: Ui,
  BDropdownGroup: Yi,
  BDropdownHeader: Ji,
  BDropdownItem: Qi,
  BDropdownItemButton: au,
  BDropdownText: ou,
  BForm: mn,
  BFormCheckbox: bn,
  BFormCheckboxGroup: pu,
  BFormFile: bu,
  BFormFloatingLabel: iu,
  BFormGroup: ku,
  BFormInput: Ol,
  BFormInvalidFeedback: Na,
  BFormRadio: gn,
  BFormRadioGroup: Au,
  BFormRow: la,
  BFormSelect: Fu,
  BFormSelectOption: il,
  BFormSelectOptionGroup: hn,
  BFormSpinbutton: Mu,
  BFormTag: Bn,
  BFormTags: td,
  BFormText: Ea,
  BFormTextarea: ld,
  BFormValidFeedback: Fa,
  BImg: sl,
  BInput: Ol,
  BInputGroup: dd,
  BInputGroupAddon: ul,
  BInputGroupAppend: cd,
  BInputGroupPrepend: fd,
  BInputGroupText: _n,
  BLink: st,
  BListGroup: pd,
  BListGroupItem: vd,
  BModal: Pa,
  BModalOrchestrator: bd,
  BNav: yd,
  BNavForm: hd,
  BNavItem: _d,
  BNavItemDropdown: Cd,
  BNavText: Td,
  BNavbar: $d,
  BNavbarBrand: xd,
  BNavbarNav: Sd,
  BNavbarToggle: Ld,
  BOffcanvas: Md,
  BOverlay: _a,
  BPagination: Dd,
  BPlaceholder: Ke,
  BPlaceholderButton: Cn,
  BPlaceholderCard: jd,
  BPlaceholderTable: Wd,
  BPlaceholderWrapper: qd,
  BPopover: el,
  BProgress: en,
  BProgressBar: Qo,
  BRow: Ud,
  BSpinner: Ba,
  BTab: ic,
  BTable: rc,
  BTableLite: $n,
  BTableSimple: dl,
  BTabs: cc,
  BTbody: kn,
  BTd: St,
  BTfoot: Ha,
  BTh: Ma,
  BThead: Tn,
  BToast: tn,
  BToastOrchestrator: pc,
  BTooltip: vc,
  BTr: at,
  BTransition: Et
}, Symbol.toStringTag, { value: "Module" })), yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useBreadcrumb: zo,
  useColorMode: Er,
  useModal: jr,
  useModalController: Ko,
  useScrollspy: Zo,
  useToast: Jo
}, Symbol.toStringTag, { value: "Module" })), gc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BvCarouselEvent: Wl,
  BvEvent: rt,
  BvTriggerableEvent: wt
}, Symbol.toStringTag, { value: "Module" })), hc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), xn = (a) => a.toLowerCase().startsWith("v") ? a.slice(1) : a, Bc = ({
  components: a = !1,
  directives: o = !1,
  plugins: e = {},
  aliases: l = {}
} = {}) => ({
  install(t) {
    const s = typeof a == "boolean" ? { all: a } : a, r = Object.keys(oa);
    va(s, r).forEach((d) => {
      const f = oa[d];
      t.component(d, f);
    });
    const u = typeof o == "boolean" ? { all: o } : o, i = Object.keys(za);
    va(u, i).forEach((d) => {
      const f = xn(d), c = za[d];
      t.directive(f, c);
    }), Object.entries(l).forEach(([d, f]) => {
      const c = typeof f == "string" ? oa[f] : f;
      t.component(d, c);
    }), ((e == null ? void 0 : e.breadcrumb) ?? !0) && t.use(Zr), (((e == null ? void 0 : e.id) ?? !0) || typeof e.id == "object") && t.use(Jr, e), ((e == null ? void 0 : e.modalController) ?? !0) && t.use(li), ((e == null ? void 0 : e.modalManager) ?? !0) && t.use(oi), (((e == null ? void 0 : e.rtl) ?? !0) || typeof e.rtl == "object") && t.use(ni, e), ((e == null ? void 0 : e.toast) ?? !0) && t.use(Yr), t.use(si, e);
  }
}), _c = ({
  aliases: a = {},
  directives: o = !0,
  components: e = !0
} = {}) => {
  const l = typeof e == "boolean" ? { all: e } : e, t = Object.keys(oa), s = va(l, t), r = [
    {
      type: "component",
      resolve: (f) => {
        if (s.includes(f) || a[f])
          return {
            name: a[f] || f,
            from: "bootstrap-vue-next"
          };
      }
    }
  ], u = typeof o == "boolean" ? { all: o } : o, i = Object.keys(za), d = va(u, i).map(xn);
  return d.length > 0 && r.push({
    type: "directive",
    resolve: (f) => {
      if (d.includes(f))
        return {
          name: `v${f}`,
          from: "bootstrap-vue-next"
        };
    }
  }), r;
};
export {
  ii as BAccordion,
  di as BAccordionItem,
  fi as BAlert,
  bi as BAvatar,
  yi as BAvatarGroup,
  on as BBadge,
  Bi as BBreadcrumb,
  nn as BBreadcrumbItem,
  mt as BButton,
  _i as BButtonGroup,
  Ci as BButtonToolbar,
  pn as BCard,
  cn as BCardBody,
  fn as BCardFooter,
  $i as BCardGroup,
  rn as BCardHeader,
  rl as BCardImg,
  dn as BCardSubtitle,
  xi as BCardText,
  un as BCardTitle,
  Ei as BCarousel,
  Mi as BCarouselSlide,
  Ft as BCloseButton,
  zt as BCol,
  ln as BCollapse,
  Ri as BContainer,
  vn as BDropdown,
  Wi as BDropdownDivider,
  Ui as BDropdownForm,
  Yi as BDropdownGroup,
  Ji as BDropdownHeader,
  Qi as BDropdownItem,
  au as BDropdownItemButton,
  ou as BDropdownText,
  mn as BForm,
  bn as BFormCheckbox,
  pu as BFormCheckboxGroup,
  bu as BFormFile,
  iu as BFormFloatingLabel,
  ku as BFormGroup,
  Ol as BFormInput,
  Na as BFormInvalidFeedback,
  gn as BFormRadio,
  Au as BFormRadioGroup,
  la as BFormRow,
  Fu as BFormSelect,
  il as BFormSelectOption,
  hn as BFormSelectOptionGroup,
  Mu as BFormSpinbutton,
  Bn as BFormTag,
  td as BFormTags,
  Ea as BFormText,
  ld as BFormTextarea,
  Fa as BFormValidFeedback,
  sl as BImg,
  Ol as BInput,
  dd as BInputGroup,
  ul as BInputGroupAddon,
  cd as BInputGroupAppend,
  fd as BInputGroupPrepend,
  _n as BInputGroupText,
  st as BLink,
  pd as BListGroup,
  vd as BListGroupItem,
  Pa as BModal,
  bd as BModalOrchestrator,
  yd as BNav,
  hd as BNavForm,
  _d as BNavItem,
  Cd as BNavItemDropdown,
  Td as BNavText,
  $d as BNavbar,
  xd as BNavbarBrand,
  Sd as BNavbarNav,
  Ld as BNavbarToggle,
  Md as BOffcanvas,
  _a as BOverlay,
  Dd as BPagination,
  Ke as BPlaceholder,
  Cn as BPlaceholderButton,
  jd as BPlaceholderCard,
  Wd as BPlaceholderTable,
  qd as BPlaceholderWrapper,
  el as BPopover,
  en as BProgress,
  Qo as BProgressBar,
  Ud as BRow,
  Ba as BSpinner,
  ic as BTab,
  rc as BTable,
  $n as BTableLite,
  dl as BTableSimple,
  cc as BTabs,
  kn as BTbody,
  St as BTd,
  Ha as BTfoot,
  Ma as BTh,
  Tn as BThead,
  tn as BToast,
  pc as BToastOrchestrator,
  vc as BTooltip,
  at as BTr,
  Et as BTransition,
  _c as BootstrapVueNextResolver,
  Wl as BvCarouselEvent,
  rt as BvEvent,
  wt as BvTriggerableEvent,
  oa as Components,
  yc as Composables,
  za as Directives,
  hc as Types,
  gc as Utils,
  Bc as createBootstrap,
  Bc as default,
  zo as useBreadcrumb,
  Er as useColorMode,
  jr as useModal,
  Ko as useModalController,
  Zo as useScrollspy,
  Jo as useToast,
  Vd as vBColorMode,
  La as vBModal,
  Id as vBPopover,
  Pd as vBScrollspy,
  La as vBToggle,
  Nd as vBTooltip
};
//# sourceMappingURL=bootstrap-vue-next.mjs.map
